import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: number; output: number; }
  DateTime: { input: Date; output: Date; }
  Decimal: { input: any; output: any; }
};

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput';
  count: Scalars['Int']['output'];
};

export type AggregateAnnounce = {
  __typename?: 'AggregateAnnounce';
  _avg?: Maybe<AnnounceAvgAggregate>;
  _count?: Maybe<AnnounceCountAggregate>;
  _max?: Maybe<AnnounceMaxAggregate>;
  _min?: Maybe<AnnounceMinAggregate>;
  _sum?: Maybe<AnnounceSumAggregate>;
};

export type AggregateCartItem = {
  __typename?: 'AggregateCartItem';
  _avg?: Maybe<CartItemAvgAggregate>;
  _count?: Maybe<CartItemCountAggregate>;
  _max?: Maybe<CartItemMaxAggregate>;
  _min?: Maybe<CartItemMinAggregate>;
  _sum?: Maybe<CartItemSumAggregate>;
};

export type AggregateCustomer = {
  __typename?: 'AggregateCustomer';
  _avg?: Maybe<CustomerAvgAggregate>;
  _count?: Maybe<CustomerCountAggregate>;
  _max?: Maybe<CustomerMaxAggregate>;
  _min?: Maybe<CustomerMinAggregate>;
  _sum?: Maybe<CustomerSumAggregate>;
};

export type AggregateItem = {
  __typename?: 'AggregateItem';
  _avg?: Maybe<ItemAvgAggregate>;
  _count?: Maybe<ItemCountAggregate>;
  _max?: Maybe<ItemMaxAggregate>;
  _min?: Maybe<ItemMinAggregate>;
  _sum?: Maybe<ItemSumAggregate>;
};

export type AggregateOrder = {
  __typename?: 'AggregateOrder';
  _avg?: Maybe<OrderAvgAggregate>;
  _count?: Maybe<OrderCountAggregate>;
  _max?: Maybe<OrderMaxAggregate>;
  _min?: Maybe<OrderMinAggregate>;
  _sum?: Maybe<OrderSumAggregate>;
};

export type AggregateOrderRequest = {
  __typename?: 'AggregateOrderRequest';
  _avg?: Maybe<OrderRequestAvgAggregate>;
  _count?: Maybe<OrderRequestCountAggregate>;
  _max?: Maybe<OrderRequestMaxAggregate>;
  _min?: Maybe<OrderRequestMinAggregate>;
  _sum?: Maybe<OrderRequestSumAggregate>;
};

export type AggregateStockItem = {
  __typename?: 'AggregateStockItem';
  _avg?: Maybe<StockItemAvgAggregate>;
  _count?: Maybe<StockItemCountAggregate>;
  _max?: Maybe<StockItemMaxAggregate>;
  _min?: Maybe<StockItemMinAggregate>;
  _sum?: Maybe<StockItemSumAggregate>;
};

export type AggregateWishlistItem = {
  __typename?: 'AggregateWishlistItem';
  _avg?: Maybe<WishlistItemAvgAggregate>;
  _count?: Maybe<WishlistItemCountAggregate>;
  _max?: Maybe<WishlistItemMaxAggregate>;
  _min?: Maybe<WishlistItemMinAggregate>;
  _sum?: Maybe<WishlistItemSumAggregate>;
};

/**
 *
 * アナウンス
 */
export type Announce = {
  __typename?: 'Announce';
  /** メッセージ区分（連携） */
  announceCd: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** 公開終了日時（連携） */
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** アナウンスID */
  id: Scalars['Int']['output'];
  /** メッセージ（連携） */
  message: Scalars['String']['output'];
  /** 公開開始日時（連携） */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** タイトル（連携？） */
  title?: Maybe<Scalars['String']['output']>;
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type AnnounceAvgAggregate = {
  __typename?: 'AnnounceAvgAggregate';
  announceCd?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

export type AnnounceCountAggregate = {
  __typename?: 'AnnounceCountAggregate';
  _all: Scalars['Int']['output'];
  announceCd: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  disabledAt: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['Int']['output'];
  publishedAt: Scalars['Int']['output'];
  title: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
};

export type AnnounceCreateInput = {
  announceCd: Scalars['Int']['input'];
  disabledAt?: InputMaybe<Scalars['DateTime']['input']>;
  id: Scalars['Int']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type AnnounceMaxAggregate = {
  __typename?: 'AnnounceMaxAggregate';
  announceCd?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type AnnounceMinAggregate = {
  __typename?: 'AnnounceMinAggregate';
  announceCd?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type AnnounceOrderByWithRelationInput = {
  announceCd?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  disabledAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  message?: InputMaybe<SortOrder>;
  publishedAt?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
};

export enum AnnounceScalarFieldEnum {
  AnnounceCd = 'announceCd',
  CreatedAt = 'createdAt',
  DisabledAt = 'disabledAt',
  Id = 'id',
  Message = 'message',
  PublishedAt = 'publishedAt',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type AnnounceSumAggregate = {
  __typename?: 'AnnounceSumAggregate';
  announceCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type AnnounceUpdateInput = {
  announceCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  disabledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnnounceUpdateManyMutationInput = {
  announceCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  disabledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<IntFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
  publishedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type AnnounceWhereInput = {
  AND?: InputMaybe<Array<AnnounceWhereInput>>;
  NOT?: InputMaybe<Array<AnnounceWhereInput>>;
  OR?: InputMaybe<Array<AnnounceWhereInput>>;
  announceCd?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  disabledAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<IntFilter>;
  message?: InputMaybe<StringFilter>;
  publishedAt?: InputMaybe<DateTimeNullableFilter>;
  title?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type AnnounceWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/**
 *
 * 請求先 → 現時点で未使用
 */
export type BillingAddress = {
  __typename?: 'BillingAddress';
  /** 住所 */
  address: Scalars['String']['output'];
  /** 担当者名 */
  chargeName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** 請求先ID */
  id: Scalars['Int']['output'];
  /** 請求先名 */
  name: Scalars['String']['output'];
  /** 請求先名カナ */
  nameKana?: Maybe<Scalars['String']['output']>;
  /** 電話番号 */
  phoneNumber: Scalars['String']['output'];
  /** 郵便番号 */
  postalCode: Scalars['String']['output'];
  /** 都道府県 */
  prefecture: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type BillingAddressCreateInput = {
  address: Scalars['String']['input'];
  chargeName: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutBillingAddressInput;
  name: Scalars['String']['input'];
  nameKana?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type BillingAddressCreateManyCustomerInput = {
  address: Scalars['String']['input'];
  chargeName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  nameKana?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type BillingAddressCreateManyCustomerInputEnvelope = {
  data: Array<BillingAddressCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BillingAddressCreateOrConnectWithoutCustomerInput = {
  create: BillingAddressCreateWithoutCustomerInput;
  where: BillingAddressWhereUniqueInput;
};

export type BillingAddressCreateWithoutCustomerInput = {
  address: Scalars['String']['input'];
  chargeName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameKana?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type BillingAddressListRelationFilter = {
  every?: InputMaybe<BillingAddressWhereInput>;
  none?: InputMaybe<BillingAddressWhereInput>;
  some?: InputMaybe<BillingAddressWhereInput>;
};

export type BillingAddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type BillingAddressOrderByWithRelationInput = {
  address?: InputMaybe<SortOrder>;
  chargeName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameKana?: InputMaybe<SortOrderInput>;
  phoneNumber?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  prefecture?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum BillingAddressScalarFieldEnum {
  Address = 'address',
  ChargeName = 'chargeName',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  Name = 'name',
  NameKana = 'nameKana',
  PhoneNumber = 'phoneNumber',
  PostalCode = 'postalCode',
  Prefecture = 'prefecture',
  UpdatedAt = 'updatedAt'
}

export type BillingAddressScalarWhereInput = {
  AND?: InputMaybe<Array<BillingAddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<BillingAddressScalarWhereInput>>;
  OR?: InputMaybe<Array<BillingAddressScalarWhereInput>>;
  address?: InputMaybe<StringFilter>;
  chargeName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nameKana?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  prefecture?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type BillingAddressUpdateInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  chargeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  prefecture?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BillingAddressUpdateManyMutationInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  chargeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  prefecture?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BillingAddressUpdateManyWithWhereWithoutCustomerInput = {
  data: BillingAddressUpdateManyMutationInput;
  where: BillingAddressScalarWhereInput;
};

export type BillingAddressUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<BillingAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<BillingAddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<BillingAddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<BillingAddressCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<BillingAddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<BillingAddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<BillingAddressWhereUniqueInput>>;
  set?: InputMaybe<Array<BillingAddressWhereUniqueInput>>;
  update?: InputMaybe<Array<BillingAddressUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<BillingAddressUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<BillingAddressUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type BillingAddressUpdateWithWhereUniqueWithoutCustomerInput = {
  data: BillingAddressUpdateWithoutCustomerInput;
  where: BillingAddressWhereUniqueInput;
};

export type BillingAddressUpdateWithoutCustomerInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  chargeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  prefecture?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type BillingAddressUpsertWithWhereUniqueWithoutCustomerInput = {
  create: BillingAddressCreateWithoutCustomerInput;
  update: BillingAddressUpdateWithoutCustomerInput;
  where: BillingAddressWhereUniqueInput;
};

export type BillingAddressWhereInput = {
  AND?: InputMaybe<Array<BillingAddressWhereInput>>;
  NOT?: InputMaybe<Array<BillingAddressWhereInput>>;
  OR?: InputMaybe<Array<BillingAddressWhereInput>>;
  address?: InputMaybe<StringFilter>;
  chargeName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nameKana?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  prefecture?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type BillingAddressWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

/**
 *
 * カート内商品
 */
export type CartItem = {
  __typename?: 'CartItem';
  /** 税抜金額 */
  amount: Scalars['Decimal']['output'];
  /** 商品在庫単価 - 原価（カート追加時） */
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース掛率（カート追加時） */
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱掛率（カート追加時） */
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - バラ掛率（カート追加時） */
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** 得意先備考（QA No.64） */
  customerNote?: Maybe<Scalars['String']['output']>;
  /** 得意先注文番号 */
  customerOrderNo?: Maybe<Scalars['String']['output']>;
  /** 径（連携） */
  diameter: Scalars['String']['output'];
  /** 径CD（連携） */
  diameterCd: Scalars['Int']['output'];
  /** カート内商品ID */
  id: Scalars['Int']['output'];
  /** 商品CD */
  itemCd: Scalars['BigInt']['output'];
  /** 長さ（連携） */
  length: Scalars['String']['output'];
  /** 長さCD（連携） */
  lengthCd: Scalars['Int']['output'];
  /** 商品名 */
  name: Scalars['String']['output'];
  /** 荷姿（注文単位） */
  packing: OrderPacking;
  /** 荷姿 */
  packingStyle?: Maybe<Scalars['String']['output']>;
  /** 数量 */
  quantity: Scalars['Int']['output'];
  /** 商品在庫 - ケース入数（カート追加時） */
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫 - 小箱入数（カート追加時） */
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** カート内で選択中 */
  selected: Scalars['Boolean']['output'];
  /** 商品 短縮CD */
  shortCd?: Maybe<Scalars['Int']['output']>;
  /** サイズCD */
  sizeCd: Scalars['BigInt']['output'];
  /** サイズ名 */
  sizeName: Scalars['String']['output'];
  /** 購入担当者 */
  staff: Staff;
  /** 購入担当者ID */
  staffId: Scalars['Int']['output'];
  /** 商品在庫 */
  stockItem?: Maybe<StockItem>;
  /** 商品在庫ID */
  stockItemId?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫単価 */
  stockItemUnitPrice?: Maybe<StockItemUnitPrice>;
  /** 商品在庫単価ID */
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  /** バラ数量 */
  totalQuantity: Scalars['Int']['output'];
  /** 単価 */
  unitPrice: Scalars['Decimal']['output'];
  /** 商品在庫単価 - バラ単価（カート追加時） */
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース単価（カート追加時） */
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱単価（カート追加時） */
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CartItemAvgAggregate = {
  __typename?: 'CartItemAvgAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  diameterCd?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  itemCd?: Maybe<Scalars['Float']['output']>;
  lengthCd?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Float']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Float']['output']>;
  shortCd?: Maybe<Scalars['Float']['output']>;
  sizeCd?: Maybe<Scalars['Float']['output']>;
  staffId?: Maybe<Scalars['Float']['output']>;
  stockItemId?: Maybe<Scalars['Float']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Float']['output']>;
  totalQuantity?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type CartItemCountAggregate = {
  __typename?: 'CartItemCountAggregate';
  _all: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  costPriceOfStockItemUnitPrice: Scalars['Int']['output'];
  costRateOfCaseOfStockItemUnitPrice: Scalars['Int']['output'];
  costRateOfPackOfStockItemUnitPrice: Scalars['Int']['output'];
  costRateOfStockItemUnitPrice: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  customerNote: Scalars['Int']['output'];
  customerOrderNo: Scalars['Int']['output'];
  diameter: Scalars['Int']['output'];
  diameterCd: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemCd: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
  lengthCd: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  packing: Scalars['Int']['output'];
  packingStyle: Scalars['Int']['output'];
  quantity: Scalars['Int']['output'];
  quantityParCaseOfStockItem: Scalars['Int']['output'];
  quantityParPackOfStockItem: Scalars['Int']['output'];
  selected: Scalars['Int']['output'];
  shortCd: Scalars['Int']['output'];
  sizeCd: Scalars['Int']['output'];
  sizeName: Scalars['Int']['output'];
  staffId: Scalars['Int']['output'];
  stockItemId: Scalars['Int']['output'];
  stockItemUnitPriceId: Scalars['Int']['output'];
  totalQuantity: Scalars['Int']['output'];
  unitPrice: Scalars['Int']['output'];
  unitPriceOfStockItemUnitPrice: Scalars['Int']['output'];
  unitPriceParCaseOfStockItemUnitPrice: Scalars['Int']['output'];
  unitPriceParPackOfStockItemUnitPrice: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type CartItemCreateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutCartItemsInput;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutCartItemsInput;
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutCartItemInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutCartItemInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateManyCustomerInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staffId: Scalars['Int']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateManyCustomerInputEnvelope = {
  data: Array<CartItemCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartItemCreateManyStaffInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerId: Scalars['Int']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateManyStaffInputEnvelope = {
  data: Array<CartItemCreateManyStaffInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartItemCreateManyStockItemInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerId: Scalars['Int']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staffId: Scalars['Int']['input'];
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateManyStockItemInputEnvelope = {
  data: Array<CartItemCreateManyStockItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartItemCreateManyStockItemUnitPriceInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerId: Scalars['Int']['input'];
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staffId: Scalars['Int']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateManyStockItemUnitPriceInputEnvelope = {
  data: Array<CartItemCreateManyStockItemUnitPriceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CartItemCreateOrConnectWithoutCustomerInput = {
  create: CartItemCreateWithoutCustomerInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemCreateOrConnectWithoutStaffInput = {
  create: CartItemCreateWithoutStaffInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemCreateOrConnectWithoutStockItemInput = {
  create: CartItemCreateWithoutStockItemInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemCreateOrConnectWithoutStockItemUnitPriceInput = {
  create: CartItemCreateWithoutStockItemUnitPriceInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemCreateWithoutCustomerInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutCartItemsInput;
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutCartItemInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutCartItemInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateWithoutStaffInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutCartItemsInput;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutCartItemInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutCartItemInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateWithoutStockItemInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutCartItemsInput;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutCartItemsInput;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutCartItemInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemCreateWithoutStockItemUnitPriceInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutCartItemsInput;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutCartItemsInput;
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutCartItemInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CartItemListRelationFilter = {
  every?: InputMaybe<CartItemWhereInput>;
  none?: InputMaybe<CartItemWhereInput>;
  some?: InputMaybe<CartItemWhereInput>;
};

export type CartItemMaxAggregate = {
  __typename?: 'CartItemMaxAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerNote?: Maybe<Scalars['String']['output']>;
  customerOrderNo?: Maybe<Scalars['String']['output']>;
  diameter?: Maybe<Scalars['String']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packing?: Maybe<OrderPacking>;
  packingStyle?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  sizeName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  stockItemId?: Maybe<Scalars['Int']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CartItemMinAggregate = {
  __typename?: 'CartItemMinAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerNote?: Maybe<Scalars['String']['output']>;
  customerOrderNo?: Maybe<Scalars['String']['output']>;
  diameter?: Maybe<Scalars['String']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  packing?: Maybe<OrderPacking>;
  packingStyle?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  sizeName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  stockItemId?: Maybe<Scalars['Int']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CartItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CartItemOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  costPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  customerNote?: InputMaybe<SortOrderInput>;
  customerOrderNo?: InputMaybe<SortOrderInput>;
  diameter?: InputMaybe<SortOrder>;
  diameterCd?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  itemCd?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  lengthCd?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  packing?: InputMaybe<SortOrder>;
  packingStyle?: InputMaybe<SortOrderInput>;
  quantity?: InputMaybe<SortOrder>;
  quantityParCaseOfStockItem?: InputMaybe<SortOrderInput>;
  quantityParPackOfStockItem?: InputMaybe<SortOrderInput>;
  selected?: InputMaybe<SortOrder>;
  shortCd?: InputMaybe<SortOrderInput>;
  sizeCd?: InputMaybe<SortOrder>;
  sizeName?: InputMaybe<SortOrder>;
  staff?: InputMaybe<StaffOrderByWithRelationInput>;
  staffId?: InputMaybe<SortOrder>;
  stockItem?: InputMaybe<StockItemOrderByWithRelationInput>;
  stockItemId?: InputMaybe<SortOrderInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceOrderByWithRelationInput>;
  stockItemUnitPriceId?: InputMaybe<SortOrderInput>;
  totalQuantity?: InputMaybe<SortOrder>;
  unitPrice?: InputMaybe<SortOrder>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum CartItemScalarFieldEnum {
  Amount = 'amount',
  CostPriceOfStockItemUnitPrice = 'costPriceOfStockItemUnitPrice',
  CostRateOfCaseOfStockItemUnitPrice = 'costRateOfCaseOfStockItemUnitPrice',
  CostRateOfPackOfStockItemUnitPrice = 'costRateOfPackOfStockItemUnitPrice',
  CostRateOfStockItemUnitPrice = 'costRateOfStockItemUnitPrice',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  CustomerNote = 'customerNote',
  CustomerOrderNo = 'customerOrderNo',
  Diameter = 'diameter',
  DiameterCd = 'diameterCd',
  Id = 'id',
  ItemCd = 'itemCd',
  Length = 'length',
  LengthCd = 'lengthCd',
  Name = 'name',
  Packing = 'packing',
  PackingStyle = 'packingStyle',
  Quantity = 'quantity',
  QuantityParCaseOfStockItem = 'quantityParCaseOfStockItem',
  QuantityParPackOfStockItem = 'quantityParPackOfStockItem',
  Selected = 'selected',
  ShortCd = 'shortCd',
  SizeCd = 'sizeCd',
  SizeName = 'sizeName',
  StaffId = 'staffId',
  StockItemId = 'stockItemId',
  StockItemUnitPriceId = 'stockItemUnitPriceId',
  TotalQuantity = 'totalQuantity',
  UnitPrice = 'unitPrice',
  UnitPriceOfStockItemUnitPrice = 'unitPriceOfStockItemUnitPrice',
  UnitPriceParCaseOfStockItemUnitPrice = 'unitPriceParCaseOfStockItemUnitPrice',
  UnitPriceParPackOfStockItemUnitPrice = 'unitPriceParPackOfStockItemUnitPrice',
  UpdatedAt = 'updatedAt'
}

export type CartItemScalarWhereInput = {
  AND?: InputMaybe<Array<CartItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<CartItemScalarWhereInput>>;
  OR?: InputMaybe<Array<CartItemScalarWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  customerNote?: InputMaybe<StringNullableFilter>;
  customerOrderNo?: InputMaybe<StringNullableFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  packing?: InputMaybe<EnumOrderPackingFilter>;
  packingStyle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  selected?: InputMaybe<BoolFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  staffId?: InputMaybe<IntFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  totalQuantity?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CartItemStaffIdItemCdSizeCdCompoundUniqueInput = {
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  staffId: Scalars['Int']['input'];
};

export type CartItemSumAggregate = {
  __typename?: 'CartItemSumAggregate';
  amount?: Maybe<Scalars['Decimal']['output']>;
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  stockItemId?: Maybe<Scalars['Int']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  totalQuantity?: Maybe<Scalars['Int']['output']>;
  unitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type CartItemUpdateInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartItemUpdateManyMutationInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartItemUpdateManyWithWhereWithoutCustomerInput = {
  data: CartItemUpdateManyMutationInput;
  where: CartItemScalarWhereInput;
};

export type CartItemUpdateManyWithWhereWithoutStaffInput = {
  data: CartItemUpdateManyMutationInput;
  where: CartItemScalarWhereInput;
};

export type CartItemUpdateManyWithWhereWithoutStockItemInput = {
  data: CartItemUpdateManyMutationInput;
  where: CartItemScalarWhereInput;
};

export type CartItemUpdateManyWithWhereWithoutStockItemUnitPriceInput = {
  data: CartItemUpdateManyMutationInput;
  where: CartItemScalarWhereInput;
};

export type CartItemUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<CartItemCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<CartItemUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<CartItemUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type CartItemUpdateManyWithoutStaffNestedInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutStaffInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutStaffInput>>;
  createMany?: InputMaybe<CartItemCreateManyStaffInputEnvelope>;
  delete?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemUpdateWithWhereUniqueWithoutStaffInput>>;
  updateMany?: InputMaybe<Array<CartItemUpdateManyWithWhereWithoutStaffInput>>;
  upsert?: InputMaybe<Array<CartItemUpsertWithWhereUniqueWithoutStaffInput>>;
};

export type CartItemUpdateManyWithoutStockItemNestedInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutStockItemInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutStockItemInput>>;
  createMany?: InputMaybe<CartItemCreateManyStockItemInputEnvelope>;
  delete?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemUpdateWithWhereUniqueWithoutStockItemInput>>;
  updateMany?: InputMaybe<Array<CartItemUpdateManyWithWhereWithoutStockItemInput>>;
  upsert?: InputMaybe<Array<CartItemUpsertWithWhereUniqueWithoutStockItemInput>>;
};

export type CartItemUpdateManyWithoutStockItemUnitPriceNestedInput = {
  connect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CartItemCreateOrConnectWithoutStockItemUnitPriceInput>>;
  create?: InputMaybe<Array<CartItemCreateWithoutStockItemUnitPriceInput>>;
  createMany?: InputMaybe<CartItemCreateManyStockItemUnitPriceInputEnvelope>;
  delete?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CartItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  set?: InputMaybe<Array<CartItemWhereUniqueInput>>;
  update?: InputMaybe<Array<CartItemUpdateWithWhereUniqueWithoutStockItemUnitPriceInput>>;
  updateMany?: InputMaybe<Array<CartItemUpdateManyWithWhereWithoutStockItemUnitPriceInput>>;
  upsert?: InputMaybe<Array<CartItemUpsertWithWhereUniqueWithoutStockItemUnitPriceInput>>;
};

export type CartItemUpdateWithWhereUniqueWithoutCustomerInput = {
  data: CartItemUpdateWithoutCustomerInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpdateWithWhereUniqueWithoutStaffInput = {
  data: CartItemUpdateWithoutStaffInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpdateWithWhereUniqueWithoutStockItemInput = {
  data: CartItemUpdateWithoutStockItemInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpdateWithWhereUniqueWithoutStockItemUnitPriceInput = {
  data: CartItemUpdateWithoutStockItemUnitPriceInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpdateWithoutCustomerInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartItemUpdateWithoutStaffInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartItemUpdateWithoutStockItemInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartItemUpdateWithoutStockItemUnitPriceInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type CartItemUpsertWithWhereUniqueWithoutCustomerInput = {
  create: CartItemCreateWithoutCustomerInput;
  update: CartItemUpdateWithoutCustomerInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpsertWithWhereUniqueWithoutStaffInput = {
  create: CartItemCreateWithoutStaffInput;
  update: CartItemUpdateWithoutStaffInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpsertWithWhereUniqueWithoutStockItemInput = {
  create: CartItemCreateWithoutStockItemInput;
  update: CartItemUpdateWithoutStockItemInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemUpsertWithWhereUniqueWithoutStockItemUnitPriceInput = {
  create: CartItemCreateWithoutStockItemUnitPriceInput;
  update: CartItemUpdateWithoutStockItemUnitPriceInput;
  where: CartItemWhereUniqueInput;
};

export type CartItemWhereInput = {
  AND?: InputMaybe<Array<CartItemWhereInput>>;
  NOT?: InputMaybe<Array<CartItemWhereInput>>;
  OR?: InputMaybe<Array<CartItemWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  customerNote?: InputMaybe<StringNullableFilter>;
  customerOrderNo?: InputMaybe<StringNullableFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  packing?: InputMaybe<EnumOrderPackingFilter>;
  packingStyle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  selected?: InputMaybe<BoolFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  staff?: InputMaybe<StaffRelationFilter>;
  staffId?: InputMaybe<IntFilter>;
  stockItem?: InputMaybe<StockItemRelationFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceRelationFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  totalQuantity?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CartItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  staffId_itemCd_sizeCd?: InputMaybe<CartItemStaffIdItemCdSizeCdCompoundUniqueInput>;
};

export type CodeVerifyResponse = {
  __typename?: 'CodeVerifyResponse';
  result: Scalars['String']['output'];
};

/**
 *
 * 得意先
 */
export type Customer = {
  __typename?: 'Customer';
  _count?: Maybe<CustomerCount>;
  billingAddress: Array<BillingAddress>;
  /** カート内商品 */
  cartItems: Array<CartItem>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先CD（連携） */
  customerCd: Scalars['Int']['output'];
  deliveryAddress: Array<DeliveryAddress>;
  /** メールアドレス → 不要（一応残しておく） */
  email?: Maybe<Scalars['String']['output']>;
  /** メールアドレス認証sub（Cognito用） → 不要（一応残しておく） */
  emailAuthSub?: Maybe<Scalars['String']['output']>;
  /** 得意先ID */
  id: Scalars['Int']['output'];
  /** 得意先名（連携） */
  name: Scalars['String']['output'];
  /** 注文 */
  order: Array<Order>;
  /** 注文依頼 */
  orderRequests: Array<OrderRequest>;
  staffs: Array<Staff>;
  /** 商品在庫単価 */
  stockItemUnitPrices: Array<StockItemUnitPrice>;
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
  /** ログインID */
  username?: Maybe<Scalars['String']['output']>;
  /** ログインID認証sub（Cognito用） */
  usernameAuthSub?: Maybe<Scalars['String']['output']>;
  /** お気に入り内商品 */
  wishlistItems: Array<WishlistItem>;
};


/**
 *
 * 得意先
 */
export type CustomerBillingAddressArgs = {
  cursor?: InputMaybe<BillingAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<BillingAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BillingAddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BillingAddressWhereInput>;
};


/**
 *
 * 得意先
 */
export type CustomerCartItemsArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CartItemWhereInput>;
};


/**
 *
 * 得意先
 */
export type CustomerDeliveryAddressArgs = {
  cursor?: InputMaybe<DeliveryAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeliveryAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeliveryAddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeliveryAddressWhereInput>;
};


/**
 *
 * 得意先
 */
export type CustomerOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


/**
 *
 * 得意先
 */
export type CustomerOrderRequestsArgs = {
  cursor?: InputMaybe<OrderRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestWhereInput>;
};


/**
 *
 * 得意先
 */
export type CustomerStaffsArgs = {
  cursor?: InputMaybe<StaffWhereUniqueInput>;
  distinct?: InputMaybe<Array<StaffScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StaffOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StaffWhereInput>;
};


/**
 *
 * 得意先
 */
export type CustomerStockItemUnitPricesArgs = {
  cursor?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<StockItemUnitPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StockItemUnitPriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
};


/**
 *
 * 得意先
 */
export type CustomerWishlistItemsArgs = {
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type CustomerAvgAggregate = {
  __typename?: 'CustomerAvgAggregate';
  customerCd?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

export type CustomerCount = {
  __typename?: 'CustomerCount';
  billingAddress: Scalars['Int']['output'];
  cartItems: Scalars['Int']['output'];
  deliveryAddress: Scalars['Int']['output'];
  order: Scalars['Int']['output'];
  orderRequests: Scalars['Int']['output'];
  staffs: Scalars['Int']['output'];
  stockItemUnitPrices: Scalars['Int']['output'];
  wishlistItems: Scalars['Int']['output'];
};


export type CustomerCountBillingAddressArgs = {
  where?: InputMaybe<BillingAddressWhereInput>;
};


export type CustomerCountCartItemsArgs = {
  where?: InputMaybe<CartItemWhereInput>;
};


export type CustomerCountDeliveryAddressArgs = {
  where?: InputMaybe<DeliveryAddressWhereInput>;
};


export type CustomerCountOrderArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type CustomerCountOrderRequestsArgs = {
  where?: InputMaybe<OrderRequestWhereInput>;
};


export type CustomerCountStaffsArgs = {
  where?: InputMaybe<StaffWhereInput>;
};


export type CustomerCountStockItemUnitPricesArgs = {
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
};


export type CustomerCountWishlistItemsArgs = {
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type CustomerCountAggregate = {
  __typename?: 'CustomerCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerCd: Scalars['Int']['output'];
  email: Scalars['Int']['output'];
  emailAuthSub: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
  username: Scalars['Int']['output'];
  usernameAuthSub: Scalars['Int']['output'];
};

export type CustomerCreateInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateNestedOneWithoutBillingAddressInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutBillingAddressInput>;
  create?: InputMaybe<CustomerCreateWithoutBillingAddressInput>;
};

export type CustomerCreateNestedOneWithoutCartItemsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutCartItemsInput>;
  create?: InputMaybe<CustomerCreateWithoutCartItemsInput>;
};

export type CustomerCreateNestedOneWithoutDeliveryAddressInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutDeliveryAddressInput>;
  create?: InputMaybe<CustomerCreateWithoutDeliveryAddressInput>;
};

export type CustomerCreateNestedOneWithoutOrderInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrderInput>;
  create?: InputMaybe<CustomerCreateWithoutOrderInput>;
};

export type CustomerCreateNestedOneWithoutOrderRequestsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutOrderRequestsInput>;
  create?: InputMaybe<CustomerCreateWithoutOrderRequestsInput>;
};

export type CustomerCreateNestedOneWithoutStaffsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutStaffsInput>;
  create?: InputMaybe<CustomerCreateWithoutStaffsInput>;
};

export type CustomerCreateNestedOneWithoutStockItemUnitPricesInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutStockItemUnitPricesInput>;
  create?: InputMaybe<CustomerCreateWithoutStockItemUnitPricesInput>;
};

export type CustomerCreateNestedOneWithoutWishlistItemsInput = {
  connect?: InputMaybe<CustomerWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CustomerCreateOrConnectWithoutWishlistItemsInput>;
  create?: InputMaybe<CustomerCreateWithoutWishlistItemsInput>;
};

export type CustomerCreateOrConnectWithoutBillingAddressInput = {
  create: CustomerCreateWithoutBillingAddressInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutCartItemsInput = {
  create: CustomerCreateWithoutCartItemsInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutDeliveryAddressInput = {
  create: CustomerCreateWithoutDeliveryAddressInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutOrderInput = {
  create: CustomerCreateWithoutOrderInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutOrderRequestsInput = {
  create: CustomerCreateWithoutOrderRequestsInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutStaffsInput = {
  create: CustomerCreateWithoutStaffsInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutStockItemUnitPricesInput = {
  create: CustomerCreateWithoutStockItemUnitPricesInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateOrConnectWithoutWishlistItemsInput = {
  create: CustomerCreateWithoutWishlistItemsInput;
  where: CustomerWhereUniqueInput;
};

export type CustomerCreateWithoutBillingAddressInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateWithoutCartItemsInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateWithoutDeliveryAddressInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateWithoutOrderInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateWithoutOrderRequestsInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateWithoutStaffsInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateWithoutStockItemUnitPricesInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerCreateWithoutWishlistItemsInput = {
  customerCd: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  emailAuthSub?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  usernameAuthSub?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerMaxAggregate = {
  __typename?: 'CustomerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerCd?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailAuthSub?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  usernameAuthSub?: Maybe<Scalars['String']['output']>;
};

export type CustomerMinAggregate = {
  __typename?: 'CustomerMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerCd?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailAuthSub?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  usernameAuthSub?: Maybe<Scalars['String']['output']>;
};

export type CustomerOrderByWithRelationInput = {
  billingAddress?: InputMaybe<BillingAddressOrderByRelationAggregateInput>;
  cartItems?: InputMaybe<CartItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerCd?: InputMaybe<SortOrder>;
  deliveryAddress?: InputMaybe<DeliveryAddressOrderByRelationAggregateInput>;
  email?: InputMaybe<SortOrderInput>;
  emailAuthSub?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByRelationAggregateInput>;
  orderRequests?: InputMaybe<OrderRequestOrderByRelationAggregateInput>;
  staffs?: InputMaybe<StaffOrderByRelationAggregateInput>;
  stockItemUnitPrices?: InputMaybe<StockItemUnitPriceOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
  username?: InputMaybe<SortOrderInput>;
  usernameAuthSub?: InputMaybe<SortOrderInput>;
  wishlistItems?: InputMaybe<WishlistItemOrderByRelationAggregateInput>;
};

export type CustomerRelationFilter = {
  is?: InputMaybe<CustomerWhereInput>;
  isNot?: InputMaybe<CustomerWhereInput>;
};

export enum CustomerScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerCd = 'customerCd',
  Email = 'email',
  EmailAuthSub = 'emailAuthSub',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Username = 'username',
  UsernameAuthSub = 'usernameAuthSub'
}

export type CustomerSumAggregate = {
  __typename?: 'CustomerSumAggregate';
  customerCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type CustomerUpdateManyMutationInput = {
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAuthSub?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameAuthSub?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type CustomerWhereInput = {
  AND?: InputMaybe<Array<CustomerWhereInput>>;
  NOT?: InputMaybe<Array<CustomerWhereInput>>;
  OR?: InputMaybe<Array<CustomerWhereInput>>;
  billingAddress?: InputMaybe<BillingAddressListRelationFilter>;
  cartItems?: InputMaybe<CartItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerCd?: InputMaybe<IntFilter>;
  deliveryAddress?: InputMaybe<DeliveryAddressListRelationFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailAuthSub?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderListRelationFilter>;
  orderRequests?: InputMaybe<OrderRequestListRelationFilter>;
  staffs?: InputMaybe<StaffListRelationFilter>;
  stockItemUnitPrices?: InputMaybe<StockItemUnitPriceListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
  username?: InputMaybe<StringNullableFilter>;
  usernameAuthSub?: InputMaybe<StringNullableFilter>;
  wishlistItems?: InputMaybe<WishlistItemListRelationFilter>;
};

export type CustomerWhereUniqueInput = {
  customerCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type DecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type DecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

/** パスワード設定可能な引数 */
export type DecoratedCustomerUpdateInput = {
  billingAddress?: InputMaybe<BillingAddressUpdateManyWithoutCustomerNestedInput>;
  cartItems?: InputMaybe<CartItemUpdateManyWithoutCustomerNestedInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<DeliveryAddressUpdateManyWithoutCustomerNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailAuthSub?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  order?: InputMaybe<OrderUpdateManyWithoutCustomerNestedInput>;
  orderRequests?: InputMaybe<OrderRequestUpdateManyWithoutCustomerNestedInput>;
  /** パスワード */
  password: Scalars['String']['input'];
  staffs?: InputMaybe<StaffUpdateManyWithoutCustomerNestedInput>;
  stockItemUnitPrices?: InputMaybe<StockItemUnitPriceUpdateManyWithoutCustomerNestedInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  usernameAuthSub?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  wishlistItems?: InputMaybe<WishlistItemUpdateManyWithoutCustomerNestedInput>;
};

/**
 *
 * 配送先 → 現時点で未使用
 */
export type DeliveryAddress = {
  __typename?: 'DeliveryAddress';
  /** 住所 */
  address: Scalars['String']['output'];
  /** 担当者名 */
  chargeName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** 配送先ID */
  id: Scalars['Int']['output'];
  /** 配送先名 */
  name: Scalars['String']['output'];
  /** 配送先名カナ */
  nameKana?: Maybe<Scalars['String']['output']>;
  /** 電話番号 */
  phoneNumber: Scalars['String']['output'];
  /** 郵便番号 */
  postalCode: Scalars['String']['output'];
  /** 都道府県 */
  prefecture: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type DeliveryAddressCreateInput = {
  address: Scalars['String']['input'];
  chargeName: Scalars['String']['input'];
  customer: CustomerCreateNestedOneWithoutDeliveryAddressInput;
  name: Scalars['String']['input'];
  nameKana?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type DeliveryAddressCreateManyCustomerInput = {
  address: Scalars['String']['input'];
  chargeName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  nameKana?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type DeliveryAddressCreateManyCustomerInputEnvelope = {
  data: Array<DeliveryAddressCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeliveryAddressCreateOrConnectWithoutCustomerInput = {
  create: DeliveryAddressCreateWithoutCustomerInput;
  where: DeliveryAddressWhereUniqueInput;
};

export type DeliveryAddressCreateWithoutCustomerInput = {
  address: Scalars['String']['input'];
  chargeName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  nameKana?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prefecture: Scalars['String']['input'];
};

export type DeliveryAddressListRelationFilter = {
  every?: InputMaybe<DeliveryAddressWhereInput>;
  none?: InputMaybe<DeliveryAddressWhereInput>;
  some?: InputMaybe<DeliveryAddressWhereInput>;
};

export type DeliveryAddressOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DeliveryAddressOrderByWithRelationInput = {
  address?: InputMaybe<SortOrder>;
  chargeName?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  nameKana?: InputMaybe<SortOrderInput>;
  phoneNumber?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  prefecture?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum DeliveryAddressScalarFieldEnum {
  Address = 'address',
  ChargeName = 'chargeName',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Id = 'id',
  Name = 'name',
  NameKana = 'nameKana',
  PhoneNumber = 'phoneNumber',
  PostalCode = 'postalCode',
  Prefecture = 'prefecture',
  UpdatedAt = 'updatedAt'
}

export type DeliveryAddressScalarWhereInput = {
  AND?: InputMaybe<Array<DeliveryAddressScalarWhereInput>>;
  NOT?: InputMaybe<Array<DeliveryAddressScalarWhereInput>>;
  OR?: InputMaybe<Array<DeliveryAddressScalarWhereInput>>;
  address?: InputMaybe<StringFilter>;
  chargeName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nameKana?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  prefecture?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type DeliveryAddressUpdateInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  chargeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  prefecture?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DeliveryAddressUpdateManyMutationInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  chargeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  prefecture?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DeliveryAddressUpdateManyWithWhereWithoutCustomerInput = {
  data: DeliveryAddressUpdateManyMutationInput;
  where: DeliveryAddressScalarWhereInput;
};

export type DeliveryAddressUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<DeliveryAddressWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DeliveryAddressCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<DeliveryAddressCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<DeliveryAddressCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<DeliveryAddressWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DeliveryAddressScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DeliveryAddressWhereUniqueInput>>;
  set?: InputMaybe<Array<DeliveryAddressWhereUniqueInput>>;
  update?: InputMaybe<Array<DeliveryAddressUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<DeliveryAddressUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<DeliveryAddressUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type DeliveryAddressUpdateWithWhereUniqueWithoutCustomerInput = {
  data: DeliveryAddressUpdateWithoutCustomerInput;
  where: DeliveryAddressWhereUniqueInput;
};

export type DeliveryAddressUpdateWithoutCustomerInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  chargeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  nameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  prefecture?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DeliveryAddressUpsertWithWhereUniqueWithoutCustomerInput = {
  create: DeliveryAddressCreateWithoutCustomerInput;
  update: DeliveryAddressUpdateWithoutCustomerInput;
  where: DeliveryAddressWhereUniqueInput;
};

export type DeliveryAddressWhereInput = {
  AND?: InputMaybe<Array<DeliveryAddressWhereInput>>;
  NOT?: InputMaybe<Array<DeliveryAddressWhereInput>>;
  OR?: InputMaybe<Array<DeliveryAddressWhereInput>>;
  address?: InputMaybe<StringFilter>;
  chargeName?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nameKana?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  postalCode?: InputMaybe<StringFilter>;
  prefecture?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type DeliveryAddressWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type EnumOrderPackingFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderPacking>;
};

export type EnumOrderPackingFilter = {
  equals?: InputMaybe<OrderPacking>;
  in?: InputMaybe<Array<OrderPacking>>;
  not?: InputMaybe<NestedEnumOrderPackingFilter>;
  notIn?: InputMaybe<Array<OrderPacking>>;
};

export type EnumOrderPackingNullableFilter = {
  equals?: InputMaybe<OrderPacking>;
  in?: InputMaybe<Array<OrderPacking>>;
  not?: InputMaybe<NestedEnumOrderPackingNullableFilter>;
  notIn?: InputMaybe<Array<OrderPacking>>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 *
 * 商品
 */
export type Item = {
  __typename?: 'Item';
  _count?: Maybe<ItemCount>;
  createdAt: Scalars['DateTime']['output'];
  /** 商品説明 -> 画面には非表示（QA No.60） */
  description?: Maybe<Scalars['String']['output']>;
  /** 無効フラグ（連携） */
  disabled: Scalars['Boolean']['output'];
  /** 商品ID */
  id: Scalars['Int']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** 品種CD（連携） */
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  /** 大分類 */
  largeCategory?: Maybe<LargeCategory>;
  /** 大分類コード（連携） */
  largeCd?: Maybe<Scalars['Int']['output']>;
  /** 中分類 */
  middleCategory?: Maybe<MiddleCategory>;
  /** 中分類コード（連携） */
  middleCd?: Maybe<Scalars['Int']['output']>;
  /** Web商品名（連携） */
  name: Scalars['String']['output'];
  /** 短縮CD（連携） */
  shortCd?: Maybe<Scalars['Int']['output']>;
  /** 小分類 */
  smallCategory?: Maybe<SmallCategory>;
  /** 小分類コード（連携） */
  smallCd?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫 */
  stockItems: Array<StockItem>;
  /** 在庫区分（0：岡総在庫　9420：由良産商在庫）（連携） */
  stockLocationCd?: Maybe<Scalars['Int']['output']>;
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


/**
 *
 * 商品
 */
export type ItemStockItemsArgs = {
  cursor?: InputMaybe<StockItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<StockItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StockItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemWhereInput>;
};

export type ItemAvgAggregate = {
  __typename?: 'ItemAvgAggregate';
  id?: Maybe<Scalars['Float']['output']>;
  itemCd?: Maybe<Scalars['Float']['output']>;
  largeCd?: Maybe<Scalars['Float']['output']>;
  middleCd?: Maybe<Scalars['Float']['output']>;
  shortCd?: Maybe<Scalars['Float']['output']>;
  smallCd?: Maybe<Scalars['Float']['output']>;
  stockLocationCd?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

export type ItemCount = {
  __typename?: 'ItemCount';
  stockItems: Scalars['Int']['output'];
};


export type ItemCountStockItemsArgs = {
  where?: InputMaybe<StockItemWhereInput>;
};

export type ItemCountAggregate = {
  __typename?: 'ItemCountAggregate';
  _all: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  description: Scalars['Int']['output'];
  disabled: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemCd: Scalars['Int']['output'];
  largeCd: Scalars['Int']['output'];
  middleCd: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  shortCd: Scalars['Int']['output'];
  smallCd: Scalars['Int']['output'];
  stockLocationCd: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
};

export type ItemCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  largeCategory?: InputMaybe<LargeCategoryCreateNestedOneWithoutItemsInput>;
  middleCategory?: InputMaybe<MiddleCategoryCreateNestedOneWithoutItemsInput>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  smallCategory?: InputMaybe<SmallCategoryCreateNestedOneWithoutItemsInput>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCreateManyLargeCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  middleCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  smallCd?: InputMaybe<Scalars['Int']['input']>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCreateManyLargeCategoryInputEnvelope = {
  data: Array<ItemCreateManyLargeCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemCreateManyMiddleCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  smallCd?: InputMaybe<Scalars['Int']['input']>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCreateManyMiddleCategoryInputEnvelope = {
  data: Array<ItemCreateManyMiddleCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemCreateManySmallCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  largeCd?: InputMaybe<Scalars['Int']['input']>;
  middleCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCreateManySmallCategoryInputEnvelope = {
  data: Array<ItemCreateManySmallCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemCreateNestedOneWithoutStockItemsInput = {
  connect?: InputMaybe<ItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ItemCreateOrConnectWithoutStockItemsInput>;
  create?: InputMaybe<ItemCreateWithoutStockItemsInput>;
};

export type ItemCreateOrConnectWithoutLargeCategoryInput = {
  create: ItemCreateWithoutLargeCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemCreateOrConnectWithoutMiddleCategoryInput = {
  create: ItemCreateWithoutMiddleCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemCreateOrConnectWithoutSmallCategoryInput = {
  create: ItemCreateWithoutSmallCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemCreateOrConnectWithoutStockItemsInput = {
  create: ItemCreateWithoutStockItemsInput;
  where: ItemWhereUniqueInput;
};

export type ItemCreateWithoutLargeCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  middleCategory?: InputMaybe<MiddleCategoryCreateNestedOneWithoutItemsInput>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  smallCategory?: InputMaybe<SmallCategoryCreateNestedOneWithoutItemsInput>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCreateWithoutMiddleCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  largeCategory?: InputMaybe<LargeCategoryCreateNestedOneWithoutItemsInput>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  smallCategory?: InputMaybe<SmallCategoryCreateNestedOneWithoutItemsInput>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCreateWithoutSmallCategoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  largeCategory?: InputMaybe<LargeCategoryCreateNestedOneWithoutItemsInput>;
  middleCategory?: InputMaybe<MiddleCategoryCreateNestedOneWithoutItemsInput>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemCreateWithoutStockItemsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
  largeCategory?: InputMaybe<LargeCategoryCreateNestedOneWithoutItemsInput>;
  middleCategory?: InputMaybe<MiddleCategoryCreateNestedOneWithoutItemsInput>;
  name: Scalars['String']['input'];
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  smallCategory?: InputMaybe<SmallCategoryCreateNestedOneWithoutItemsInput>;
  stockLocationCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type ItemListRelationFilter = {
  every?: InputMaybe<ItemWhereInput>;
  none?: InputMaybe<ItemWhereInput>;
  some?: InputMaybe<ItemWhereInput>;
};

export type ItemMaxAggregate = {
  __typename?: 'ItemMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  largeCd?: Maybe<Scalars['Int']['output']>;
  middleCd?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  smallCd?: Maybe<Scalars['Int']['output']>;
  stockLocationCd?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ItemMinAggregate = {
  __typename?: 'ItemMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  largeCd?: Maybe<Scalars['Int']['output']>;
  middleCd?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  smallCd?: Maybe<Scalars['Int']['output']>;
  stockLocationCd?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ItemOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  disabled?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  itemCd?: InputMaybe<SortOrderInput>;
  largeCategory?: InputMaybe<LargeCategoryOrderByWithRelationInput>;
  largeCd?: InputMaybe<SortOrderInput>;
  middleCategory?: InputMaybe<MiddleCategoryOrderByWithRelationInput>;
  middleCd?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  shortCd?: InputMaybe<SortOrderInput>;
  smallCategory?: InputMaybe<SmallCategoryOrderByWithRelationInput>;
  smallCd?: InputMaybe<SortOrderInput>;
  stockItems?: InputMaybe<StockItemOrderByRelationAggregateInput>;
  stockLocationCd?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
};

export type ItemRelationFilter = {
  is?: InputMaybe<ItemWhereInput>;
  isNot?: InputMaybe<ItemWhereInput>;
};

export enum ItemScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Disabled = 'disabled',
  Id = 'id',
  ItemCd = 'itemCd',
  LargeCd = 'largeCd',
  MiddleCd = 'middleCd',
  Name = 'name',
  ShortCd = 'shortCd',
  SmallCd = 'smallCd',
  StockLocationCd = 'stockLocationCd',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type ItemScalarWhereInput = {
  AND?: InputMaybe<Array<ItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<ItemScalarWhereInput>>;
  OR?: InputMaybe<Array<ItemScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntNullableFilter>;
  largeCd?: InputMaybe<IntNullableFilter>;
  middleCd?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  smallCd?: InputMaybe<IntNullableFilter>;
  stockLocationCd?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type ItemSumAggregate = {
  __typename?: 'ItemSumAggregate';
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  largeCd?: Maybe<Scalars['Int']['output']>;
  middleCd?: Maybe<Scalars['Int']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  smallCd?: Maybe<Scalars['Int']['output']>;
  stockLocationCd?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type ItemUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stockItems?: InputMaybe<StockItemUpdateManyWithoutItemNestedInput>;
  stockLocationCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ItemUpdateManyMutationInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stockLocationCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ItemUpdateManyWithWhereWithoutLargeCategoryInput = {
  data: ItemUpdateManyMutationInput;
  where: ItemScalarWhereInput;
};

export type ItemUpdateManyWithWhereWithoutMiddleCategoryInput = {
  data: ItemUpdateManyMutationInput;
  where: ItemScalarWhereInput;
};

export type ItemUpdateManyWithWhereWithoutSmallCategoryInput = {
  data: ItemUpdateManyMutationInput;
  where: ItemScalarWhereInput;
};

export type ItemUpdateManyWithoutLargeCategoryNestedInput = {
  connect?: InputMaybe<Array<ItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemCreateOrConnectWithoutLargeCategoryInput>>;
  create?: InputMaybe<Array<ItemCreateWithoutLargeCategoryInput>>;
  createMany?: InputMaybe<ItemCreateManyLargeCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemUpdateWithWhereUniqueWithoutLargeCategoryInput>>;
  updateMany?: InputMaybe<Array<ItemUpdateManyWithWhereWithoutLargeCategoryInput>>;
  upsert?: InputMaybe<Array<ItemUpsertWithWhereUniqueWithoutLargeCategoryInput>>;
};

export type ItemUpdateManyWithoutMiddleCategoryNestedInput = {
  connect?: InputMaybe<Array<ItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemCreateOrConnectWithoutMiddleCategoryInput>>;
  create?: InputMaybe<Array<ItemCreateWithoutMiddleCategoryInput>>;
  createMany?: InputMaybe<ItemCreateManyMiddleCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemUpdateWithWhereUniqueWithoutMiddleCategoryInput>>;
  updateMany?: InputMaybe<Array<ItemUpdateManyWithWhereWithoutMiddleCategoryInput>>;
  upsert?: InputMaybe<Array<ItemUpsertWithWhereUniqueWithoutMiddleCategoryInput>>;
};

export type ItemUpdateManyWithoutSmallCategoryNestedInput = {
  connect?: InputMaybe<Array<ItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ItemCreateOrConnectWithoutSmallCategoryInput>>;
  create?: InputMaybe<Array<ItemCreateWithoutSmallCategoryInput>>;
  createMany?: InputMaybe<ItemCreateManySmallCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ItemWhereUniqueInput>>;
  set?: InputMaybe<Array<ItemWhereUniqueInput>>;
  update?: InputMaybe<Array<ItemUpdateWithWhereUniqueWithoutSmallCategoryInput>>;
  updateMany?: InputMaybe<Array<ItemUpdateManyWithWhereWithoutSmallCategoryInput>>;
  upsert?: InputMaybe<Array<ItemUpsertWithWhereUniqueWithoutSmallCategoryInput>>;
};

export type ItemUpdateWithWhereUniqueWithoutLargeCategoryInput = {
  data: ItemUpdateWithoutLargeCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemUpdateWithWhereUniqueWithoutMiddleCategoryInput = {
  data: ItemUpdateWithoutMiddleCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemUpdateWithWhereUniqueWithoutSmallCategoryInput = {
  data: ItemUpdateWithoutSmallCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemUpdateWithoutLargeCategoryInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stockItems?: InputMaybe<StockItemUpdateManyWithoutItemNestedInput>;
  stockLocationCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ItemUpdateWithoutMiddleCategoryInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stockItems?: InputMaybe<StockItemUpdateManyWithoutItemNestedInput>;
  stockLocationCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ItemUpdateWithoutSmallCategoryInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  disabled?: InputMaybe<BoolFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<NullableBigIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  stockItems?: InputMaybe<StockItemUpdateManyWithoutItemNestedInput>;
  stockLocationCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type ItemUpsertWithWhereUniqueWithoutLargeCategoryInput = {
  create: ItemCreateWithoutLargeCategoryInput;
  update: ItemUpdateWithoutLargeCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemUpsertWithWhereUniqueWithoutMiddleCategoryInput = {
  create: ItemCreateWithoutMiddleCategoryInput;
  update: ItemUpdateWithoutMiddleCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemUpsertWithWhereUniqueWithoutSmallCategoryInput = {
  create: ItemCreateWithoutSmallCategoryInput;
  update: ItemUpdateWithoutSmallCategoryInput;
  where: ItemWhereUniqueInput;
};

export type ItemWhereInput = {
  AND?: InputMaybe<Array<ItemWhereInput>>;
  NOT?: InputMaybe<Array<ItemWhereInput>>;
  OR?: InputMaybe<Array<ItemWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  disabled?: InputMaybe<BoolFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntNullableFilter>;
  largeCategory?: InputMaybe<LargeCategoryRelationFilter>;
  largeCd?: InputMaybe<IntNullableFilter>;
  middleCategory?: InputMaybe<MiddleCategoryRelationFilter>;
  middleCd?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  smallCategory?: InputMaybe<SmallCategoryRelationFilter>;
  smallCd?: InputMaybe<IntNullableFilter>;
  stockItems?: InputMaybe<StockItemListRelationFilter>;
  stockLocationCd?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type ItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd?: InputMaybe<Scalars['BigInt']['input']>;
};

/**
 *
 * 大分類
 */
export type LargeCategory = {
  __typename?: 'LargeCategory';
  _count?: Maybe<LargeCategoryCount>;
  createdAt: Scalars['DateTime']['output'];
  /** 大分類ID */
  id: Scalars['Int']['output'];
  items: Array<Item>;
  /** 大分類コード（連携） */
  largeCd?: Maybe<Scalars['Int']['output']>;
  middleCategiries: Array<MiddleCategory>;
  /** 大分類名（連携） */
  name: Scalars['String']['output'];
  /** 大分類順番（連携） */
  seq?: Maybe<Scalars['Int']['output']>;
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


/**
 *
 * 大分類
 */
export type LargeCategoryItemsArgs = {
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemWhereInput>;
};


/**
 *
 * 大分類
 */
export type LargeCategoryMiddleCategiriesArgs = {
  cursor?: InputMaybe<MiddleCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<MiddleCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MiddleCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MiddleCategoryWhereInput>;
};

export type LargeCategoryCount = {
  __typename?: 'LargeCategoryCount';
  items: Scalars['Int']['output'];
  middleCategiries: Scalars['Int']['output'];
};


export type LargeCategoryCountItemsArgs = {
  where?: InputMaybe<ItemWhereInput>;
};


export type LargeCategoryCountMiddleCategiriesArgs = {
  where?: InputMaybe<MiddleCategoryWhereInput>;
};

export type LargeCategoryCreateInput = {
  largeCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type LargeCategoryCreateNestedOneWithoutItemsInput = {
  connect?: InputMaybe<LargeCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LargeCategoryCreateOrConnectWithoutItemsInput>;
  create?: InputMaybe<LargeCategoryCreateWithoutItemsInput>;
};

export type LargeCategoryCreateNestedOneWithoutMiddleCategiriesInput = {
  connect?: InputMaybe<LargeCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LargeCategoryCreateOrConnectWithoutMiddleCategiriesInput>;
  create?: InputMaybe<LargeCategoryCreateWithoutMiddleCategiriesInput>;
};

export type LargeCategoryCreateOrConnectWithoutItemsInput = {
  create: LargeCategoryCreateWithoutItemsInput;
  where: LargeCategoryWhereUniqueInput;
};

export type LargeCategoryCreateOrConnectWithoutMiddleCategiriesInput = {
  create: LargeCategoryCreateWithoutMiddleCategiriesInput;
  where: LargeCategoryWhereUniqueInput;
};

export type LargeCategoryCreateWithoutItemsInput = {
  largeCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type LargeCategoryCreateWithoutMiddleCategiriesInput = {
  largeCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type LargeCategoryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  items?: InputMaybe<ItemOrderByRelationAggregateInput>;
  largeCd?: InputMaybe<SortOrderInput>;
  middleCategiries?: InputMaybe<MiddleCategoryOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  seq?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
};

export type LargeCategoryRelationFilter = {
  is?: InputMaybe<LargeCategoryWhereInput>;
  isNot?: InputMaybe<LargeCategoryWhereInput>;
};

export enum LargeCategoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LargeCd = 'largeCd',
  Name = 'name',
  Seq = 'seq',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type LargeCategoryUpdateInput = {
  items?: InputMaybe<ItemUpdateManyWithoutLargeCategoryNestedInput>;
  largeCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  middleCategiries?: InputMaybe<MiddleCategoryUpdateManyWithoutLargeCategoryNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  seq?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type LargeCategoryUpdateManyMutationInput = {
  largeCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  seq?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type LargeCategoryWhereInput = {
  AND?: InputMaybe<Array<LargeCategoryWhereInput>>;
  NOT?: InputMaybe<Array<LargeCategoryWhereInput>>;
  OR?: InputMaybe<Array<LargeCategoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  items?: InputMaybe<ItemListRelationFilter>;
  largeCd?: InputMaybe<IntNullableFilter>;
  middleCategiries?: InputMaybe<MiddleCategoryListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  seq?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type LargeCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  largeCd?: InputMaybe<Scalars['Int']['input']>;
};

/**
 *
 * 中分類
 */
export type MiddleCategory = {
  __typename?: 'MiddleCategory';
  _count?: Maybe<MiddleCategoryCount>;
  createdAt: Scalars['DateTime']['output'];
  /** 中分類ID */
  id: Scalars['Int']['output'];
  items: Array<Item>;
  /** 大分類 */
  largeCategory?: Maybe<LargeCategory>;
  /** 大分類コード（連携） */
  largeCd?: Maybe<Scalars['Int']['output']>;
  /** 中分類コード（連携） */
  middleCd?: Maybe<Scalars['Int']['output']>;
  /** 中分類名（連携） */
  name: Scalars['String']['output'];
  /** 中分類順番（連携） */
  seq?: Maybe<Scalars['Int']['output']>;
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


/**
 *
 * 中分類
 */
export type MiddleCategoryItemsArgs = {
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemWhereInput>;
};

export type MiddleCategoryCount = {
  __typename?: 'MiddleCategoryCount';
  items: Scalars['Int']['output'];
};


export type MiddleCategoryCountItemsArgs = {
  where?: InputMaybe<ItemWhereInput>;
};

export type MiddleCategoryCreateInput = {
  largeCategory?: InputMaybe<LargeCategoryCreateNestedOneWithoutMiddleCategiriesInput>;
  middleCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type MiddleCategoryCreateManyLargeCategoryInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  middleCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type MiddleCategoryCreateManyLargeCategoryInputEnvelope = {
  data: Array<MiddleCategoryCreateManyLargeCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MiddleCategoryCreateNestedOneWithoutItemsInput = {
  connect?: InputMaybe<MiddleCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<MiddleCategoryCreateOrConnectWithoutItemsInput>;
  create?: InputMaybe<MiddleCategoryCreateWithoutItemsInput>;
};

export type MiddleCategoryCreateOrConnectWithoutItemsInput = {
  create: MiddleCategoryCreateWithoutItemsInput;
  where: MiddleCategoryWhereUniqueInput;
};

export type MiddleCategoryCreateOrConnectWithoutLargeCategoryInput = {
  create: MiddleCategoryCreateWithoutLargeCategoryInput;
  where: MiddleCategoryWhereUniqueInput;
};

export type MiddleCategoryCreateWithoutItemsInput = {
  largeCategory?: InputMaybe<LargeCategoryCreateNestedOneWithoutMiddleCategiriesInput>;
  middleCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type MiddleCategoryCreateWithoutLargeCategoryInput = {
  middleCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type MiddleCategoryLargeCdMiddleCdCompoundUniqueInput = {
  largeCd: Scalars['Int']['input'];
  middleCd: Scalars['Int']['input'];
};

export type MiddleCategoryListRelationFilter = {
  every?: InputMaybe<MiddleCategoryWhereInput>;
  none?: InputMaybe<MiddleCategoryWhereInput>;
  some?: InputMaybe<MiddleCategoryWhereInput>;
};

export type MiddleCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MiddleCategoryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  items?: InputMaybe<ItemOrderByRelationAggregateInput>;
  largeCategory?: InputMaybe<LargeCategoryOrderByWithRelationInput>;
  largeCd?: InputMaybe<SortOrderInput>;
  middleCd?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  seq?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
};

export type MiddleCategoryRelationFilter = {
  is?: InputMaybe<MiddleCategoryWhereInput>;
  isNot?: InputMaybe<MiddleCategoryWhereInput>;
};

export enum MiddleCategoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LargeCd = 'largeCd',
  MiddleCd = 'middleCd',
  Name = 'name',
  Seq = 'seq',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type MiddleCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<MiddleCategoryScalarWhereInput>>;
  NOT?: InputMaybe<Array<MiddleCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<MiddleCategoryScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  largeCd?: InputMaybe<IntNullableFilter>;
  middleCd?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  seq?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type MiddleCategoryUpdateInput = {
  items?: InputMaybe<ItemUpdateManyWithoutMiddleCategoryNestedInput>;
  middleCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  seq?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MiddleCategoryUpdateManyMutationInput = {
  middleCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  seq?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MiddleCategoryUpdateManyWithWhereWithoutLargeCategoryInput = {
  data: MiddleCategoryUpdateManyMutationInput;
  where: MiddleCategoryScalarWhereInput;
};

export type MiddleCategoryUpdateManyWithoutLargeCategoryNestedInput = {
  connect?: InputMaybe<Array<MiddleCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MiddleCategoryCreateOrConnectWithoutLargeCategoryInput>>;
  create?: InputMaybe<Array<MiddleCategoryCreateWithoutLargeCategoryInput>>;
  createMany?: InputMaybe<MiddleCategoryCreateManyLargeCategoryInputEnvelope>;
  delete?: InputMaybe<Array<MiddleCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MiddleCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MiddleCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<MiddleCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<MiddleCategoryUpdateWithWhereUniqueWithoutLargeCategoryInput>>;
  updateMany?: InputMaybe<Array<MiddleCategoryUpdateManyWithWhereWithoutLargeCategoryInput>>;
  upsert?: InputMaybe<Array<MiddleCategoryUpsertWithWhereUniqueWithoutLargeCategoryInput>>;
};

export type MiddleCategoryUpdateWithWhereUniqueWithoutLargeCategoryInput = {
  data: MiddleCategoryUpdateWithoutLargeCategoryInput;
  where: MiddleCategoryWhereUniqueInput;
};

export type MiddleCategoryUpdateWithoutLargeCategoryInput = {
  items?: InputMaybe<ItemUpdateManyWithoutMiddleCategoryNestedInput>;
  middleCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  seq?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type MiddleCategoryUpsertWithWhereUniqueWithoutLargeCategoryInput = {
  create: MiddleCategoryCreateWithoutLargeCategoryInput;
  update: MiddleCategoryUpdateWithoutLargeCategoryInput;
  where: MiddleCategoryWhereUniqueInput;
};

export type MiddleCategoryWhereInput = {
  AND?: InputMaybe<Array<MiddleCategoryWhereInput>>;
  NOT?: InputMaybe<Array<MiddleCategoryWhereInput>>;
  OR?: InputMaybe<Array<MiddleCategoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  items?: InputMaybe<ItemListRelationFilter>;
  largeCategory?: InputMaybe<LargeCategoryRelationFilter>;
  largeCd?: InputMaybe<IntNullableFilter>;
  middleCd?: InputMaybe<IntNullableFilter>;
  name?: InputMaybe<StringFilter>;
  seq?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type MiddleCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  largeCd_middleCd?: InputMaybe<MiddleCategoryLargeCdMiddleCdCompoundUniqueInput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  codeVerify: CodeVerifyResponse;
  createOneAnnounce: Announce;
  createOneBillingAddress: BillingAddress;
  createOneCartItem: CartItem;
  createOneCustomer: Customer;
  createOneDeliveryAddress: DeliveryAddress;
  createOneItem: Item;
  createOneLargeCategory: LargeCategory;
  createOneMiddleCategory: MiddleCategory;
  createOneOrder: Order;
  createOneOrderDetail: OrderDetail;
  createOneOrderRequest: OrderRequest;
  createOneOrderRequestDetail: OrderRequestDetail;
  createOneSmallCategory: SmallCategory;
  createOneStaff: Staff;
  createOneStockItem: StockItem;
  createOneStockItemUnitPrice: StockItemUnitPrice;
  createOneSystemSetting: SystemSetting;
  createOneWishlistItem: WishlistItem;
  deleteManyCartItem: AffectedRowsOutput;
  deleteManyWishlistItem: AffectedRowsOutput;
  deleteOneAnnounce?: Maybe<Announce>;
  deleteOneBillingAddress?: Maybe<BillingAddress>;
  deleteOneCartItem?: Maybe<CartItem>;
  deleteOneCustomer?: Maybe<Customer>;
  deleteOneDeliveryAddress?: Maybe<DeliveryAddress>;
  deleteOneItem?: Maybe<Item>;
  deleteOneLargeCategory?: Maybe<LargeCategory>;
  deleteOneMiddleCategory?: Maybe<MiddleCategory>;
  deleteOneOrder?: Maybe<Order>;
  deleteOneOrderDetail?: Maybe<OrderDetail>;
  deleteOneOrderRequest?: Maybe<OrderRequest>;
  deleteOneOrderRequestDetail?: Maybe<OrderRequestDetail>;
  deleteOneSmallCategory?: Maybe<SmallCategory>;
  deleteOneStaff?: Maybe<Staff>;
  deleteOneStockItem?: Maybe<StockItem>;
  deleteOneStockItemUnitPrice?: Maybe<StockItemUnitPrice>;
  deleteOneSystemSetting?: Maybe<SystemSetting>;
  deleteOneWishlistItem?: Maybe<WishlistItem>;
  sendOrderRequest: SendOrderRequestResponse;
  sendVerificationCode: SendVerificationCodeResponse;
  updateManyAnnounce: AffectedRowsOutput;
  updateManyBillingAddress: AffectedRowsOutput;
  updateManyCartItem: AffectedRowsOutput;
  updateManyCustomer: AffectedRowsOutput;
  updateManyDeliveryAddress: AffectedRowsOutput;
  updateManyItem: AffectedRowsOutput;
  updateManyLargeCategory: AffectedRowsOutput;
  updateManyMiddleCategory: AffectedRowsOutput;
  updateManyOrder: AffectedRowsOutput;
  updateManyOrderDetail: AffectedRowsOutput;
  updateManyOrderRequest: AffectedRowsOutput;
  updateManyOrderRequestDetail: AffectedRowsOutput;
  updateManySmallCategory: AffectedRowsOutput;
  updateManyStaff: AffectedRowsOutput;
  updateManyStockItem: AffectedRowsOutput;
  updateManyStockItemUnitPrice: AffectedRowsOutput;
  updateManySystemSetting: AffectedRowsOutput;
  updateManyWishlistItem: AffectedRowsOutput;
  updateOneAnnounce?: Maybe<Announce>;
  updateOneBillingAddress?: Maybe<BillingAddress>;
  updateOneCartItem?: Maybe<CartItem>;
  updateOneCustomer: Customer;
  updateOneDeliveryAddress?: Maybe<DeliveryAddress>;
  updateOneItem?: Maybe<Item>;
  updateOneLargeCategory?: Maybe<LargeCategory>;
  updateOneMiddleCategory?: Maybe<MiddleCategory>;
  updateOneOrder?: Maybe<Order>;
  updateOneOrderDetail?: Maybe<OrderDetail>;
  updateOneOrderRequest?: Maybe<OrderRequest>;
  updateOneOrderRequestDetail?: Maybe<OrderRequestDetail>;
  updateOneSmallCategory?: Maybe<SmallCategory>;
  updateOneStaff?: Maybe<Staff>;
  updateOneStockItem?: Maybe<StockItem>;
  updateOneStockItemUnitPrice?: Maybe<StockItemUnitPrice>;
  updateOneSystemSetting?: Maybe<SystemSetting>;
  updateOneWishlistItem?: Maybe<WishlistItem>;
};


export type MutationCodeVerifyArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationCreateOneAnnounceArgs = {
  data: AnnounceCreateInput;
};


export type MutationCreateOneBillingAddressArgs = {
  data: BillingAddressCreateInput;
};


export type MutationCreateOneCartItemArgs = {
  data: CartItemCreateInput;
};


export type MutationCreateOneCustomerArgs = {
  data: CustomerCreateInput;
};


export type MutationCreateOneDeliveryAddressArgs = {
  data: DeliveryAddressCreateInput;
};


export type MutationCreateOneItemArgs = {
  data: ItemCreateInput;
};


export type MutationCreateOneLargeCategoryArgs = {
  data: LargeCategoryCreateInput;
};


export type MutationCreateOneMiddleCategoryArgs = {
  data: MiddleCategoryCreateInput;
};


export type MutationCreateOneOrderArgs = {
  data: OrderCreateInput;
};


export type MutationCreateOneOrderDetailArgs = {
  data: OrderDetailCreateInput;
};


export type MutationCreateOneOrderRequestArgs = {
  data: OrderRequestCreateInput;
};


export type MutationCreateOneOrderRequestDetailArgs = {
  data: OrderRequestDetailCreateInput;
};


export type MutationCreateOneSmallCategoryArgs = {
  data: SmallCategoryCreateInput;
};


export type MutationCreateOneStaffArgs = {
  data: StaffCreateInput;
};


export type MutationCreateOneStockItemArgs = {
  data: StockItemCreateInput;
};


export type MutationCreateOneStockItemUnitPriceArgs = {
  data: StockItemUnitPriceCreateInput;
};


export type MutationCreateOneSystemSettingArgs = {
  data: SystemSettingCreateInput;
};


export type MutationCreateOneWishlistItemArgs = {
  data: WishlistItemCreateInput;
};


export type MutationDeleteManyCartItemArgs = {
  where?: InputMaybe<CartItemWhereInput>;
};


export type MutationDeleteManyWishlistItemArgs = {
  where?: InputMaybe<WishlistItemWhereInput>;
};


export type MutationDeleteOneAnnounceArgs = {
  where: AnnounceWhereUniqueInput;
};


export type MutationDeleteOneBillingAddressArgs = {
  where: BillingAddressWhereUniqueInput;
};


export type MutationDeleteOneCartItemArgs = {
  where: CartItemWhereUniqueInput;
};


export type MutationDeleteOneCustomerArgs = {
  where: CustomerWhereUniqueInput;
};


export type MutationDeleteOneDeliveryAddressArgs = {
  where: DeliveryAddressWhereUniqueInput;
};


export type MutationDeleteOneItemArgs = {
  where: ItemWhereUniqueInput;
};


export type MutationDeleteOneLargeCategoryArgs = {
  where: LargeCategoryWhereUniqueInput;
};


export type MutationDeleteOneMiddleCategoryArgs = {
  where: MiddleCategoryWhereUniqueInput;
};


export type MutationDeleteOneOrderArgs = {
  where: OrderWhereUniqueInput;
};


export type MutationDeleteOneOrderDetailArgs = {
  where: OrderDetailWhereUniqueInput;
};


export type MutationDeleteOneOrderRequestArgs = {
  where: OrderRequestWhereUniqueInput;
};


export type MutationDeleteOneOrderRequestDetailArgs = {
  where: OrderRequestDetailWhereUniqueInput;
};


export type MutationDeleteOneSmallCategoryArgs = {
  where: SmallCategoryWhereUniqueInput;
};


export type MutationDeleteOneStaffArgs = {
  where: StaffWhereUniqueInput;
};


export type MutationDeleteOneStockItemArgs = {
  where: StockItemWhereUniqueInput;
};


export type MutationDeleteOneStockItemUnitPriceArgs = {
  where: StockItemUnitPriceWhereUniqueInput;
};


export type MutationDeleteOneSystemSettingArgs = {
  where: SystemSettingWhereUniqueInput;
};


export type MutationDeleteOneWishlistItemArgs = {
  where: WishlistItemWhereUniqueInput;
};


export type MutationSendOrderRequestArgs = {
  customerName: Scalars['String']['input'];
  details: Array<SendOrderRequestDetailInput>;
  itemQuantity: Scalars['String']['input'];
  mailAddress: Scalars['String']['input'];
  orderDate: Scalars['String']['input'];
  orderRequestNo: Scalars['Int']['input'];
  staffName: Scalars['String']['input'];
  totalAmount: Scalars['String']['input'];
};


export type MutationSendVerificationCodeArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateManyAnnounceArgs = {
  data: AnnounceUpdateManyMutationInput;
  where?: InputMaybe<AnnounceWhereInput>;
};


export type MutationUpdateManyBillingAddressArgs = {
  data: BillingAddressUpdateManyMutationInput;
  where?: InputMaybe<BillingAddressWhereInput>;
};


export type MutationUpdateManyCartItemArgs = {
  data: CartItemUpdateManyMutationInput;
  where?: InputMaybe<CartItemWhereInput>;
};


export type MutationUpdateManyCustomerArgs = {
  data: CustomerUpdateManyMutationInput;
  where?: InputMaybe<CustomerWhereInput>;
};


export type MutationUpdateManyDeliveryAddressArgs = {
  data: DeliveryAddressUpdateManyMutationInput;
  where?: InputMaybe<DeliveryAddressWhereInput>;
};


export type MutationUpdateManyItemArgs = {
  data: ItemUpdateManyMutationInput;
  where?: InputMaybe<ItemWhereInput>;
};


export type MutationUpdateManyLargeCategoryArgs = {
  data: LargeCategoryUpdateManyMutationInput;
  where?: InputMaybe<LargeCategoryWhereInput>;
};


export type MutationUpdateManyMiddleCategoryArgs = {
  data: MiddleCategoryUpdateManyMutationInput;
  where?: InputMaybe<MiddleCategoryWhereInput>;
};


export type MutationUpdateManyOrderArgs = {
  data: OrderUpdateManyMutationInput;
  where?: InputMaybe<OrderWhereInput>;
};


export type MutationUpdateManyOrderDetailArgs = {
  data: OrderDetailUpdateManyMutationInput;
  where?: InputMaybe<OrderDetailWhereInput>;
};


export type MutationUpdateManyOrderRequestArgs = {
  data: OrderRequestUpdateManyMutationInput;
  where?: InputMaybe<OrderRequestWhereInput>;
};


export type MutationUpdateManyOrderRequestDetailArgs = {
  data: OrderRequestDetailUpdateManyMutationInput;
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};


export type MutationUpdateManySmallCategoryArgs = {
  data: SmallCategoryUpdateManyMutationInput;
  where?: InputMaybe<SmallCategoryWhereInput>;
};


export type MutationUpdateManyStaffArgs = {
  data: StaffUpdateManyMutationInput;
  where?: InputMaybe<StaffWhereInput>;
};


export type MutationUpdateManyStockItemArgs = {
  data: StockItemUpdateManyMutationInput;
  where?: InputMaybe<StockItemWhereInput>;
};


export type MutationUpdateManyStockItemUnitPriceArgs = {
  data: StockItemUnitPriceUpdateManyMutationInput;
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
};


export type MutationUpdateManySystemSettingArgs = {
  data: SystemSettingUpdateManyMutationInput;
  where?: InputMaybe<SystemSettingWhereInput>;
};


export type MutationUpdateManyWishlistItemArgs = {
  data: WishlistItemUpdateManyMutationInput;
  where?: InputMaybe<WishlistItemWhereInput>;
};


export type MutationUpdateOneAnnounceArgs = {
  data: AnnounceUpdateInput;
  where: AnnounceWhereUniqueInput;
};


export type MutationUpdateOneBillingAddressArgs = {
  data: BillingAddressUpdateInput;
  where: BillingAddressWhereUniqueInput;
};


export type MutationUpdateOneCartItemArgs = {
  data: CartItemUpdateInput;
  where: CartItemWhereUniqueInput;
};


export type MutationUpdateOneCustomerArgs = {
  data: DecoratedCustomerUpdateInput;
  where: CustomerWhereUniqueInput;
};


export type MutationUpdateOneDeliveryAddressArgs = {
  data: DeliveryAddressUpdateInput;
  where: DeliveryAddressWhereUniqueInput;
};


export type MutationUpdateOneItemArgs = {
  data: ItemUpdateInput;
  where: ItemWhereUniqueInput;
};


export type MutationUpdateOneLargeCategoryArgs = {
  data: LargeCategoryUpdateInput;
  where: LargeCategoryWhereUniqueInput;
};


export type MutationUpdateOneMiddleCategoryArgs = {
  data: MiddleCategoryUpdateInput;
  where: MiddleCategoryWhereUniqueInput;
};


export type MutationUpdateOneOrderArgs = {
  data: OrderUpdateInput;
  where: OrderWhereUniqueInput;
};


export type MutationUpdateOneOrderDetailArgs = {
  data: OrderDetailUpdateInput;
  where: OrderDetailWhereUniqueInput;
};


export type MutationUpdateOneOrderRequestArgs = {
  data: OrderRequestUpdateInput;
  where: OrderRequestWhereUniqueInput;
};


export type MutationUpdateOneOrderRequestDetailArgs = {
  data: OrderRequestDetailUpdateInput;
  where: OrderRequestDetailWhereUniqueInput;
};


export type MutationUpdateOneSmallCategoryArgs = {
  data: SmallCategoryUpdateInput;
  where: SmallCategoryWhereUniqueInput;
};


export type MutationUpdateOneStaffArgs = {
  data: StaffUpdateInput;
  where: StaffWhereUniqueInput;
};


export type MutationUpdateOneStockItemArgs = {
  data: StockItemUpdateInput;
  where: StockItemWhereUniqueInput;
};


export type MutationUpdateOneStockItemUnitPriceArgs = {
  data: StockItemUnitPriceUpdateInput;
  where: StockItemUnitPriceWhereUniqueInput;
};


export type MutationUpdateOneSystemSettingArgs = {
  data: SystemSettingUpdateInput;
  where: SystemSettingWhereUniqueInput;
};


export type MutationUpdateOneWishlistItemArgs = {
  data: WishlistItemUpdateInput;
  where: WishlistItemWhereUniqueInput;
};

export type NestedBigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBigIntNullableFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<NestedBigIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type NestedDecimalFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedDecimalNullableFilter = {
  equals?: InputMaybe<Scalars['Decimal']['input']>;
  gt?: InputMaybe<Scalars['Decimal']['input']>;
  gte?: InputMaybe<Scalars['Decimal']['input']>;
  in?: InputMaybe<Array<Scalars['Decimal']['input']>>;
  lt?: InputMaybe<Scalars['Decimal']['input']>;
  lte?: InputMaybe<Scalars['Decimal']['input']>;
  not?: InputMaybe<NestedDecimalNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Decimal']['input']>>;
};

export type NestedEnumOrderPackingFilter = {
  equals?: InputMaybe<OrderPacking>;
  in?: InputMaybe<Array<OrderPacking>>;
  not?: InputMaybe<NestedEnumOrderPackingFilter>;
  notIn?: InputMaybe<Array<OrderPacking>>;
};

export type NestedEnumOrderPackingNullableFilter = {
  equals?: InputMaybe<OrderPacking>;
  in?: InputMaybe<Array<OrderPacking>>;
  not?: InputMaybe<NestedEnumOrderPackingNullableFilter>;
  notIn?: InputMaybe<Array<OrderPacking>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type NullableBigIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['BigInt']['input']>;
  divide?: InputMaybe<Scalars['BigInt']['input']>;
  increment?: InputMaybe<Scalars['BigInt']['input']>;
  multiply?: InputMaybe<Scalars['BigInt']['input']>;
  set?: InputMaybe<Scalars['BigInt']['input']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NullableDecimalFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Decimal']['input']>;
  divide?: InputMaybe<Scalars['Decimal']['input']>;
  increment?: InputMaybe<Scalars['Decimal']['input']>;
  multiply?: InputMaybe<Scalars['Decimal']['input']>;
  set?: InputMaybe<Scalars['Decimal']['input']>;
};

export type NullableEnumOrderPackingFieldUpdateOperationsInput = {
  set?: InputMaybe<OrderPacking>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>;
  divide?: InputMaybe<Scalars['Int']['input']>;
  increment?: InputMaybe<Scalars['Int']['input']>;
  multiply?: InputMaybe<Scalars['Int']['input']>;
  set?: InputMaybe<Scalars['Int']['input']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

/**
 *
 * 注文
 */
export type Order = {
  __typename?: 'Order';
  _count?: Maybe<OrderCount>;
  /** 請求先住所（連携） */
  billingAddress?: Maybe<Scalars['String']['output']>;
  /** 請求先担当者名 */
  billingChargeName?: Maybe<Scalars['String']['output']>;
  /** 請求先名 */
  billingName?: Maybe<Scalars['String']['output']>;
  /** 請求先名カナ */
  billingNameKana?: Maybe<Scalars['String']['output']>;
  /** 請求先電話番号（連携） */
  billingPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** 請求先郵便番号（連携） */
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  /** 請求先都道府県 */
  billingPrefecture?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先CD（連携） */
  customerCd: Scalars['Int']['output'];
  /** 得意先担当者名（連携） */
  customerChargeName?: Maybe<Scalars['String']['output']>;
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** 得意先名称（連携） */
  customerName: Scalars['String']['output'];
  /** 配送先住所（連携） */
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  /** 配送先担当者名 */
  deliveryChargeName?: Maybe<Scalars['String']['output']>;
  /** 出荷日（希望納品日？） */
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** 配送先名 */
  deliveryName?: Maybe<Scalars['String']['output']>;
  /** 配送先名カナ */
  deliveryNameKana?: Maybe<Scalars['String']['output']>;
  /** 配送先電話番号（連携） */
  deliveryPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** 配送先郵便番号（連携） */
  deliveryPostalCode?: Maybe<Scalars['String']['output']>;
  /** 配送先都道府県 */
  deliveryPrefecture?: Maybe<Scalars['String']['output']>;
  /** 注文明細 */
  details: Array<OrderDetail>;
  /** 注文ID */
  id: Scalars['Int']['output'];
  /** 当日配送かどうか（0：指定無し　1：本日出荷） */
  isSameDayDelivery: Scalars['Boolean']['output'];
  /** 最低金額 */
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 注文完了日時（連携） */
  orderCompleteDate: Scalars['DateTime']['output'];
  /** 注文完了者（連携） */
  orderCompleteParsonName?: Maybe<Scalars['String']['output']>;
  /** 注文完了タイプ（連携） */
  orderCompleteType?: Maybe<Scalars['String']['output']>;
  /** 注文依頼日時（連携） */
  orderRequestDate: Scalars['DateTime']['output'];
  /** 注文依頼ID */
  orderRequestId?: Maybe<Scalars['Int']['output']>;
  /** 購入担当者 */
  staff?: Maybe<Staff>;
  /** 購入担当者ID（連携） */
  staffId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 *
 * 注文
 */
export type OrderDetailsArgs = {
  cursor?: InputMaybe<OrderDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderDetailWhereInput>;
};

export type OrderAvgAggregate = {
  __typename?: 'OrderAvgAggregate';
  customerCd?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  orderRequestId?: Maybe<Scalars['Float']['output']>;
  staffId?: Maybe<Scalars['Float']['output']>;
};

export type OrderCount = {
  __typename?: 'OrderCount';
  details: Scalars['Int']['output'];
};


export type OrderCountDetailsArgs = {
  where?: InputMaybe<OrderDetailWhereInput>;
};

export type OrderCountAggregate = {
  __typename?: 'OrderCountAggregate';
  _all: Scalars['Int']['output'];
  billingAddress: Scalars['Int']['output'];
  billingChargeName: Scalars['Int']['output'];
  billingName: Scalars['Int']['output'];
  billingNameKana: Scalars['Int']['output'];
  billingPhoneNumber: Scalars['Int']['output'];
  billingPostalCode: Scalars['Int']['output'];
  billingPrefecture: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerCd: Scalars['Int']['output'];
  customerChargeName: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['Int']['output'];
  deliveryAddress: Scalars['Int']['output'];
  deliveryChargeName: Scalars['Int']['output'];
  deliveryDate: Scalars['Int']['output'];
  deliveryName: Scalars['Int']['output'];
  deliveryNameKana: Scalars['Int']['output'];
  deliveryPhoneNumber: Scalars['Int']['output'];
  deliveryPostalCode: Scalars['Int']['output'];
  deliveryPrefecture: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSameDayDelivery: Scalars['Int']['output'];
  minimumOrderAmount: Scalars['Int']['output'];
  orderCompleteDate: Scalars['Int']['output'];
  orderCompleteParsonName: Scalars['Int']['output'];
  orderCompleteType: Scalars['Int']['output'];
  orderRequestDate: Scalars['Int']['output'];
  orderRequestId: Scalars['Int']['output'];
  staffId: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OrderCreateInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  customer: CustomerCreateNestedOneWithoutOrderInput;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<OrderDetailCreateNestedManyWithoutOrderInput>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderCompleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompleteParsonName?: InputMaybe<Scalars['String']['input']>;
  orderCompleteType?: InputMaybe<Scalars['String']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderRequestId?: InputMaybe<Scalars['Int']['input']>;
  staff?: InputMaybe<StaffCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateManyCustomerInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderCompleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompleteParsonName?: InputMaybe<Scalars['String']['input']>;
  orderCompleteType?: InputMaybe<Scalars['String']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderRequestId?: InputMaybe<Scalars['Int']['input']>;
  staffId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderCreateManyCustomerInputEnvelope = {
  data: Array<OrderCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateManyStaffInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['Int']['input'];
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderCompleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompleteParsonName?: InputMaybe<Scalars['String']['input']>;
  orderCompleteType?: InputMaybe<Scalars['String']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderRequestId?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderCreateManyStaffInputEnvelope = {
  data: Array<OrderCreateManyStaffInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderCreateNestedOneWithoutDetailsInput = {
  connect?: InputMaybe<OrderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderCreateOrConnectWithoutDetailsInput>;
  create?: InputMaybe<OrderCreateWithoutDetailsInput>;
};

export type OrderCreateOrConnectWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutDetailsInput = {
  create: OrderCreateWithoutDetailsInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateOrConnectWithoutStaffInput = {
  create: OrderCreateWithoutStaffInput;
  where: OrderWhereUniqueInput;
};

export type OrderCreateWithoutCustomerInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<OrderDetailCreateNestedManyWithoutOrderInput>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderCompleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompleteParsonName?: InputMaybe<Scalars['String']['input']>;
  orderCompleteType?: InputMaybe<Scalars['String']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderRequestId?: InputMaybe<Scalars['Int']['input']>;
  staff?: InputMaybe<StaffCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutDetailsInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  customer: CustomerCreateNestedOneWithoutOrderInput;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderCompleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompleteParsonName?: InputMaybe<Scalars['String']['input']>;
  orderCompleteType?: InputMaybe<Scalars['String']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderRequestId?: InputMaybe<Scalars['Int']['input']>;
  staff?: InputMaybe<StaffCreateNestedOneWithoutOrdersInput>;
};

export type OrderCreateWithoutStaffInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  customer: CustomerCreateNestedOneWithoutOrderInput;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<OrderDetailCreateNestedManyWithoutOrderInput>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderCompleteDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderCompleteParsonName?: InputMaybe<Scalars['String']['input']>;
  orderCompleteType?: InputMaybe<Scalars['String']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  orderRequestId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 *
 * 注文明細
 */
export type OrderDetail = {
  __typename?: 'OrderDetail';
  /** 確定税抜金額（連携） */
  amount: Scalars['Decimal']['output'];
  /** 商品在庫単価 - 原価 */
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース掛率 */
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱掛率 */
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - バラ掛率 */
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先備考（QA No.64）（連携） */
  customerNote?: Maybe<Scalars['String']['output']>;
  /** 得意先注文番号（連携） */
  customerOrderNo?: Maybe<Scalars['String']['output']>;
  /** 径（連携） */
  diameter: Scalars['String']['output'];
  /** 径CD（連携） */
  diameterCd: Scalars['Int']['output'];
  /** 注文明細ID */
  id: Scalars['Int']['output'];
  /** 商品CD（連携） */
  itemCd: Scalars['BigInt']['output'];
  /** 長さ（連携） */
  length: Scalars['String']['output'];
  /** 長さCD（連携） */
  lengthCd: Scalars['Int']['output'];
  /** 商品名（連携） */
  name: Scalars['String']['output'];
  /** 注文 */
  order: Order;
  /** 注文ID */
  orderId: Scalars['Int']['output'];
  /** 確定行番号（QA No.67）（連携） */
  orderLineNo: Scalars['Int']['output'];
  /** 注文依頼ID */
  orderRequestDetailId?: Maybe<Scalars['Int']['output']>;
  /** 確定荷姿（注文単位）（連携） */
  packing: OrderPacking;
  /** 荷姿 */
  packingStyle?: Maybe<Scalars['String']['output']>;
  /** 確定数量 */
  quantity: Scalars['Int']['output'];
  /** 商品在庫 - ケース入数 */
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫 - 小箱入数 */
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** 注文依頼 - 税抜金額 */
  requestAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 注文依頼 - 行番号（QA No.67） */
  requestLineNo?: Maybe<Scalars['Int']['output']>;
  /** 注文依頼 - 荷姿（注文単位） */
  requestPacking?: Maybe<OrderPacking>;
  /** 注文依頼 - 数量 */
  requestQuantity?: Maybe<Scalars['Int']['output']>;
  /** 注文依頼 - バラ数量 */
  requestTotalQuantity?: Maybe<Scalars['Int']['output']>;
  /** 注文依頼 - 単価 */
  requestUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品 短縮CD（連携） */
  shortCd?: Maybe<Scalars['Int']['output']>;
  /** サイズCD（連携） */
  sizeCd: Scalars['BigInt']['output'];
  /** サイズ名（連携） */
  sizeName: Scalars['String']['output'];
  /** 商品在庫 */
  stockItem?: Maybe<StockItem>;
  /** 商品在庫ID */
  stockItemId?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫単価 */
  stockItemUnitPrice?: Maybe<StockItemUnitPrice>;
  /** 商品在庫単価ID */
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  /** 確定バラ数量 */
  totalQuantity: Scalars['Int']['output'];
  /** 確定単価（連携） */
  unitPrice: Scalars['Decimal']['output'];
  /** 商品在庫単価 - バラ単価 */
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース単価 */
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱単価 */
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderDetailCreateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutDetailsInput;
  orderLineNo?: InputMaybe<Scalars['Int']['input']>;
  orderRequestDetailId?: InputMaybe<Scalars['Int']['input']>;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  requestPacking?: InputMaybe<OrderPacking>;
  requestQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestTotalQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutOrderDetailInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutOrderDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderDetailCreateManyOrderInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderLineNo?: InputMaybe<Scalars['Int']['input']>;
  orderRequestDetailId?: InputMaybe<Scalars['Int']['input']>;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  requestPacking?: InputMaybe<OrderPacking>;
  requestQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestTotalQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderDetailCreateManyOrderInputEnvelope = {
  data: Array<OrderDetailCreateManyOrderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderDetailCreateManyStockItemInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  orderLineNo?: InputMaybe<Scalars['Int']['input']>;
  orderRequestDetailId?: InputMaybe<Scalars['Int']['input']>;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  requestPacking?: InputMaybe<OrderPacking>;
  requestQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestTotalQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderDetailCreateManyStockItemInputEnvelope = {
  data: Array<OrderDetailCreateManyStockItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderDetailCreateManyStockItemUnitPriceInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderId: Scalars['Int']['input'];
  orderLineNo?: InputMaybe<Scalars['Int']['input']>;
  orderRequestDetailId?: InputMaybe<Scalars['Int']['input']>;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  requestPacking?: InputMaybe<OrderPacking>;
  requestQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestTotalQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderDetailCreateManyStockItemUnitPriceInputEnvelope = {
  data: Array<OrderDetailCreateManyStockItemUnitPriceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderDetailCreateNestedManyWithoutOrderInput = {
  connect?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderDetailCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderDetailCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderDetailCreateManyOrderInputEnvelope>;
};

export type OrderDetailCreateOrConnectWithoutOrderInput = {
  create: OrderDetailCreateWithoutOrderInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailCreateOrConnectWithoutStockItemInput = {
  create: OrderDetailCreateWithoutStockItemInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailCreateOrConnectWithoutStockItemUnitPriceInput = {
  create: OrderDetailCreateWithoutStockItemUnitPriceInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailCreateWithoutOrderInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderLineNo?: InputMaybe<Scalars['Int']['input']>;
  orderRequestDetailId?: InputMaybe<Scalars['Int']['input']>;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  requestPacking?: InputMaybe<OrderPacking>;
  requestQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestTotalQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutOrderDetailInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutOrderDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderDetailCreateWithoutStockItemInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutDetailsInput;
  orderLineNo?: InputMaybe<Scalars['Int']['input']>;
  orderRequestDetailId?: InputMaybe<Scalars['Int']['input']>;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  requestPacking?: InputMaybe<OrderPacking>;
  requestQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestTotalQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutOrderDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderDetailCreateWithoutStockItemUnitPriceInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  order: OrderCreateNestedOneWithoutDetailsInput;
  orderLineNo?: InputMaybe<Scalars['Int']['input']>;
  orderRequestDetailId?: InputMaybe<Scalars['Int']['input']>;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestAmount?: InputMaybe<Scalars['Decimal']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  requestPacking?: InputMaybe<OrderPacking>;
  requestQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestTotalQuantity?: InputMaybe<Scalars['Int']['input']>;
  requestUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutOrderDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderDetailListRelationFilter = {
  every?: InputMaybe<OrderDetailWhereInput>;
  none?: InputMaybe<OrderDetailWhereInput>;
  some?: InputMaybe<OrderDetailWhereInput>;
};

export type OrderDetailOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderDetailOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  costPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerNote?: InputMaybe<SortOrderInput>;
  customerOrderNo?: InputMaybe<SortOrderInput>;
  diameter?: InputMaybe<SortOrder>;
  diameterCd?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  itemCd?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  lengthCd?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  order?: InputMaybe<OrderOrderByWithRelationInput>;
  orderId?: InputMaybe<SortOrder>;
  orderLineNo?: InputMaybe<SortOrder>;
  orderRequestDetailId?: InputMaybe<SortOrderInput>;
  packing?: InputMaybe<SortOrder>;
  packingStyle?: InputMaybe<SortOrderInput>;
  quantity?: InputMaybe<SortOrder>;
  quantityParCaseOfStockItem?: InputMaybe<SortOrderInput>;
  quantityParPackOfStockItem?: InputMaybe<SortOrderInput>;
  requestAmount?: InputMaybe<SortOrderInput>;
  requestLineNo?: InputMaybe<SortOrderInput>;
  requestPacking?: InputMaybe<SortOrderInput>;
  requestQuantity?: InputMaybe<SortOrderInput>;
  requestTotalQuantity?: InputMaybe<SortOrderInput>;
  requestUnitPrice?: InputMaybe<SortOrderInput>;
  shortCd?: InputMaybe<SortOrderInput>;
  sizeCd?: InputMaybe<SortOrder>;
  sizeName?: InputMaybe<SortOrder>;
  stockItem?: InputMaybe<StockItemOrderByWithRelationInput>;
  stockItemId?: InputMaybe<SortOrderInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceOrderByWithRelationInput>;
  stockItemUnitPriceId?: InputMaybe<SortOrderInput>;
  totalQuantity?: InputMaybe<SortOrder>;
  unitPrice?: InputMaybe<SortOrder>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum OrderDetailScalarFieldEnum {
  Amount = 'amount',
  CostPriceOfStockItemUnitPrice = 'costPriceOfStockItemUnitPrice',
  CostRateOfCaseOfStockItemUnitPrice = 'costRateOfCaseOfStockItemUnitPrice',
  CostRateOfPackOfStockItemUnitPrice = 'costRateOfPackOfStockItemUnitPrice',
  CostRateOfStockItemUnitPrice = 'costRateOfStockItemUnitPrice',
  CreatedAt = 'createdAt',
  CustomerNote = 'customerNote',
  CustomerOrderNo = 'customerOrderNo',
  Diameter = 'diameter',
  DiameterCd = 'diameterCd',
  Id = 'id',
  ItemCd = 'itemCd',
  Length = 'length',
  LengthCd = 'lengthCd',
  Name = 'name',
  OrderId = 'orderId',
  OrderLineNo = 'orderLineNo',
  OrderRequestDetailId = 'orderRequestDetailId',
  Packing = 'packing',
  PackingStyle = 'packingStyle',
  Quantity = 'quantity',
  QuantityParCaseOfStockItem = 'quantityParCaseOfStockItem',
  QuantityParPackOfStockItem = 'quantityParPackOfStockItem',
  RequestAmount = 'requestAmount',
  RequestLineNo = 'requestLineNo',
  RequestPacking = 'requestPacking',
  RequestQuantity = 'requestQuantity',
  RequestTotalQuantity = 'requestTotalQuantity',
  RequestUnitPrice = 'requestUnitPrice',
  ShortCd = 'shortCd',
  SizeCd = 'sizeCd',
  SizeName = 'sizeName',
  StockItemId = 'stockItemId',
  StockItemUnitPriceId = 'stockItemUnitPriceId',
  TotalQuantity = 'totalQuantity',
  UnitPrice = 'unitPrice',
  UnitPriceOfStockItemUnitPrice = 'unitPriceOfStockItemUnitPrice',
  UnitPriceParCaseOfStockItemUnitPrice = 'unitPriceParCaseOfStockItemUnitPrice',
  UnitPriceParPackOfStockItemUnitPrice = 'unitPriceParPackOfStockItemUnitPrice',
  UpdatedAt = 'updatedAt'
}

export type OrderDetailScalarWhereInput = {
  AND?: InputMaybe<Array<OrderDetailScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderDetailScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderDetailScalarWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerNote?: InputMaybe<StringNullableFilter>;
  customerOrderNo?: InputMaybe<StringNullableFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderLineNo?: InputMaybe<IntFilter>;
  orderRequestDetailId?: InputMaybe<IntNullableFilter>;
  packing?: InputMaybe<EnumOrderPackingFilter>;
  packingStyle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  requestAmount?: InputMaybe<DecimalNullableFilter>;
  requestLineNo?: InputMaybe<IntNullableFilter>;
  requestPacking?: InputMaybe<EnumOrderPackingNullableFilter>;
  requestQuantity?: InputMaybe<IntNullableFilter>;
  requestTotalQuantity?: InputMaybe<IntNullableFilter>;
  requestUnitPrice?: InputMaybe<DecimalNullableFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  totalQuantity?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderDetailUpdateInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  orderRequestDetailId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestPacking?: InputMaybe<NullableEnumOrderPackingFieldUpdateOperationsInput>;
  requestQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestTotalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderDetailUpdateManyMutationInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  orderRequestDetailId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestPacking?: InputMaybe<NullableEnumOrderPackingFieldUpdateOperationsInput>;
  requestQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestTotalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderDetailUpdateManyWithWhereWithoutOrderInput = {
  data: OrderDetailUpdateManyMutationInput;
  where: OrderDetailScalarWhereInput;
};

export type OrderDetailUpdateManyWithWhereWithoutStockItemInput = {
  data: OrderDetailUpdateManyMutationInput;
  where: OrderDetailScalarWhereInput;
};

export type OrderDetailUpdateManyWithWhereWithoutStockItemUnitPriceInput = {
  data: OrderDetailUpdateManyMutationInput;
  where: OrderDetailScalarWhereInput;
};

export type OrderDetailUpdateManyWithoutOrderNestedInput = {
  connect?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderDetailCreateOrConnectWithoutOrderInput>>;
  create?: InputMaybe<Array<OrderDetailCreateWithoutOrderInput>>;
  createMany?: InputMaybe<OrderDetailCreateManyOrderInputEnvelope>;
  delete?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderDetailUpdateWithWhereUniqueWithoutOrderInput>>;
  updateMany?: InputMaybe<Array<OrderDetailUpdateManyWithWhereWithoutOrderInput>>;
  upsert?: InputMaybe<Array<OrderDetailUpsertWithWhereUniqueWithoutOrderInput>>;
};

export type OrderDetailUpdateManyWithoutStockItemNestedInput = {
  connect?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderDetailCreateOrConnectWithoutStockItemInput>>;
  create?: InputMaybe<Array<OrderDetailCreateWithoutStockItemInput>>;
  createMany?: InputMaybe<OrderDetailCreateManyStockItemInputEnvelope>;
  delete?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderDetailUpdateWithWhereUniqueWithoutStockItemInput>>;
  updateMany?: InputMaybe<Array<OrderDetailUpdateManyWithWhereWithoutStockItemInput>>;
  upsert?: InputMaybe<Array<OrderDetailUpsertWithWhereUniqueWithoutStockItemInput>>;
};

export type OrderDetailUpdateManyWithoutStockItemUnitPriceNestedInput = {
  connect?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderDetailCreateOrConnectWithoutStockItemUnitPriceInput>>;
  create?: InputMaybe<Array<OrderDetailCreateWithoutStockItemUnitPriceInput>>;
  createMany?: InputMaybe<OrderDetailCreateManyStockItemUnitPriceInputEnvelope>;
  delete?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderDetailUpdateWithWhereUniqueWithoutStockItemUnitPriceInput>>;
  updateMany?: InputMaybe<Array<OrderDetailUpdateManyWithWhereWithoutStockItemUnitPriceInput>>;
  upsert?: InputMaybe<Array<OrderDetailUpsertWithWhereUniqueWithoutStockItemUnitPriceInput>>;
};

export type OrderDetailUpdateWithWhereUniqueWithoutOrderInput = {
  data: OrderDetailUpdateWithoutOrderInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailUpdateWithWhereUniqueWithoutStockItemInput = {
  data: OrderDetailUpdateWithoutStockItemInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailUpdateWithWhereUniqueWithoutStockItemUnitPriceInput = {
  data: OrderDetailUpdateWithoutStockItemUnitPriceInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailUpdateWithoutOrderInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  orderRequestDetailId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestPacking?: InputMaybe<NullableEnumOrderPackingFieldUpdateOperationsInput>;
  requestQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestTotalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderDetailUpdateWithoutStockItemInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  orderRequestDetailId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestPacking?: InputMaybe<NullableEnumOrderPackingFieldUpdateOperationsInput>;
  requestQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestTotalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderDetailUpdateWithoutStockItemUnitPriceInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  orderRequestDetailId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestPacking?: InputMaybe<NullableEnumOrderPackingFieldUpdateOperationsInput>;
  requestQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestTotalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderDetailUpsertWithWhereUniqueWithoutOrderInput = {
  create: OrderDetailCreateWithoutOrderInput;
  update: OrderDetailUpdateWithoutOrderInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailUpsertWithWhereUniqueWithoutStockItemInput = {
  create: OrderDetailCreateWithoutStockItemInput;
  update: OrderDetailUpdateWithoutStockItemInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailUpsertWithWhereUniqueWithoutStockItemUnitPriceInput = {
  create: OrderDetailCreateWithoutStockItemUnitPriceInput;
  update: OrderDetailUpdateWithoutStockItemUnitPriceInput;
  where: OrderDetailWhereUniqueInput;
};

export type OrderDetailWhereInput = {
  AND?: InputMaybe<Array<OrderDetailWhereInput>>;
  NOT?: InputMaybe<Array<OrderDetailWhereInput>>;
  OR?: InputMaybe<Array<OrderDetailWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerNote?: InputMaybe<StringNullableFilter>;
  customerOrderNo?: InputMaybe<StringNullableFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  order?: InputMaybe<OrderRelationFilter>;
  orderId?: InputMaybe<IntFilter>;
  orderLineNo?: InputMaybe<IntFilter>;
  orderRequestDetailId?: InputMaybe<IntNullableFilter>;
  packing?: InputMaybe<EnumOrderPackingFilter>;
  packingStyle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  requestAmount?: InputMaybe<DecimalNullableFilter>;
  requestLineNo?: InputMaybe<IntNullableFilter>;
  requestPacking?: InputMaybe<EnumOrderPackingNullableFilter>;
  requestQuantity?: InputMaybe<IntNullableFilter>;
  requestTotalQuantity?: InputMaybe<IntNullableFilter>;
  requestUnitPrice?: InputMaybe<DecimalNullableFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  stockItem?: InputMaybe<StockItemRelationFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceRelationFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  totalQuantity?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderListRelationFilter = {
  every?: InputMaybe<OrderWhereInput>;
  none?: InputMaybe<OrderWhereInput>;
  some?: InputMaybe<OrderWhereInput>;
};

export type OrderMaxAggregate = {
  __typename?: 'OrderMaxAggregate';
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingChargeName?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingNameKana?: Maybe<Scalars['String']['output']>;
  billingPhoneNumber?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingPrefecture?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerCd?: Maybe<Scalars['Int']['output']>;
  customerChargeName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryChargeName?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryName?: Maybe<Scalars['String']['output']>;
  deliveryNameKana?: Maybe<Scalars['String']['output']>;
  deliveryPhoneNumber?: Maybe<Scalars['String']['output']>;
  deliveryPostalCode?: Maybe<Scalars['String']['output']>;
  deliveryPrefecture?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSameDayDelivery?: Maybe<Scalars['Boolean']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  orderCompleteDate?: Maybe<Scalars['DateTime']['output']>;
  orderCompleteParsonName?: Maybe<Scalars['String']['output']>;
  orderCompleteType?: Maybe<Scalars['String']['output']>;
  orderRequestDate?: Maybe<Scalars['DateTime']['output']>;
  orderRequestId?: Maybe<Scalars['Int']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderMinAggregate = {
  __typename?: 'OrderMinAggregate';
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingChargeName?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingNameKana?: Maybe<Scalars['String']['output']>;
  billingPhoneNumber?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingPrefecture?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerCd?: Maybe<Scalars['Int']['output']>;
  customerChargeName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryChargeName?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryName?: Maybe<Scalars['String']['output']>;
  deliveryNameKana?: Maybe<Scalars['String']['output']>;
  deliveryPhoneNumber?: Maybe<Scalars['String']['output']>;
  deliveryPostalCode?: Maybe<Scalars['String']['output']>;
  deliveryPrefecture?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSameDayDelivery?: Maybe<Scalars['Boolean']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  orderCompleteDate?: Maybe<Scalars['DateTime']['output']>;
  orderCompleteParsonName?: Maybe<Scalars['String']['output']>;
  orderCompleteType?: Maybe<Scalars['String']['output']>;
  orderRequestDate?: Maybe<Scalars['DateTime']['output']>;
  orderRequestId?: Maybe<Scalars['Int']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderOrderByWithRelationInput = {
  billingAddress?: InputMaybe<SortOrderInput>;
  billingChargeName?: InputMaybe<SortOrderInput>;
  billingName?: InputMaybe<SortOrderInput>;
  billingNameKana?: InputMaybe<SortOrderInput>;
  billingPhoneNumber?: InputMaybe<SortOrderInput>;
  billingPostalCode?: InputMaybe<SortOrderInput>;
  billingPrefecture?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerCd?: InputMaybe<SortOrder>;
  customerChargeName?: InputMaybe<SortOrderInput>;
  customerId?: InputMaybe<SortOrder>;
  customerName?: InputMaybe<SortOrder>;
  deliveryAddress?: InputMaybe<SortOrderInput>;
  deliveryChargeName?: InputMaybe<SortOrderInput>;
  deliveryDate?: InputMaybe<SortOrderInput>;
  deliveryName?: InputMaybe<SortOrderInput>;
  deliveryNameKana?: InputMaybe<SortOrderInput>;
  deliveryPhoneNumber?: InputMaybe<SortOrderInput>;
  deliveryPostalCode?: InputMaybe<SortOrderInput>;
  deliveryPrefecture?: InputMaybe<SortOrderInput>;
  details?: InputMaybe<OrderDetailOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isSameDayDelivery?: InputMaybe<SortOrder>;
  minimumOrderAmount?: InputMaybe<SortOrderInput>;
  orderCompleteDate?: InputMaybe<SortOrder>;
  orderCompleteParsonName?: InputMaybe<SortOrderInput>;
  orderCompleteType?: InputMaybe<SortOrderInput>;
  orderRequestDate?: InputMaybe<SortOrder>;
  orderRequestId?: InputMaybe<SortOrderInput>;
  staff?: InputMaybe<StaffOrderByWithRelationInput>;
  staffId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum OrderPacking {
  Auto = 'Auto',
  Bara = 'Bara',
  Case = 'Case',
  Pack = 'Pack'
}

export type OrderRelationFilter = {
  is?: InputMaybe<OrderWhereInput>;
  isNot?: InputMaybe<OrderWhereInput>;
};

/**
 *
 * 注文依頼
 */
export type OrderRequest = {
  __typename?: 'OrderRequest';
  _count?: Maybe<OrderRequestCount>;
  /** 請求先住所（連携） */
  billingAddress?: Maybe<Scalars['String']['output']>;
  /** 請求先担当者名 */
  billingChargeName?: Maybe<Scalars['String']['output']>;
  /** 請求先名 */
  billingName?: Maybe<Scalars['String']['output']>;
  /** 請求先名カナ */
  billingNameKana?: Maybe<Scalars['String']['output']>;
  /** 請求先電話番号（連携） */
  billingPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** 請求先郵便番号（連携） */
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  /** 請求先都道府県 */
  billingPrefecture?: Maybe<Scalars['String']['output']>;
  /** キャンセル日時 */
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先CD（連携） */
  customerCd: Scalars['Int']['output'];
  /** 得意先担当者名（連携） */
  customerChargeName?: Maybe<Scalars['String']['output']>;
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** 得意先名称（連携） */
  customerName: Scalars['String']['output'];
  /** 配送先住所（連携） */
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  /** 配送先担当者名 */
  deliveryChargeName?: Maybe<Scalars['String']['output']>;
  /** 出荷日（希望納品日？） */
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  /** 配送先名 */
  deliveryName?: Maybe<Scalars['String']['output']>;
  /** 配送先名カナ */
  deliveryNameKana?: Maybe<Scalars['String']['output']>;
  /** 配送先電話番号（連携） */
  deliveryPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** 配送先郵便番号（連携） */
  deliveryPostalCode?: Maybe<Scalars['String']['output']>;
  /** 配送先都道府県 */
  deliveryPrefecture?: Maybe<Scalars['String']['output']>;
  /** 注文依頼明細 */
  details: Array<OrderRequestDetail>;
  /** 注文依頼ID（連携） */
  id: Scalars['Int']['output'];
  /** 当日配送かどうか（0：指定無し　1：本日出荷） */
  isSameDayDelivery: Scalars['Boolean']['output'];
  /** 最低金額 */
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 注文依頼日時（連携） */
  orderRequestDate: Scalars['DateTime']['output'];
  /** 購入担当者 */
  staff?: Maybe<Staff>;
  /** 購入担当者ID（連携） */
  staffId?: Maybe<Scalars['Int']['output']>;
  /** 基幹システムとの同期日時 */
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


/**
 *
 * 注文依頼
 */
export type OrderRequestDetailsArgs = {
  cursor?: InputMaybe<OrderRequestDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};

export type OrderRequestAvgAggregate = {
  __typename?: 'OrderRequestAvgAggregate';
  customerCd?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  staffId?: Maybe<Scalars['Float']['output']>;
};

export type OrderRequestCount = {
  __typename?: 'OrderRequestCount';
  details: Scalars['Int']['output'];
};


export type OrderRequestCountDetailsArgs = {
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};

export type OrderRequestCountAggregate = {
  __typename?: 'OrderRequestCountAggregate';
  _all: Scalars['Int']['output'];
  billingAddress: Scalars['Int']['output'];
  billingChargeName: Scalars['Int']['output'];
  billingName: Scalars['Int']['output'];
  billingNameKana: Scalars['Int']['output'];
  billingPhoneNumber: Scalars['Int']['output'];
  billingPostalCode: Scalars['Int']['output'];
  billingPrefecture: Scalars['Int']['output'];
  canceledAt: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerCd: Scalars['Int']['output'];
  customerChargeName: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  customerName: Scalars['Int']['output'];
  deliveryAddress: Scalars['Int']['output'];
  deliveryChargeName: Scalars['Int']['output'];
  deliveryDate: Scalars['Int']['output'];
  deliveryName: Scalars['Int']['output'];
  deliveryNameKana: Scalars['Int']['output'];
  deliveryPhoneNumber: Scalars['Int']['output'];
  deliveryPostalCode: Scalars['Int']['output'];
  deliveryPrefecture: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSameDayDelivery: Scalars['Int']['output'];
  minimumOrderAmount: Scalars['Int']['output'];
  orderRequestDate: Scalars['Int']['output'];
  staffId: Scalars['Int']['output'];
  syncedAt: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type OrderRequestCreateInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrderRequestsInput;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<OrderRequestDetailCreateNestedManyWithoutOrderRequestInput>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  staff?: InputMaybe<StaffCreateNestedOneWithoutOrderRequestsInput>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderRequestCreateManyCustomerInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  staffId?: InputMaybe<Scalars['Int']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderRequestCreateManyCustomerInputEnvelope = {
  data: Array<OrderRequestCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderRequestCreateManyStaffInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerId: Scalars['Int']['input'];
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderRequestCreateManyStaffInputEnvelope = {
  data: Array<OrderRequestCreateManyStaffInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderRequestCreateNestedOneWithoutDetailsInput = {
  connect?: InputMaybe<OrderRequestWhereUniqueInput>;
  connectOrCreate?: InputMaybe<OrderRequestCreateOrConnectWithoutDetailsInput>;
  create?: InputMaybe<OrderRequestCreateWithoutDetailsInput>;
};

export type OrderRequestCreateOrConnectWithoutCustomerInput = {
  create: OrderRequestCreateWithoutCustomerInput;
  where: OrderRequestWhereUniqueInput;
};

export type OrderRequestCreateOrConnectWithoutDetailsInput = {
  create: OrderRequestCreateWithoutDetailsInput;
  where: OrderRequestWhereUniqueInput;
};

export type OrderRequestCreateOrConnectWithoutStaffInput = {
  create: OrderRequestCreateWithoutStaffInput;
  where: OrderRequestWhereUniqueInput;
};

export type OrderRequestCreateWithoutCustomerInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<OrderRequestDetailCreateNestedManyWithoutOrderRequestInput>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  staff?: InputMaybe<StaffCreateNestedOneWithoutOrderRequestsInput>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderRequestCreateWithoutDetailsInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrderRequestsInput;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  staff?: InputMaybe<StaffCreateNestedOneWithoutOrderRequestsInput>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type OrderRequestCreateWithoutStaffInput = {
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingChargeName?: InputMaybe<Scalars['String']['input']>;
  billingName?: InputMaybe<Scalars['String']['input']>;
  billingNameKana?: InputMaybe<Scalars['String']['input']>;
  billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode?: InputMaybe<Scalars['String']['input']>;
  billingPrefecture?: InputMaybe<Scalars['String']['input']>;
  canceledAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer: CustomerCreateNestedOneWithoutOrderRequestsInput;
  customerCd: Scalars['Int']['input'];
  customerChargeName?: InputMaybe<Scalars['String']['input']>;
  customerName: Scalars['String']['input'];
  deliveryAddress?: InputMaybe<Scalars['String']['input']>;
  deliveryChargeName?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  deliveryName?: InputMaybe<Scalars['String']['input']>;
  deliveryNameKana?: InputMaybe<Scalars['String']['input']>;
  deliveryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  deliveryPostalCode?: InputMaybe<Scalars['String']['input']>;
  deliveryPrefecture?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<OrderRequestDetailCreateNestedManyWithoutOrderRequestInput>;
  isSameDayDelivery?: InputMaybe<Scalars['Boolean']['input']>;
  minimumOrderAmount?: InputMaybe<Scalars['Decimal']['input']>;
  orderRequestDate?: InputMaybe<Scalars['DateTime']['input']>;
  syncedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 *
 * 注文依頼明細
 */
export type OrderRequestDetail = {
  __typename?: 'OrderRequestDetail';
  /** 税抜金額（連携） */
  amount: Scalars['Decimal']['output'];
  /** 商品在庫単価 - 原価 */
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース掛率 */
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱掛率 */
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - バラ掛率 */
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先備考（QA No.64）（連携） */
  customerNote?: Maybe<Scalars['String']['output']>;
  /** 得意先注文番号（連携） */
  customerOrderNo?: Maybe<Scalars['String']['output']>;
  /** 径（連携） */
  diameter: Scalars['String']['output'];
  /** 径CD（連携） */
  diameterCd: Scalars['Int']['output'];
  /** 注文依頼明細ID */
  id: Scalars['Int']['output'];
  /** 商品CD（連携） */
  itemCd: Scalars['BigInt']['output'];
  /** 長さ（連携） */
  length: Scalars['String']['output'];
  /** 長さCD（連携） */
  lengthCd: Scalars['Int']['output'];
  /** 商品名（連携） */
  name: Scalars['String']['output'];
  /** 注文依頼 */
  orderRequest: OrderRequest;
  /** 注文依頼ID */
  orderRequestId: Scalars['Int']['output'];
  /** 荷姿（注文単位）（連携） */
  packing: OrderPacking;
  /** 荷姿 */
  packingStyle?: Maybe<Scalars['String']['output']>;
  /** 数量 */
  quantity: Scalars['Int']['output'];
  /** 商品在庫 - ケース入数 */
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫 - 小箱入数 */
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** 行番号（QA No.67）（連携） */
  requestLineNo: Scalars['Int']['output'];
  /** 商品 短縮CD（連携） */
  shortCd?: Maybe<Scalars['Int']['output']>;
  /** サイズCD（連携） */
  sizeCd: Scalars['BigInt']['output'];
  /** サイズ名（連携） */
  sizeName: Scalars['String']['output'];
  /** 商品在庫 */
  stockItem?: Maybe<StockItem>;
  /** 商品在庫ID */
  stockItemId?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫単価 */
  stockItemUnitPrice?: Maybe<StockItemUnitPrice>;
  /** 商品在庫単価ID */
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  /** バラ数量 */
  totalQuantity: Scalars['Int']['output'];
  /** 単価（連携） */
  unitPrice: Scalars['Decimal']['output'];
  /** 商品在庫単価 - バラ単価 */
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース単価 */
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱単価 */
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderRequestDetailCreateInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderRequest: OrderRequestCreateNestedOneWithoutDetailsInput;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutOrderRequestDetailInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutOrderRequestDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderRequestDetailCreateManyOrderRequestInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderRequestDetailCreateManyOrderRequestInputEnvelope = {
  data: Array<OrderRequestDetailCreateManyOrderRequestInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderRequestDetailCreateManyStockItemInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderRequestId: Scalars['Int']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderRequestDetailCreateManyStockItemInputEnvelope = {
  data: Array<OrderRequestDetailCreateManyStockItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderRequestDetailCreateManyStockItemUnitPriceInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderRequestId: Scalars['Int']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderRequestDetailCreateManyStockItemUnitPriceInputEnvelope = {
  data: Array<OrderRequestDetailCreateManyStockItemUnitPriceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OrderRequestDetailCreateNestedManyWithoutOrderRequestInput = {
  connect?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderRequestDetailCreateOrConnectWithoutOrderRequestInput>>;
  create?: InputMaybe<Array<OrderRequestDetailCreateWithoutOrderRequestInput>>;
  createMany?: InputMaybe<OrderRequestDetailCreateManyOrderRequestInputEnvelope>;
};

export type OrderRequestDetailCreateOrConnectWithoutOrderRequestInput = {
  create: OrderRequestDetailCreateWithoutOrderRequestInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailCreateOrConnectWithoutStockItemInput = {
  create: OrderRequestDetailCreateWithoutStockItemInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailCreateOrConnectWithoutStockItemUnitPriceInput = {
  create: OrderRequestDetailCreateWithoutStockItemUnitPriceInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailCreateWithoutOrderRequestInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutOrderRequestDetailInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutOrderRequestDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderRequestDetailCreateWithoutStockItemInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderRequest: OrderRequestCreateNestedOneWithoutDetailsInput;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutOrderRequestDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderRequestDetailCreateWithoutStockItemUnitPriceInput = {
  amount?: InputMaybe<Scalars['Decimal']['input']>;
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerNote?: InputMaybe<Scalars['String']['input']>;
  customerOrderNo?: InputMaybe<Scalars['String']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  orderRequest: OrderRequestCreateNestedOneWithoutDetailsInput;
  packing?: InputMaybe<OrderPacking>;
  packingStyle?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  requestLineNo?: InputMaybe<Scalars['Int']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutOrderRequestDetailInput>;
  totalQuantity?: InputMaybe<Scalars['Int']['input']>;
  unitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type OrderRequestDetailListRelationFilter = {
  every?: InputMaybe<OrderRequestDetailWhereInput>;
  none?: InputMaybe<OrderRequestDetailWhereInput>;
  some?: InputMaybe<OrderRequestDetailWhereInput>;
};

export type OrderRequestDetailOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderRequestDetailOrderByWithRelationInput = {
  amount?: InputMaybe<SortOrder>;
  costPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerNote?: InputMaybe<SortOrderInput>;
  customerOrderNo?: InputMaybe<SortOrderInput>;
  diameter?: InputMaybe<SortOrder>;
  diameterCd?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  itemCd?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  lengthCd?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderRequest?: InputMaybe<OrderRequestOrderByWithRelationInput>;
  orderRequestId?: InputMaybe<SortOrder>;
  packing?: InputMaybe<SortOrder>;
  packingStyle?: InputMaybe<SortOrderInput>;
  quantity?: InputMaybe<SortOrder>;
  quantityParCaseOfStockItem?: InputMaybe<SortOrderInput>;
  quantityParPackOfStockItem?: InputMaybe<SortOrderInput>;
  requestLineNo?: InputMaybe<SortOrder>;
  shortCd?: InputMaybe<SortOrderInput>;
  sizeCd?: InputMaybe<SortOrder>;
  sizeName?: InputMaybe<SortOrder>;
  stockItem?: InputMaybe<StockItemOrderByWithRelationInput>;
  stockItemId?: InputMaybe<SortOrderInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceOrderByWithRelationInput>;
  stockItemUnitPriceId?: InputMaybe<SortOrderInput>;
  totalQuantity?: InputMaybe<SortOrder>;
  unitPrice?: InputMaybe<SortOrder>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum OrderRequestDetailScalarFieldEnum {
  Amount = 'amount',
  CostPriceOfStockItemUnitPrice = 'costPriceOfStockItemUnitPrice',
  CostRateOfCaseOfStockItemUnitPrice = 'costRateOfCaseOfStockItemUnitPrice',
  CostRateOfPackOfStockItemUnitPrice = 'costRateOfPackOfStockItemUnitPrice',
  CostRateOfStockItemUnitPrice = 'costRateOfStockItemUnitPrice',
  CreatedAt = 'createdAt',
  CustomerNote = 'customerNote',
  CustomerOrderNo = 'customerOrderNo',
  Diameter = 'diameter',
  DiameterCd = 'diameterCd',
  Id = 'id',
  ItemCd = 'itemCd',
  Length = 'length',
  LengthCd = 'lengthCd',
  Name = 'name',
  OrderRequestId = 'orderRequestId',
  Packing = 'packing',
  PackingStyle = 'packingStyle',
  Quantity = 'quantity',
  QuantityParCaseOfStockItem = 'quantityParCaseOfStockItem',
  QuantityParPackOfStockItem = 'quantityParPackOfStockItem',
  RequestLineNo = 'requestLineNo',
  ShortCd = 'shortCd',
  SizeCd = 'sizeCd',
  SizeName = 'sizeName',
  StockItemId = 'stockItemId',
  StockItemUnitPriceId = 'stockItemUnitPriceId',
  TotalQuantity = 'totalQuantity',
  UnitPrice = 'unitPrice',
  UnitPriceOfStockItemUnitPrice = 'unitPriceOfStockItemUnitPrice',
  UnitPriceParCaseOfStockItemUnitPrice = 'unitPriceParCaseOfStockItemUnitPrice',
  UnitPriceParPackOfStockItemUnitPrice = 'unitPriceParPackOfStockItemUnitPrice',
  UpdatedAt = 'updatedAt'
}

export type OrderRequestDetailScalarWhereInput = {
  AND?: InputMaybe<Array<OrderRequestDetailScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderRequestDetailScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderRequestDetailScalarWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerNote?: InputMaybe<StringNullableFilter>;
  customerOrderNo?: InputMaybe<StringNullableFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  orderRequestId?: InputMaybe<IntFilter>;
  packing?: InputMaybe<EnumOrderPackingFilter>;
  packingStyle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  requestLineNo?: InputMaybe<IntFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  totalQuantity?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderRequestDetailUpdateInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderRequestDetailUpdateManyMutationInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderRequestDetailUpdateManyWithWhereWithoutOrderRequestInput = {
  data: OrderRequestDetailUpdateManyMutationInput;
  where: OrderRequestDetailScalarWhereInput;
};

export type OrderRequestDetailUpdateManyWithWhereWithoutStockItemInput = {
  data: OrderRequestDetailUpdateManyMutationInput;
  where: OrderRequestDetailScalarWhereInput;
};

export type OrderRequestDetailUpdateManyWithWhereWithoutStockItemUnitPriceInput = {
  data: OrderRequestDetailUpdateManyMutationInput;
  where: OrderRequestDetailScalarWhereInput;
};

export type OrderRequestDetailUpdateManyWithoutOrderRequestNestedInput = {
  connect?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderRequestDetailCreateOrConnectWithoutOrderRequestInput>>;
  create?: InputMaybe<Array<OrderRequestDetailCreateWithoutOrderRequestInput>>;
  createMany?: InputMaybe<OrderRequestDetailCreateManyOrderRequestInputEnvelope>;
  delete?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderRequestDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderRequestDetailUpdateWithWhereUniqueWithoutOrderRequestInput>>;
  updateMany?: InputMaybe<Array<OrderRequestDetailUpdateManyWithWhereWithoutOrderRequestInput>>;
  upsert?: InputMaybe<Array<OrderRequestDetailUpsertWithWhereUniqueWithoutOrderRequestInput>>;
};

export type OrderRequestDetailUpdateManyWithoutStockItemNestedInput = {
  connect?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderRequestDetailCreateOrConnectWithoutStockItemInput>>;
  create?: InputMaybe<Array<OrderRequestDetailCreateWithoutStockItemInput>>;
  createMany?: InputMaybe<OrderRequestDetailCreateManyStockItemInputEnvelope>;
  delete?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderRequestDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderRequestDetailUpdateWithWhereUniqueWithoutStockItemInput>>;
  updateMany?: InputMaybe<Array<OrderRequestDetailUpdateManyWithWhereWithoutStockItemInput>>;
  upsert?: InputMaybe<Array<OrderRequestDetailUpsertWithWhereUniqueWithoutStockItemInput>>;
};

export type OrderRequestDetailUpdateManyWithoutStockItemUnitPriceNestedInput = {
  connect?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderRequestDetailCreateOrConnectWithoutStockItemUnitPriceInput>>;
  create?: InputMaybe<Array<OrderRequestDetailCreateWithoutStockItemUnitPriceInput>>;
  createMany?: InputMaybe<OrderRequestDetailCreateManyStockItemUnitPriceInputEnvelope>;
  delete?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderRequestDetailScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderRequestDetailWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderRequestDetailUpdateWithWhereUniqueWithoutStockItemUnitPriceInput>>;
  updateMany?: InputMaybe<Array<OrderRequestDetailUpdateManyWithWhereWithoutStockItemUnitPriceInput>>;
  upsert?: InputMaybe<Array<OrderRequestDetailUpsertWithWhereUniqueWithoutStockItemUnitPriceInput>>;
};

export type OrderRequestDetailUpdateWithWhereUniqueWithoutOrderRequestInput = {
  data: OrderRequestDetailUpdateWithoutOrderRequestInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailUpdateWithWhereUniqueWithoutStockItemInput = {
  data: OrderRequestDetailUpdateWithoutStockItemInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailUpdateWithWhereUniqueWithoutStockItemUnitPriceInput = {
  data: OrderRequestDetailUpdateWithoutStockItemUnitPriceInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailUpdateWithoutOrderRequestInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderRequestDetailUpdateWithoutStockItemInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderRequestDetailUpdateWithoutStockItemUnitPriceInput = {
  amount?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  customerNote?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerOrderNo?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  packing?: InputMaybe<EnumOrderPackingFieldUpdateOperationsInput>;
  packingStyle?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  quantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  requestLineNo?: InputMaybe<IntFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  totalQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type OrderRequestDetailUpsertWithWhereUniqueWithoutOrderRequestInput = {
  create: OrderRequestDetailCreateWithoutOrderRequestInput;
  update: OrderRequestDetailUpdateWithoutOrderRequestInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailUpsertWithWhereUniqueWithoutStockItemInput = {
  create: OrderRequestDetailCreateWithoutStockItemInput;
  update: OrderRequestDetailUpdateWithoutStockItemInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailUpsertWithWhereUniqueWithoutStockItemUnitPriceInput = {
  create: OrderRequestDetailCreateWithoutStockItemUnitPriceInput;
  update: OrderRequestDetailUpdateWithoutStockItemUnitPriceInput;
  where: OrderRequestDetailWhereUniqueInput;
};

export type OrderRequestDetailWhereInput = {
  AND?: InputMaybe<Array<OrderRequestDetailWhereInput>>;
  NOT?: InputMaybe<Array<OrderRequestDetailWhereInput>>;
  OR?: InputMaybe<Array<OrderRequestDetailWhereInput>>;
  amount?: InputMaybe<DecimalFilter>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerNote?: InputMaybe<StringNullableFilter>;
  customerOrderNo?: InputMaybe<StringNullableFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  orderRequest?: InputMaybe<OrderRequestRelationFilter>;
  orderRequestId?: InputMaybe<IntFilter>;
  packing?: InputMaybe<EnumOrderPackingFilter>;
  packingStyle?: InputMaybe<StringNullableFilter>;
  quantity?: InputMaybe<IntFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  requestLineNo?: InputMaybe<IntFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  stockItem?: InputMaybe<StockItemRelationFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceRelationFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  totalQuantity?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderRequestDetailWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderRequestListRelationFilter = {
  every?: InputMaybe<OrderRequestWhereInput>;
  none?: InputMaybe<OrderRequestWhereInput>;
  some?: InputMaybe<OrderRequestWhereInput>;
};

export type OrderRequestMaxAggregate = {
  __typename?: 'OrderRequestMaxAggregate';
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingChargeName?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingNameKana?: Maybe<Scalars['String']['output']>;
  billingPhoneNumber?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingPrefecture?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerCd?: Maybe<Scalars['Int']['output']>;
  customerChargeName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryChargeName?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryName?: Maybe<Scalars['String']['output']>;
  deliveryNameKana?: Maybe<Scalars['String']['output']>;
  deliveryPhoneNumber?: Maybe<Scalars['String']['output']>;
  deliveryPostalCode?: Maybe<Scalars['String']['output']>;
  deliveryPrefecture?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSameDayDelivery?: Maybe<Scalars['Boolean']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  orderRequestDate?: Maybe<Scalars['DateTime']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderRequestMinAggregate = {
  __typename?: 'OrderRequestMinAggregate';
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingChargeName?: Maybe<Scalars['String']['output']>;
  billingName?: Maybe<Scalars['String']['output']>;
  billingNameKana?: Maybe<Scalars['String']['output']>;
  billingPhoneNumber?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingPrefecture?: Maybe<Scalars['String']['output']>;
  canceledAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerCd?: Maybe<Scalars['Int']['output']>;
  customerChargeName?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  customerName?: Maybe<Scalars['String']['output']>;
  deliveryAddress?: Maybe<Scalars['String']['output']>;
  deliveryChargeName?: Maybe<Scalars['String']['output']>;
  deliveryDate?: Maybe<Scalars['DateTime']['output']>;
  deliveryName?: Maybe<Scalars['String']['output']>;
  deliveryNameKana?: Maybe<Scalars['String']['output']>;
  deliveryPhoneNumber?: Maybe<Scalars['String']['output']>;
  deliveryPostalCode?: Maybe<Scalars['String']['output']>;
  deliveryPrefecture?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  isSameDayDelivery?: Maybe<Scalars['Boolean']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  orderRequestDate?: Maybe<Scalars['DateTime']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  syncedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OrderRequestOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OrderRequestOrderByWithRelationInput = {
  billingAddress?: InputMaybe<SortOrderInput>;
  billingChargeName?: InputMaybe<SortOrderInput>;
  billingName?: InputMaybe<SortOrderInput>;
  billingNameKana?: InputMaybe<SortOrderInput>;
  billingPhoneNumber?: InputMaybe<SortOrderInput>;
  billingPostalCode?: InputMaybe<SortOrderInput>;
  billingPrefecture?: InputMaybe<SortOrderInput>;
  canceledAt?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerCd?: InputMaybe<SortOrder>;
  customerChargeName?: InputMaybe<SortOrderInput>;
  customerId?: InputMaybe<SortOrder>;
  customerName?: InputMaybe<SortOrder>;
  deliveryAddress?: InputMaybe<SortOrderInput>;
  deliveryChargeName?: InputMaybe<SortOrderInput>;
  deliveryDate?: InputMaybe<SortOrderInput>;
  deliveryName?: InputMaybe<SortOrderInput>;
  deliveryNameKana?: InputMaybe<SortOrderInput>;
  deliveryPhoneNumber?: InputMaybe<SortOrderInput>;
  deliveryPostalCode?: InputMaybe<SortOrderInput>;
  deliveryPrefecture?: InputMaybe<SortOrderInput>;
  details?: InputMaybe<OrderRequestDetailOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  isSameDayDelivery?: InputMaybe<SortOrder>;
  minimumOrderAmount?: InputMaybe<SortOrderInput>;
  orderRequestDate?: InputMaybe<SortOrder>;
  staff?: InputMaybe<StaffOrderByWithRelationInput>;
  staffId?: InputMaybe<SortOrderInput>;
  syncedAt?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type OrderRequestRelationFilter = {
  is?: InputMaybe<OrderRequestWhereInput>;
  isNot?: InputMaybe<OrderRequestWhereInput>;
};

export enum OrderRequestScalarFieldEnum {
  BillingAddress = 'billingAddress',
  BillingChargeName = 'billingChargeName',
  BillingName = 'billingName',
  BillingNameKana = 'billingNameKana',
  BillingPhoneNumber = 'billingPhoneNumber',
  BillingPostalCode = 'billingPostalCode',
  BillingPrefecture = 'billingPrefecture',
  CanceledAt = 'canceledAt',
  CreatedAt = 'createdAt',
  CustomerCd = 'customerCd',
  CustomerChargeName = 'customerChargeName',
  CustomerId = 'customerId',
  CustomerName = 'customerName',
  DeliveryAddress = 'deliveryAddress',
  DeliveryChargeName = 'deliveryChargeName',
  DeliveryDate = 'deliveryDate',
  DeliveryName = 'deliveryName',
  DeliveryNameKana = 'deliveryNameKana',
  DeliveryPhoneNumber = 'deliveryPhoneNumber',
  DeliveryPostalCode = 'deliveryPostalCode',
  DeliveryPrefecture = 'deliveryPrefecture',
  Id = 'id',
  IsSameDayDelivery = 'isSameDayDelivery',
  MinimumOrderAmount = 'minimumOrderAmount',
  OrderRequestDate = 'orderRequestDate',
  StaffId = 'staffId',
  SyncedAt = 'syncedAt',
  UpdatedAt = 'updatedAt'
}

export type OrderRequestScalarWhereInput = {
  AND?: InputMaybe<Array<OrderRequestScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderRequestScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderRequestScalarWhereInput>>;
  billingAddress?: InputMaybe<StringNullableFilter>;
  billingChargeName?: InputMaybe<StringNullableFilter>;
  billingName?: InputMaybe<StringNullableFilter>;
  billingNameKana?: InputMaybe<StringNullableFilter>;
  billingPhoneNumber?: InputMaybe<StringNullableFilter>;
  billingPostalCode?: InputMaybe<StringNullableFilter>;
  billingPrefecture?: InputMaybe<StringNullableFilter>;
  canceledAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerCd?: InputMaybe<IntFilter>;
  customerChargeName?: InputMaybe<StringNullableFilter>;
  customerId?: InputMaybe<IntFilter>;
  customerName?: InputMaybe<StringFilter>;
  deliveryAddress?: InputMaybe<StringNullableFilter>;
  deliveryChargeName?: InputMaybe<StringNullableFilter>;
  deliveryDate?: InputMaybe<DateTimeNullableFilter>;
  deliveryName?: InputMaybe<StringNullableFilter>;
  deliveryNameKana?: InputMaybe<StringNullableFilter>;
  deliveryPhoneNumber?: InputMaybe<StringNullableFilter>;
  deliveryPostalCode?: InputMaybe<StringNullableFilter>;
  deliveryPrefecture?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isSameDayDelivery?: InputMaybe<BoolFilter>;
  minimumOrderAmount?: InputMaybe<DecimalNullableFilter>;
  orderRequestDate?: InputMaybe<DateTimeFilter>;
  staffId?: InputMaybe<IntNullableFilter>;
  syncedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderRequestSumAggregate = {
  __typename?: 'OrderRequestSumAggregate';
  customerCd?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
};

export type OrderRequestUpdateInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  details?: InputMaybe<OrderRequestDetailUpdateManyWithoutOrderRequestNestedInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type OrderRequestUpdateManyMutationInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type OrderRequestUpdateManyWithWhereWithoutCustomerInput = {
  data: OrderRequestUpdateManyMutationInput;
  where: OrderRequestScalarWhereInput;
};

export type OrderRequestUpdateManyWithWhereWithoutStaffInput = {
  data: OrderRequestUpdateManyMutationInput;
  where: OrderRequestScalarWhereInput;
};

export type OrderRequestUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderRequestCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderRequestCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderRequestCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderRequestUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<OrderRequestUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<OrderRequestUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type OrderRequestUpdateManyWithoutStaffNestedInput = {
  connect?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderRequestCreateOrConnectWithoutStaffInput>>;
  create?: InputMaybe<Array<OrderRequestCreateWithoutStaffInput>>;
  createMany?: InputMaybe<OrderRequestCreateManyStaffInputEnvelope>;
  delete?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderRequestUpdateWithWhereUniqueWithoutStaffInput>>;
  updateMany?: InputMaybe<Array<OrderRequestUpdateManyWithWhereWithoutStaffInput>>;
  upsert?: InputMaybe<Array<OrderRequestUpsertWithWhereUniqueWithoutStaffInput>>;
};

export type OrderRequestUpdateWithWhereUniqueWithoutCustomerInput = {
  data: OrderRequestUpdateWithoutCustomerInput;
  where: OrderRequestWhereUniqueInput;
};

export type OrderRequestUpdateWithWhereUniqueWithoutStaffInput = {
  data: OrderRequestUpdateWithoutStaffInput;
  where: OrderRequestWhereUniqueInput;
};

export type OrderRequestUpdateWithoutCustomerInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  details?: InputMaybe<OrderRequestDetailUpdateManyWithoutOrderRequestNestedInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type OrderRequestUpdateWithoutStaffInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  canceledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  details?: InputMaybe<OrderRequestDetailUpdateManyWithoutOrderRequestNestedInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  syncedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type OrderRequestUpsertWithWhereUniqueWithoutCustomerInput = {
  create: OrderRequestCreateWithoutCustomerInput;
  update: OrderRequestUpdateWithoutCustomerInput;
  where: OrderRequestWhereUniqueInput;
};

export type OrderRequestUpsertWithWhereUniqueWithoutStaffInput = {
  create: OrderRequestCreateWithoutStaffInput;
  update: OrderRequestUpdateWithoutStaffInput;
  where: OrderRequestWhereUniqueInput;
};

export type OrderRequestWhereInput = {
  AND?: InputMaybe<Array<OrderRequestWhereInput>>;
  NOT?: InputMaybe<Array<OrderRequestWhereInput>>;
  OR?: InputMaybe<Array<OrderRequestWhereInput>>;
  billingAddress?: InputMaybe<StringNullableFilter>;
  billingChargeName?: InputMaybe<StringNullableFilter>;
  billingName?: InputMaybe<StringNullableFilter>;
  billingNameKana?: InputMaybe<StringNullableFilter>;
  billingPhoneNumber?: InputMaybe<StringNullableFilter>;
  billingPostalCode?: InputMaybe<StringNullableFilter>;
  billingPrefecture?: InputMaybe<StringNullableFilter>;
  canceledAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerCd?: InputMaybe<IntFilter>;
  customerChargeName?: InputMaybe<StringNullableFilter>;
  customerId?: InputMaybe<IntFilter>;
  customerName?: InputMaybe<StringFilter>;
  deliveryAddress?: InputMaybe<StringNullableFilter>;
  deliveryChargeName?: InputMaybe<StringNullableFilter>;
  deliveryDate?: InputMaybe<DateTimeNullableFilter>;
  deliveryName?: InputMaybe<StringNullableFilter>;
  deliveryNameKana?: InputMaybe<StringNullableFilter>;
  deliveryPhoneNumber?: InputMaybe<StringNullableFilter>;
  deliveryPostalCode?: InputMaybe<StringNullableFilter>;
  deliveryPrefecture?: InputMaybe<StringNullableFilter>;
  details?: InputMaybe<OrderRequestDetailListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  isSameDayDelivery?: InputMaybe<BoolFilter>;
  minimumOrderAmount?: InputMaybe<DecimalNullableFilter>;
  orderRequestDate?: InputMaybe<DateTimeFilter>;
  staff?: InputMaybe<StaffRelationFilter>;
  staffId?: InputMaybe<IntNullableFilter>;
  syncedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderRequestWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export enum OrderScalarFieldEnum {
  BillingAddress = 'billingAddress',
  BillingChargeName = 'billingChargeName',
  BillingName = 'billingName',
  BillingNameKana = 'billingNameKana',
  BillingPhoneNumber = 'billingPhoneNumber',
  BillingPostalCode = 'billingPostalCode',
  BillingPrefecture = 'billingPrefecture',
  CreatedAt = 'createdAt',
  CustomerCd = 'customerCd',
  CustomerChargeName = 'customerChargeName',
  CustomerId = 'customerId',
  CustomerName = 'customerName',
  DeliveryAddress = 'deliveryAddress',
  DeliveryChargeName = 'deliveryChargeName',
  DeliveryDate = 'deliveryDate',
  DeliveryName = 'deliveryName',
  DeliveryNameKana = 'deliveryNameKana',
  DeliveryPhoneNumber = 'deliveryPhoneNumber',
  DeliveryPostalCode = 'deliveryPostalCode',
  DeliveryPrefecture = 'deliveryPrefecture',
  Id = 'id',
  IsSameDayDelivery = 'isSameDayDelivery',
  MinimumOrderAmount = 'minimumOrderAmount',
  OrderCompleteDate = 'orderCompleteDate',
  OrderCompleteParsonName = 'orderCompleteParsonName',
  OrderCompleteType = 'orderCompleteType',
  OrderRequestDate = 'orderRequestDate',
  OrderRequestId = 'orderRequestId',
  StaffId = 'staffId',
  UpdatedAt = 'updatedAt'
}

export type OrderScalarWhereInput = {
  AND?: InputMaybe<Array<OrderScalarWhereInput>>;
  NOT?: InputMaybe<Array<OrderScalarWhereInput>>;
  OR?: InputMaybe<Array<OrderScalarWhereInput>>;
  billingAddress?: InputMaybe<StringNullableFilter>;
  billingChargeName?: InputMaybe<StringNullableFilter>;
  billingName?: InputMaybe<StringNullableFilter>;
  billingNameKana?: InputMaybe<StringNullableFilter>;
  billingPhoneNumber?: InputMaybe<StringNullableFilter>;
  billingPostalCode?: InputMaybe<StringNullableFilter>;
  billingPrefecture?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerCd?: InputMaybe<IntFilter>;
  customerChargeName?: InputMaybe<StringNullableFilter>;
  customerId?: InputMaybe<IntFilter>;
  customerName?: InputMaybe<StringFilter>;
  deliveryAddress?: InputMaybe<StringNullableFilter>;
  deliveryChargeName?: InputMaybe<StringNullableFilter>;
  deliveryDate?: InputMaybe<DateTimeNullableFilter>;
  deliveryName?: InputMaybe<StringNullableFilter>;
  deliveryNameKana?: InputMaybe<StringNullableFilter>;
  deliveryPhoneNumber?: InputMaybe<StringNullableFilter>;
  deliveryPostalCode?: InputMaybe<StringNullableFilter>;
  deliveryPrefecture?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isSameDayDelivery?: InputMaybe<BoolFilter>;
  minimumOrderAmount?: InputMaybe<DecimalNullableFilter>;
  orderCompleteDate?: InputMaybe<DateTimeFilter>;
  orderCompleteParsonName?: InputMaybe<StringNullableFilter>;
  orderCompleteType?: InputMaybe<StringNullableFilter>;
  orderRequestDate?: InputMaybe<DateTimeFilter>;
  orderRequestId?: InputMaybe<IntNullableFilter>;
  staffId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderSumAggregate = {
  __typename?: 'OrderSumAggregate';
  customerCd?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  minimumOrderAmount?: Maybe<Scalars['Decimal']['output']>;
  orderRequestId?: Maybe<Scalars['Int']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
};

export type OrderUpdateInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  details?: InputMaybe<OrderDetailUpdateManyWithoutOrderNestedInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderCompleteDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderCompleteParsonName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderCompleteType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderRequestId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderUpdateManyMutationInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderCompleteDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderCompleteParsonName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderCompleteType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderRequestId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderUpdateManyWithWhereWithoutCustomerInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithWhereWithoutStaffInput = {
  data: OrderUpdateManyMutationInput;
  where: OrderScalarWhereInput;
};

export type OrderUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<OrderCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type OrderUpdateManyWithoutStaffNestedInput = {
  connect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OrderCreateOrConnectWithoutStaffInput>>;
  create?: InputMaybe<Array<OrderCreateWithoutStaffInput>>;
  createMany?: InputMaybe<OrderCreateManyStaffInputEnvelope>;
  delete?: InputMaybe<Array<OrderWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OrderScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OrderWhereUniqueInput>>;
  set?: InputMaybe<Array<OrderWhereUniqueInput>>;
  update?: InputMaybe<Array<OrderUpdateWithWhereUniqueWithoutStaffInput>>;
  updateMany?: InputMaybe<Array<OrderUpdateManyWithWhereWithoutStaffInput>>;
  upsert?: InputMaybe<Array<OrderUpsertWithWhereUniqueWithoutStaffInput>>;
};

export type OrderUpdateWithWhereUniqueWithoutCustomerInput = {
  data: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithWhereUniqueWithoutStaffInput = {
  data: OrderUpdateWithoutStaffInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpdateWithoutCustomerInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  details?: InputMaybe<OrderDetailUpdateManyWithoutOrderNestedInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderCompleteDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderCompleteParsonName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderCompleteType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderRequestId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderUpdateWithoutStaffInput = {
  billingAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  billingPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  customerChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  customerName?: InputMaybe<StringFieldUpdateOperationsInput>;
  deliveryAddress?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryChargeName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  deliveryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryNameKana?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPhoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPostalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  deliveryPrefecture?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  details?: InputMaybe<OrderDetailUpdateManyWithoutOrderNestedInput>;
  isSameDayDelivery?: InputMaybe<BoolFieldUpdateOperationsInput>;
  minimumOrderAmount?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  orderCompleteDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderCompleteParsonName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderCompleteType?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  orderRequestDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  orderRequestId?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type OrderUpsertWithWhereUniqueWithoutCustomerInput = {
  create: OrderCreateWithoutCustomerInput;
  update: OrderUpdateWithoutCustomerInput;
  where: OrderWhereUniqueInput;
};

export type OrderUpsertWithWhereUniqueWithoutStaffInput = {
  create: OrderCreateWithoutStaffInput;
  update: OrderUpdateWithoutStaffInput;
  where: OrderWhereUniqueInput;
};

export type OrderWhereInput = {
  AND?: InputMaybe<Array<OrderWhereInput>>;
  NOT?: InputMaybe<Array<OrderWhereInput>>;
  OR?: InputMaybe<Array<OrderWhereInput>>;
  billingAddress?: InputMaybe<StringNullableFilter>;
  billingChargeName?: InputMaybe<StringNullableFilter>;
  billingName?: InputMaybe<StringNullableFilter>;
  billingNameKana?: InputMaybe<StringNullableFilter>;
  billingPhoneNumber?: InputMaybe<StringNullableFilter>;
  billingPostalCode?: InputMaybe<StringNullableFilter>;
  billingPrefecture?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerCd?: InputMaybe<IntFilter>;
  customerChargeName?: InputMaybe<StringNullableFilter>;
  customerId?: InputMaybe<IntFilter>;
  customerName?: InputMaybe<StringFilter>;
  deliveryAddress?: InputMaybe<StringNullableFilter>;
  deliveryChargeName?: InputMaybe<StringNullableFilter>;
  deliveryDate?: InputMaybe<DateTimeNullableFilter>;
  deliveryName?: InputMaybe<StringNullableFilter>;
  deliveryNameKana?: InputMaybe<StringNullableFilter>;
  deliveryPhoneNumber?: InputMaybe<StringNullableFilter>;
  deliveryPostalCode?: InputMaybe<StringNullableFilter>;
  deliveryPrefecture?: InputMaybe<StringNullableFilter>;
  details?: InputMaybe<OrderDetailListRelationFilter>;
  id?: InputMaybe<IntFilter>;
  isSameDayDelivery?: InputMaybe<BoolFilter>;
  minimumOrderAmount?: InputMaybe<DecimalNullableFilter>;
  orderCompleteDate?: InputMaybe<DateTimeFilter>;
  orderCompleteParsonName?: InputMaybe<StringNullableFilter>;
  orderCompleteType?: InputMaybe<StringNullableFilter>;
  orderRequestDate?: InputMaybe<DateTimeFilter>;
  orderRequestId?: InputMaybe<IntNullableFilter>;
  staff?: InputMaybe<StaffRelationFilter>;
  staffId?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type OrderWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type Query = {
  __typename?: 'Query';
  aggregateAnnounce: AggregateAnnounce;
  aggregateCartItem: AggregateCartItem;
  aggregateCustomer: AggregateCustomer;
  aggregateItem: AggregateItem;
  aggregateOrder: AggregateOrder;
  aggregateOrderRequest: AggregateOrderRequest;
  aggregateStockItem: AggregateStockItem;
  aggregateWishlistItem: AggregateWishlistItem;
  announces: Array<Announce>;
  billingAddresses: Array<BillingAddress>;
  cartItems: Array<CartItem>;
  customers: Array<Customer>;
  deliveryAddresses: Array<DeliveryAddress>;
  findFirstAnnounce?: Maybe<Announce>;
  findFirstBillingAddress?: Maybe<BillingAddress>;
  findFirstCartItem?: Maybe<CartItem>;
  findFirstCustomer?: Maybe<Customer>;
  findFirstDeliveryAddress?: Maybe<DeliveryAddress>;
  findFirstItem?: Maybe<Item>;
  findFirstLargeCategory?: Maybe<LargeCategory>;
  findFirstMiddleCategory?: Maybe<MiddleCategory>;
  findFirstOrder?: Maybe<Order>;
  findFirstOrderDetail?: Maybe<OrderDetail>;
  findFirstOrderRequest?: Maybe<OrderRequest>;
  findFirstOrderRequestDetail?: Maybe<OrderRequestDetail>;
  findFirstSmallCategory?: Maybe<SmallCategory>;
  findFirstStaff?: Maybe<Staff>;
  findFirstStockItem?: Maybe<StockItem>;
  findFirstStockItemUnitPrice?: Maybe<StockItemUnitPrice>;
  findFirstSystemSetting?: Maybe<SystemSetting>;
  findFirstWishlistItem?: Maybe<WishlistItem>;
  findManyStaff: Array<Staff>;
  items: Array<Item>;
  largeCategories: Array<LargeCategory>;
  middleCategories: Array<MiddleCategory>;
  orderDetails: Array<OrderDetail>;
  orderRequestDetails: Array<OrderRequestDetail>;
  orderRequests: Array<OrderRequest>;
  orders: Array<Order>;
  smallCategories: Array<SmallCategory>;
  stockItemUnitPrices: Array<StockItemUnitPrice>;
  stockItems: Array<StockItem>;
  systemSettings: Array<SystemSetting>;
  wishlistItems: Array<WishlistItem>;
};


export type QueryAggregateAnnounceArgs = {
  cursor?: InputMaybe<AnnounceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AnnounceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnounceWhereInput>;
};


export type QueryAggregateCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type QueryAggregateCustomerArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryAggregateItemArgs = {
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemWhereInput>;
};


export type QueryAggregateOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryAggregateOrderRequestArgs = {
  cursor?: InputMaybe<OrderRequestWhereUniqueInput>;
  orderBy?: InputMaybe<Array<OrderRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestWhereInput>;
};


export type QueryAggregateStockItemArgs = {
  cursor?: InputMaybe<StockItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<StockItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemWhereInput>;
};


export type QueryAggregateWishlistItemArgs = {
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WishlistItemWhereInput>;
};


export type QueryAnnouncesArgs = {
  cursor?: InputMaybe<AnnounceWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnnounceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnnounceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnounceWhereInput>;
};


export type QueryBillingAddressesArgs = {
  cursor?: InputMaybe<BillingAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<BillingAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BillingAddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BillingAddressWhereInput>;
};


export type QueryCartItemsArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type QueryCustomersArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryDeliveryAddressesArgs = {
  cursor?: InputMaybe<DeliveryAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeliveryAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeliveryAddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeliveryAddressWhereInput>;
};


export type QueryFindFirstAnnounceArgs = {
  cursor?: InputMaybe<AnnounceWhereUniqueInput>;
  distinct?: InputMaybe<Array<AnnounceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AnnounceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AnnounceWhereInput>;
};


export type QueryFindFirstBillingAddressArgs = {
  cursor?: InputMaybe<BillingAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<BillingAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<BillingAddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<BillingAddressWhereInput>;
};


export type QueryFindFirstCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CartItemWhereInput>;
};


export type QueryFindFirstCustomerArgs = {
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  distinct?: InputMaybe<Array<CustomerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CustomerWhereInput>;
};


export type QueryFindFirstDeliveryAddressArgs = {
  cursor?: InputMaybe<DeliveryAddressWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeliveryAddressScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeliveryAddressOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<DeliveryAddressWhereInput>;
};


export type QueryFindFirstItemArgs = {
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemWhereInput>;
};


export type QueryFindFirstLargeCategoryArgs = {
  cursor?: InputMaybe<LargeCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<LargeCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LargeCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LargeCategoryWhereInput>;
};


export type QueryFindFirstMiddleCategoryArgs = {
  cursor?: InputMaybe<MiddleCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<MiddleCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MiddleCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MiddleCategoryWhereInput>;
};


export type QueryFindFirstOrderArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QueryFindFirstOrderDetailArgs = {
  cursor?: InputMaybe<OrderDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderDetailWhereInput>;
};


export type QueryFindFirstOrderRequestArgs = {
  cursor?: InputMaybe<OrderRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestWhereInput>;
};


export type QueryFindFirstOrderRequestDetailArgs = {
  cursor?: InputMaybe<OrderRequestDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};


export type QueryFindFirstSmallCategoryArgs = {
  cursor?: InputMaybe<SmallCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<SmallCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SmallCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SmallCategoryWhereInput>;
};


export type QueryFindFirstStaffArgs = {
  cursor?: InputMaybe<StaffWhereUniqueInput>;
  distinct?: InputMaybe<Array<StaffScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StaffOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StaffWhereInput>;
};


export type QueryFindFirstStockItemArgs = {
  cursor?: InputMaybe<StockItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<StockItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StockItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemWhereInput>;
};


export type QueryFindFirstStockItemUnitPriceArgs = {
  cursor?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<StockItemUnitPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StockItemUnitPriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
};


export type QueryFindFirstSystemSettingArgs = {
  cursor?: InputMaybe<SystemSettingWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemSettingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemSettingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemSettingWhereInput>;
};


export type QueryFindFirstWishlistItemArgs = {
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WishlistItemWhereInput>;
};


export type QueryFindManyStaffArgs = {
  cursor?: InputMaybe<StaffWhereUniqueInput>;
  distinct?: InputMaybe<Array<StaffScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StaffOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StaffWhereInput>;
};


export type QueryItemsArgs = {
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemWhereInput>;
};


export type QueryLargeCategoriesArgs = {
  cursor?: InputMaybe<LargeCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<LargeCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LargeCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LargeCategoryWhereInput>;
};


export type QueryMiddleCategoriesArgs = {
  cursor?: InputMaybe<MiddleCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<MiddleCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MiddleCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<MiddleCategoryWhereInput>;
};


export type QueryOrderDetailsArgs = {
  cursor?: InputMaybe<OrderDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderDetailWhereInput>;
};


export type QueryOrderRequestDetailsArgs = {
  cursor?: InputMaybe<OrderRequestDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};


export type QueryOrderRequestsArgs = {
  cursor?: InputMaybe<OrderRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestWhereInput>;
};


export type QueryOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


export type QuerySmallCategoriesArgs = {
  cursor?: InputMaybe<SmallCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<SmallCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SmallCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SmallCategoryWhereInput>;
};


export type QueryStockItemUnitPricesArgs = {
  cursor?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<StockItemUnitPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StockItemUnitPriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
};


export type QueryStockItemsArgs = {
  cursor?: InputMaybe<StockItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<StockItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StockItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemWhereInput>;
};


export type QuerySystemSettingsArgs = {
  cursor?: InputMaybe<SystemSettingWhereUniqueInput>;
  distinct?: InputMaybe<Array<SystemSettingScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SystemSettingOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SystemSettingWhereInput>;
};


export type QueryWishlistItemsArgs = {
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WishlistItemWhereInput>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type SendOrderRequestDetailInput = {
  /** 金額 */
  amount: Scalars['String']['input'];
  /** 備考 */
  customerNote: Scalars['String']['input'];
  /** 注文番号 */
  customerOrderNo: Scalars['String']['input'];
  /** 商品名 */
  name: Scalars['String']['input'];
  /** 単価種別 */
  orderUnitPriceName: Scalars['String']['input'];
  /** 注文数量の単位 */
  packing: Scalars['String']['input'];
  /** 注文数量 */
  quantity: Scalars['String']['input'];
  /** 注文明細行番号 */
  requestLineNo: Scalars['Int']['input'];
  /** サイズ名 */
  sizeName: Scalars['String']['input'];
  /** 合計数量 */
  totalQuantity: Scalars['String']['input'];
  /** 単価 */
  unitPrice: Scalars['String']['input'];
};

export type SendOrderRequestResponse = {
  __typename?: 'SendOrderRequestResponse';
  message: Scalars['String']['output'];
};

export type SendVerificationCodeResponse = {
  __typename?: 'SendVerificationCodeResponse';
  message: Scalars['String']['output'];
};

/**
 *
 * 小分類
 */
export type SmallCategory = {
  __typename?: 'SmallCategory';
  _count?: Maybe<SmallCategoryCount>;
  createdAt: Scalars['DateTime']['output'];
  /** 小分類ID */
  id: Scalars['Int']['output'];
  items: Array<Item>;
  /** 小分類名（連携） */
  name: Scalars['String']['output'];
  /** 小分類順番（連携） */
  seq?: Maybe<Scalars['Int']['output']>;
  /** 小分類コード（連携） */
  smallCd?: Maybe<Scalars['Int']['output']>;
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
};


/**
 *
 * 小分類
 */
export type SmallCategoryItemsArgs = {
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<ItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ItemWhereInput>;
};

export type SmallCategoryCount = {
  __typename?: 'SmallCategoryCount';
  items: Scalars['Int']['output'];
};


export type SmallCategoryCountItemsArgs = {
  where?: InputMaybe<ItemWhereInput>;
};

export type SmallCategoryCreateInput = {
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  smallCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type SmallCategoryCreateNestedOneWithoutItemsInput = {
  connect?: InputMaybe<SmallCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<SmallCategoryCreateOrConnectWithoutItemsInput>;
  create?: InputMaybe<SmallCategoryCreateWithoutItemsInput>;
};

export type SmallCategoryCreateOrConnectWithoutItemsInput = {
  create: SmallCategoryCreateWithoutItemsInput;
  where: SmallCategoryWhereUniqueInput;
};

export type SmallCategoryCreateWithoutItemsInput = {
  name: Scalars['String']['input'];
  seq?: InputMaybe<Scalars['Int']['input']>;
  smallCd?: InputMaybe<Scalars['Int']['input']>;
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type SmallCategoryOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  items?: InputMaybe<ItemOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  seq?: InputMaybe<SortOrderInput>;
  smallCd?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
};

export type SmallCategoryRelationFilter = {
  is?: InputMaybe<SmallCategoryWhereInput>;
  isNot?: InputMaybe<SmallCategoryWhereInput>;
};

export enum SmallCategoryScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  Seq = 'seq',
  SmallCd = 'smallCd',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type SmallCategoryUpdateInput = {
  items?: InputMaybe<ItemUpdateManyWithoutSmallCategoryNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  seq?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  smallCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type SmallCategoryUpdateManyMutationInput = {
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  seq?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  smallCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type SmallCategoryWhereInput = {
  AND?: InputMaybe<Array<SmallCategoryWhereInput>>;
  NOT?: InputMaybe<Array<SmallCategoryWhereInput>>;
  OR?: InputMaybe<Array<SmallCategoryWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IntFilter>;
  items?: InputMaybe<ItemListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  seq?: InputMaybe<IntNullableFilter>;
  smallCd?: InputMaybe<IntNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type SmallCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  smallCd?: InputMaybe<Scalars['Int']['input']>;
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

/**
 *
 * 得意先担当者（Web側のみ）
 */
export type Staff = {
  __typename?: 'Staff';
  _count?: Maybe<StaffCount>;
  cartItems: Array<CartItem>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** メールアドレス */
  email?: Maybe<Scalars['String']['output']>;
  /** 得意先担当者ID */
  id: Scalars['Int']['output'];
  /** ガイドツアーを表示するかどうか */
  isEnabledGuidetour: Scalars['Boolean']['output'];
  /** 担当者名 */
  name: Scalars['String']['output'];
  orderRequests: Array<OrderRequest>;
  orders: Array<Order>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wishlistItems: Array<WishlistItem>;
};


/**
 *
 * 得意先担当者（Web側のみ）
 */
export type StaffCartItemsArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CartItemWhereInput>;
};


/**
 *
 * 得意先担当者（Web側のみ）
 */
export type StaffOrderRequestsArgs = {
  cursor?: InputMaybe<OrderRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestWhereInput>;
};


/**
 *
 * 得意先担当者（Web側のみ）
 */
export type StaffOrdersArgs = {
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderWhereInput>;
};


/**
 *
 * 得意先担当者（Web側のみ）
 */
export type StaffWishlistItemsArgs = {
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type StaffCount = {
  __typename?: 'StaffCount';
  cartItems: Scalars['Int']['output'];
  orderRequests: Scalars['Int']['output'];
  orders: Scalars['Int']['output'];
  wishlistItems: Scalars['Int']['output'];
};


export type StaffCountCartItemsArgs = {
  where?: InputMaybe<CartItemWhereInput>;
};


export type StaffCountOrderRequestsArgs = {
  where?: InputMaybe<OrderRequestWhereInput>;
};


export type StaffCountOrdersArgs = {
  where?: InputMaybe<OrderWhereInput>;
};


export type StaffCountWishlistItemsArgs = {
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type StaffCreateInput = {
  customer: CustomerCreateNestedOneWithoutStaffsInput;
  email?: InputMaybe<Scalars['String']['input']>;
  isEnabledGuidetour?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StaffCreateManyCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabledGuidetour?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StaffCreateManyCustomerInputEnvelope = {
  data: Array<StaffCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffCreateNestedOneWithoutCartItemsInput = {
  connect?: InputMaybe<StaffWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StaffCreateOrConnectWithoutCartItemsInput>;
  create?: InputMaybe<StaffCreateWithoutCartItemsInput>;
};

export type StaffCreateNestedOneWithoutOrderRequestsInput = {
  connect?: InputMaybe<StaffWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StaffCreateOrConnectWithoutOrderRequestsInput>;
  create?: InputMaybe<StaffCreateWithoutOrderRequestsInput>;
};

export type StaffCreateNestedOneWithoutOrdersInput = {
  connect?: InputMaybe<StaffWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StaffCreateOrConnectWithoutOrdersInput>;
  create?: InputMaybe<StaffCreateWithoutOrdersInput>;
};

export type StaffCreateNestedOneWithoutWishlistItemsInput = {
  connect?: InputMaybe<StaffWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StaffCreateOrConnectWithoutWishlistItemsInput>;
  create?: InputMaybe<StaffCreateWithoutWishlistItemsInput>;
};

export type StaffCreateOrConnectWithoutCartItemsInput = {
  create: StaffCreateWithoutCartItemsInput;
  where: StaffWhereUniqueInput;
};

export type StaffCreateOrConnectWithoutCustomerInput = {
  create: StaffCreateWithoutCustomerInput;
  where: StaffWhereUniqueInput;
};

export type StaffCreateOrConnectWithoutOrderRequestsInput = {
  create: StaffCreateWithoutOrderRequestsInput;
  where: StaffWhereUniqueInput;
};

export type StaffCreateOrConnectWithoutOrdersInput = {
  create: StaffCreateWithoutOrdersInput;
  where: StaffWhereUniqueInput;
};

export type StaffCreateOrConnectWithoutWishlistItemsInput = {
  create: StaffCreateWithoutWishlistItemsInput;
  where: StaffWhereUniqueInput;
};

export type StaffCreateWithoutCartItemsInput = {
  customer: CustomerCreateNestedOneWithoutStaffsInput;
  email?: InputMaybe<Scalars['String']['input']>;
  isEnabledGuidetour?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StaffCreateWithoutCustomerInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  isEnabledGuidetour?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StaffCreateWithoutOrderRequestsInput = {
  customer: CustomerCreateNestedOneWithoutStaffsInput;
  email?: InputMaybe<Scalars['String']['input']>;
  isEnabledGuidetour?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StaffCreateWithoutOrdersInput = {
  customer: CustomerCreateNestedOneWithoutStaffsInput;
  email?: InputMaybe<Scalars['String']['input']>;
  isEnabledGuidetour?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StaffCreateWithoutWishlistItemsInput = {
  customer: CustomerCreateNestedOneWithoutStaffsInput;
  email?: InputMaybe<Scalars['String']['input']>;
  isEnabledGuidetour?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type StaffListRelationFilter = {
  every?: InputMaybe<StaffWhereInput>;
  none?: InputMaybe<StaffWhereInput>;
  some?: InputMaybe<StaffWhereInput>;
};

export type StaffOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StaffOrderByWithRelationInput = {
  cartItems?: InputMaybe<CartItemOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isEnabledGuidetour?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  orderRequests?: InputMaybe<OrderRequestOrderByRelationAggregateInput>;
  orders?: InputMaybe<OrderOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
  wishlistItems?: InputMaybe<WishlistItemOrderByRelationAggregateInput>;
};

export type StaffRelationFilter = {
  is?: InputMaybe<StaffWhereInput>;
  isNot?: InputMaybe<StaffWhereInput>;
};

export enum StaffScalarFieldEnum {
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Email = 'email',
  Id = 'id',
  IsEnabledGuidetour = 'isEnabledGuidetour',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type StaffScalarWhereInput = {
  AND?: InputMaybe<Array<StaffScalarWhereInput>>;
  NOT?: InputMaybe<Array<StaffScalarWhereInput>>;
  OR?: InputMaybe<Array<StaffScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isEnabledGuidetour?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type StaffUpdateInput = {
  cartItems?: InputMaybe<CartItemUpdateManyWithoutStaffNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isEnabledGuidetour?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderRequests?: InputMaybe<OrderRequestUpdateManyWithoutStaffNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutStaffNestedInput>;
  wishlistItems?: InputMaybe<WishlistItemUpdateManyWithoutStaffNestedInput>;
};

export type StaffUpdateManyMutationInput = {
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isEnabledGuidetour?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type StaffUpdateManyWithWhereWithoutCustomerInput = {
  data: StaffUpdateManyMutationInput;
  where: StaffScalarWhereInput;
};

export type StaffUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<StaffWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StaffCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<StaffCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<StaffCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<StaffWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StaffScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StaffWhereUniqueInput>>;
  set?: InputMaybe<Array<StaffWhereUniqueInput>>;
  update?: InputMaybe<Array<StaffUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<StaffUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<StaffUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type StaffUpdateWithWhereUniqueWithoutCustomerInput = {
  data: StaffUpdateWithoutCustomerInput;
  where: StaffWhereUniqueInput;
};

export type StaffUpdateWithoutCustomerInput = {
  cartItems?: InputMaybe<CartItemUpdateManyWithoutStaffNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isEnabledGuidetour?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  orderRequests?: InputMaybe<OrderRequestUpdateManyWithoutStaffNestedInput>;
  orders?: InputMaybe<OrderUpdateManyWithoutStaffNestedInput>;
  wishlistItems?: InputMaybe<WishlistItemUpdateManyWithoutStaffNestedInput>;
};

export type StaffUpsertWithWhereUniqueWithoutCustomerInput = {
  create: StaffCreateWithoutCustomerInput;
  update: StaffUpdateWithoutCustomerInput;
  where: StaffWhereUniqueInput;
};

export type StaffWhereInput = {
  AND?: InputMaybe<Array<StaffWhereInput>>;
  NOT?: InputMaybe<Array<StaffWhereInput>>;
  OR?: InputMaybe<Array<StaffWhereInput>>;
  cartItems?: InputMaybe<CartItemListRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  email?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IntFilter>;
  isEnabledGuidetour?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  orderRequests?: InputMaybe<OrderRequestListRelationFilter>;
  orders?: InputMaybe<OrderListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  wishlistItems?: InputMaybe<WishlistItemListRelationFilter>;
};

export type StaffWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/**
 *
 * 商品在庫
 */
export type StockItem = {
  __typename?: 'StockItem';
  _count?: Maybe<StockItemCount>;
  /** カート内商品 */
  cartItem: Array<CartItem>;
  /** 原価（連携） */
  costPrice: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** 径（連携） */
  diameter: Scalars['String']['output'];
  /** 径CD（連携） */
  diameterCd: Scalars['Int']['output'];
  /** 商品在庫ID */
  id: Scalars['Int']['output'];
  /** 商品 */
  item: Item;
  /** 品種CD（連携） */
  itemCd: Scalars['BigInt']['output'];
  /** 商品ID */
  itemId: Scalars['Int']['output'];
  /** 長さ（連携） */
  length: Scalars['String']['output'];
  /** 長さCD（連携） */
  lengthCd: Scalars['Int']['output'];
  /** 注文明細 */
  orderDetail: Array<OrderDetail>;
  /** 注文依頼明細 */
  orderRequestDetail: Array<OrderRequestDetail>;
  /** ケース入数（連携） */
  quantityParCase: Scalars['Int']['output'];
  /** 小箱入数（連携） */
  quantityParPack: Scalars['Int']['output'];
  /** 概算在庫数 */
  roughStockQuantity: Scalars['Int']['output'];
  /** サイズCD（連携） */
  sizeCd: Scalars['BigInt']['output'];
  /** サイズ名（連携） */
  sizeName: Scalars['String']['output'];
  /** 商品在庫単価 */
  stockItemUnitPrices: Array<StockItemUnitPrice>;
  /** 東大阪在庫数 */
  stockQuantityHigashi: Scalars['Int']['output'];
  /** 在庫数記号 */
  stockQuantitySymbol: Scalars['String']['output'];
  /** 八尾在庫数 */
  stockQuantityYao: Scalars['Int']['output'];
  /** 在庫数合計 */
  totalStockQuantity: Scalars['Int']['output'];
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
  /** お気に入り内商品 */
  wishlistItem: Array<WishlistItem>;
};


/**
 *
 * 商品在庫
 */
export type StockItemCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CartItemWhereInput>;
};


/**
 *
 * 商品在庫
 */
export type StockItemOrderDetailArgs = {
  cursor?: InputMaybe<OrderDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderDetailWhereInput>;
};


/**
 *
 * 商品在庫
 */
export type StockItemOrderRequestDetailArgs = {
  cursor?: InputMaybe<OrderRequestDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};


/**
 *
 * 商品在庫
 */
export type StockItemStockItemUnitPricesArgs = {
  cursor?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  distinct?: InputMaybe<Array<StockItemUnitPriceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<StockItemUnitPriceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
};


/**
 *
 * 商品在庫
 */
export type StockItemWishlistItemArgs = {
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type StockItemAvgAggregate = {
  __typename?: 'StockItemAvgAggregate';
  costPrice?: Maybe<Scalars['Decimal']['output']>;
  diameterCd?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  itemCd?: Maybe<Scalars['Float']['output']>;
  itemId?: Maybe<Scalars['Float']['output']>;
  lengthCd?: Maybe<Scalars['Float']['output']>;
  quantityParCase?: Maybe<Scalars['Float']['output']>;
  quantityParPack?: Maybe<Scalars['Float']['output']>;
  roughStockQuantity?: Maybe<Scalars['Float']['output']>;
  sizeCd?: Maybe<Scalars['Float']['output']>;
  stockQuantityHigashi?: Maybe<Scalars['Float']['output']>;
  stockQuantityYao?: Maybe<Scalars['Float']['output']>;
  totalStockQuantity?: Maybe<Scalars['Float']['output']>;
  updatedBy?: Maybe<Scalars['Float']['output']>;
};

export type StockItemCount = {
  __typename?: 'StockItemCount';
  cartItem: Scalars['Int']['output'];
  orderDetail: Scalars['Int']['output'];
  orderRequestDetail: Scalars['Int']['output'];
  stockItemUnitPrices: Scalars['Int']['output'];
  wishlistItem: Scalars['Int']['output'];
};


export type StockItemCountCartItemArgs = {
  where?: InputMaybe<CartItemWhereInput>;
};


export type StockItemCountOrderDetailArgs = {
  where?: InputMaybe<OrderDetailWhereInput>;
};


export type StockItemCountOrderRequestDetailArgs = {
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};


export type StockItemCountStockItemUnitPricesArgs = {
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
};


export type StockItemCountWishlistItemArgs = {
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type StockItemCountAggregate = {
  __typename?: 'StockItemCountAggregate';
  _all: Scalars['Int']['output'];
  costPrice: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  diameter: Scalars['Int']['output'];
  diameterCd: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemCd: Scalars['Int']['output'];
  itemId: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
  lengthCd: Scalars['Int']['output'];
  quantityParCase: Scalars['Int']['output'];
  quantityParPack: Scalars['Int']['output'];
  roughStockQuantity: Scalars['Int']['output'];
  sizeCd: Scalars['Int']['output'];
  sizeName: Scalars['Int']['output'];
  stockQuantityHigashi: Scalars['Int']['output'];
  stockQuantitySymbol: Scalars['Int']['output'];
  stockQuantityYao: Scalars['Int']['output'];
  totalStockQuantity: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  updatedBy: Scalars['Int']['output'];
};

export type StockItemCreateInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  item: ItemCreateNestedOneWithoutStockItemsInput;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemCreateManyItemInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemCreateManyItemInputEnvelope = {
  data: Array<StockItemCreateManyItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StockItemCreateNestedOneWithoutCartItemInput = {
  connect?: InputMaybe<StockItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemCreateOrConnectWithoutCartItemInput>;
  create?: InputMaybe<StockItemCreateWithoutCartItemInput>;
};

export type StockItemCreateNestedOneWithoutOrderDetailInput = {
  connect?: InputMaybe<StockItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemCreateOrConnectWithoutOrderDetailInput>;
  create?: InputMaybe<StockItemCreateWithoutOrderDetailInput>;
};

export type StockItemCreateNestedOneWithoutOrderRequestDetailInput = {
  connect?: InputMaybe<StockItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemCreateOrConnectWithoutOrderRequestDetailInput>;
  create?: InputMaybe<StockItemCreateWithoutOrderRequestDetailInput>;
};

export type StockItemCreateNestedOneWithoutStockItemUnitPricesInput = {
  connect?: InputMaybe<StockItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemCreateOrConnectWithoutStockItemUnitPricesInput>;
  create?: InputMaybe<StockItemCreateWithoutStockItemUnitPricesInput>;
};

export type StockItemCreateNestedOneWithoutWishlistItemInput = {
  connect?: InputMaybe<StockItemWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemCreateOrConnectWithoutWishlistItemInput>;
  create?: InputMaybe<StockItemCreateWithoutWishlistItemInput>;
};

export type StockItemCreateOrConnectWithoutCartItemInput = {
  create: StockItemCreateWithoutCartItemInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemCreateOrConnectWithoutItemInput = {
  create: StockItemCreateWithoutItemInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemCreateOrConnectWithoutOrderDetailInput = {
  create: StockItemCreateWithoutOrderDetailInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemCreateOrConnectWithoutOrderRequestDetailInput = {
  create: StockItemCreateWithoutOrderRequestDetailInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemCreateOrConnectWithoutStockItemUnitPricesInput = {
  create: StockItemCreateWithoutStockItemUnitPricesInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemCreateOrConnectWithoutWishlistItemInput = {
  create: StockItemCreateWithoutWishlistItemInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemCreateWithoutCartItemInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  item: ItemCreateNestedOneWithoutStockItemsInput;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemCreateWithoutItemInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemCreateWithoutOrderDetailInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  item: ItemCreateNestedOneWithoutStockItemsInput;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemCreateWithoutOrderRequestDetailInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  item: ItemCreateNestedOneWithoutStockItemsInput;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemCreateWithoutStockItemUnitPricesInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  item: ItemCreateNestedOneWithoutStockItemsInput;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemCreateWithoutWishlistItemInput = {
  costPrice: Scalars['Decimal']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  item: ItemCreateNestedOneWithoutStockItemsInput;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  quantityParCase: Scalars['Int']['input'];
  quantityParPack: Scalars['Int']['input'];
  roughStockQuantity: Scalars['Int']['input'];
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockQuantityHigashi: Scalars['Int']['input'];
  stockQuantitySymbol: Scalars['String']['input'];
  stockQuantityYao: Scalars['Int']['input'];
  totalStockQuantity: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemItemCdSizeCdCompoundUniqueInput = {
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
};

export type StockItemListRelationFilter = {
  every?: InputMaybe<StockItemWhereInput>;
  none?: InputMaybe<StockItemWhereInput>;
  some?: InputMaybe<StockItemWhereInput>;
};

export type StockItemMaxAggregate = {
  __typename?: 'StockItemMaxAggregate';
  costPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  diameter?: Maybe<Scalars['String']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  quantityParCase?: Maybe<Scalars['Int']['output']>;
  quantityParPack?: Maybe<Scalars['Int']['output']>;
  roughStockQuantity?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  sizeName?: Maybe<Scalars['String']['output']>;
  stockQuantityHigashi?: Maybe<Scalars['Int']['output']>;
  stockQuantitySymbol?: Maybe<Scalars['String']['output']>;
  stockQuantityYao?: Maybe<Scalars['Int']['output']>;
  totalStockQuantity?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type StockItemMinAggregate = {
  __typename?: 'StockItemMinAggregate';
  costPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  diameter?: Maybe<Scalars['String']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  quantityParCase?: Maybe<Scalars['Int']['output']>;
  quantityParPack?: Maybe<Scalars['Int']['output']>;
  roughStockQuantity?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  sizeName?: Maybe<Scalars['String']['output']>;
  stockQuantityHigashi?: Maybe<Scalars['Int']['output']>;
  stockQuantitySymbol?: Maybe<Scalars['String']['output']>;
  stockQuantityYao?: Maybe<Scalars['Int']['output']>;
  totalStockQuantity?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

export type StockItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StockItemOrderByWithRelationInput = {
  cartItem?: InputMaybe<CartItemOrderByRelationAggregateInput>;
  costPrice?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  diameter?: InputMaybe<SortOrder>;
  diameterCd?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  item?: InputMaybe<ItemOrderByWithRelationInput>;
  itemCd?: InputMaybe<SortOrder>;
  itemId?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  lengthCd?: InputMaybe<SortOrder>;
  orderDetail?: InputMaybe<OrderDetailOrderByRelationAggregateInput>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailOrderByRelationAggregateInput>;
  quantityParCase?: InputMaybe<SortOrder>;
  quantityParPack?: InputMaybe<SortOrder>;
  roughStockQuantity?: InputMaybe<SortOrder>;
  sizeCd?: InputMaybe<SortOrder>;
  sizeName?: InputMaybe<SortOrder>;
  stockItemUnitPrices?: InputMaybe<StockItemUnitPriceOrderByRelationAggregateInput>;
  stockQuantityHigashi?: InputMaybe<SortOrder>;
  stockQuantitySymbol?: InputMaybe<SortOrder>;
  stockQuantityYao?: InputMaybe<SortOrder>;
  totalStockQuantity?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
  wishlistItem?: InputMaybe<WishlistItemOrderByRelationAggregateInput>;
};

export type StockItemRelationFilter = {
  is?: InputMaybe<StockItemWhereInput>;
  isNot?: InputMaybe<StockItemWhereInput>;
};

export enum StockItemScalarFieldEnum {
  CostPrice = 'costPrice',
  CreatedAt = 'createdAt',
  Diameter = 'diameter',
  DiameterCd = 'diameterCd',
  Id = 'id',
  ItemCd = 'itemCd',
  ItemId = 'itemId',
  Length = 'length',
  LengthCd = 'lengthCd',
  QuantityParCase = 'quantityParCase',
  QuantityParPack = 'quantityParPack',
  RoughStockQuantity = 'roughStockQuantity',
  SizeCd = 'sizeCd',
  SizeName = 'sizeName',
  StockQuantityHigashi = 'stockQuantityHigashi',
  StockQuantitySymbol = 'stockQuantitySymbol',
  StockQuantityYao = 'stockQuantityYao',
  TotalStockQuantity = 'totalStockQuantity',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type StockItemScalarWhereInput = {
  AND?: InputMaybe<Array<StockItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<StockItemScalarWhereInput>>;
  OR?: InputMaybe<Array<StockItemScalarWhereInput>>;
  costPrice?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  itemId?: InputMaybe<IntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  quantityParCase?: InputMaybe<IntFilter>;
  quantityParPack?: InputMaybe<IntFilter>;
  roughStockQuantity?: InputMaybe<IntFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  stockQuantityHigashi?: InputMaybe<IntFilter>;
  stockQuantitySymbol?: InputMaybe<StringFilter>;
  stockQuantityYao?: InputMaybe<IntFilter>;
  totalStockQuantity?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type StockItemSumAggregate = {
  __typename?: 'StockItemSumAggregate';
  costPrice?: Maybe<Scalars['Decimal']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  quantityParCase?: Maybe<Scalars['Int']['output']>;
  quantityParPack?: Maybe<Scalars['Int']['output']>;
  roughStockQuantity?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  stockQuantityHigashi?: Maybe<Scalars['Int']['output']>;
  stockQuantityYao?: Maybe<Scalars['Int']['output']>;
  totalStockQuantity?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['Int']['output']>;
};

/**
 *
 * 商品在庫単価
 */
export type StockItemUnitPrice = {
  __typename?: 'StockItemUnitPrice';
  _count?: Maybe<StockItemUnitPriceCount>;
  /** カート内商品 */
  cartItem: Array<CartItem>;
  /** 原価（連携） */
  costPrice: Scalars['Decimal']['output'];
  /** バラ掛率（連携） */
  costRate: Scalars['Decimal']['output'];
  /** ケース掛率（連携） */
  costRateOfCase: Scalars['Decimal']['output'];
  /** 小箱掛率（連携） */
  costRateOfPack: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先CD（連携） */
  customerCd: Scalars['Int']['output'];
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** 商品在庫単価ID */
  id: Scalars['Int']['output'];
  /** 品種CD（連携） */
  itemCd: Scalars['BigInt']['output'];
  /** 注文明細 */
  orderDetail: Array<OrderDetail>;
  /** 注文依頼明細 */
  orderRequestDetail: Array<OrderRequestDetail>;
  /** サイズCD（連携） */
  sizeCd: Scalars['BigInt']['output'];
  /** 商品在庫 */
  stockItem: StockItem;
  /** 商品在庫ID */
  stockItemId: Scalars['Int']['output'];
  /** バラ単価（連携） */
  unitPrice: Scalars['Decimal']['output'];
  /** ケース単価（連携） */
  unitPriceParCase: Scalars['Decimal']['output'];
  /** 小箱単価（連携） */
  unitPriceParPack: Scalars['Decimal']['output'];
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者（連携） */
  updatedBy?: Maybe<Scalars['Int']['output']>;
  /** お気に入り内商品 */
  wishlistItem: Array<WishlistItem>;
};


/**
 *
 * 商品在庫単価
 */
export type StockItemUnitPriceCartItemArgs = {
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CartItemWhereInput>;
};


/**
 *
 * 商品在庫単価
 */
export type StockItemUnitPriceOrderDetailArgs = {
  cursor?: InputMaybe<OrderDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderDetailWhereInput>;
};


/**
 *
 * 商品在庫単価
 */
export type StockItemUnitPriceOrderRequestDetailArgs = {
  cursor?: InputMaybe<OrderRequestDetailWhereUniqueInput>;
  distinct?: InputMaybe<Array<OrderRequestDetailScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OrderRequestDetailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};


/**
 *
 * 商品在庫単価
 */
export type StockItemUnitPriceWishlistItemArgs = {
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type StockItemUnitPriceCount = {
  __typename?: 'StockItemUnitPriceCount';
  cartItem: Scalars['Int']['output'];
  orderDetail: Scalars['Int']['output'];
  orderRequestDetail: Scalars['Int']['output'];
  wishlistItem: Scalars['Int']['output'];
};


export type StockItemUnitPriceCountCartItemArgs = {
  where?: InputMaybe<CartItemWhereInput>;
};


export type StockItemUnitPriceCountOrderDetailArgs = {
  where?: InputMaybe<OrderDetailWhereInput>;
};


export type StockItemUnitPriceCountOrderRequestDetailArgs = {
  where?: InputMaybe<OrderRequestDetailWhereInput>;
};


export type StockItemUnitPriceCountWishlistItemArgs = {
  where?: InputMaybe<WishlistItemWhereInput>;
};

export type StockItemUnitPriceCreateInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customer: CustomerCreateNestedOneWithoutStockItemUnitPricesInput;
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  stockItem: StockItemCreateNestedOneWithoutStockItemUnitPricesInput;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateManyCustomerInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customerCd: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  stockItemId: Scalars['Int']['input'];
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateManyCustomerInputEnvelope = {
  data: Array<StockItemUnitPriceCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StockItemUnitPriceCreateManyStockItemInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customerCd: Scalars['Int']['input'];
  customerId: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateManyStockItemInputEnvelope = {
  data: Array<StockItemUnitPriceCreateManyStockItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StockItemUnitPriceCreateNestedOneWithoutCartItemInput = {
  connect?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemUnitPriceCreateOrConnectWithoutCartItemInput>;
  create?: InputMaybe<StockItemUnitPriceCreateWithoutCartItemInput>;
};

export type StockItemUnitPriceCreateNestedOneWithoutOrderDetailInput = {
  connect?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemUnitPriceCreateOrConnectWithoutOrderDetailInput>;
  create?: InputMaybe<StockItemUnitPriceCreateWithoutOrderDetailInput>;
};

export type StockItemUnitPriceCreateNestedOneWithoutOrderRequestDetailInput = {
  connect?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemUnitPriceCreateOrConnectWithoutOrderRequestDetailInput>;
  create?: InputMaybe<StockItemUnitPriceCreateWithoutOrderRequestDetailInput>;
};

export type StockItemUnitPriceCreateNestedOneWithoutWishlistItemInput = {
  connect?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<StockItemUnitPriceCreateOrConnectWithoutWishlistItemInput>;
  create?: InputMaybe<StockItemUnitPriceCreateWithoutWishlistItemInput>;
};

export type StockItemUnitPriceCreateOrConnectWithoutCartItemInput = {
  create: StockItemUnitPriceCreateWithoutCartItemInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceCreateOrConnectWithoutCustomerInput = {
  create: StockItemUnitPriceCreateWithoutCustomerInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceCreateOrConnectWithoutOrderDetailInput = {
  create: StockItemUnitPriceCreateWithoutOrderDetailInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceCreateOrConnectWithoutOrderRequestDetailInput = {
  create: StockItemUnitPriceCreateWithoutOrderRequestDetailInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceCreateOrConnectWithoutStockItemInput = {
  create: StockItemUnitPriceCreateWithoutStockItemInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceCreateOrConnectWithoutWishlistItemInput = {
  create: StockItemUnitPriceCreateWithoutWishlistItemInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceCreateWithoutCartItemInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customer: CustomerCreateNestedOneWithoutStockItemUnitPricesInput;
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  stockItem: StockItemCreateNestedOneWithoutStockItemUnitPricesInput;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateWithoutCustomerInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  stockItem: StockItemCreateNestedOneWithoutStockItemUnitPricesInput;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateWithoutOrderDetailInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customer: CustomerCreateNestedOneWithoutStockItemUnitPricesInput;
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  stockItem: StockItemCreateNestedOneWithoutStockItemUnitPricesInput;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateWithoutOrderRequestDetailInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customer: CustomerCreateNestedOneWithoutStockItemUnitPricesInput;
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  stockItem: StockItemCreateNestedOneWithoutStockItemUnitPricesInput;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateWithoutStockItemInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customer: CustomerCreateNestedOneWithoutStockItemUnitPricesInput;
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCreateWithoutWishlistItemInput = {
  costPrice: Scalars['Decimal']['input'];
  costRate: Scalars['Decimal']['input'];
  costRateOfCase: Scalars['Decimal']['input'];
  costRateOfPack: Scalars['Decimal']['input'];
  customer: CustomerCreateNestedOneWithoutStockItemUnitPricesInput;
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  stockItem: StockItemCreateNestedOneWithoutStockItemUnitPricesInput;
  unitPrice: Scalars['Decimal']['input'];
  unitPriceParCase: Scalars['Decimal']['input'];
  unitPriceParPack: Scalars['Decimal']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUnitPriceCustomerCdItemCdSizeCdCompoundUniqueInput = {
  customerCd: Scalars['Int']['input'];
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
};

export type StockItemUnitPriceListRelationFilter = {
  every?: InputMaybe<StockItemUnitPriceWhereInput>;
  none?: InputMaybe<StockItemUnitPriceWhereInput>;
  some?: InputMaybe<StockItemUnitPriceWhereInput>;
};

export type StockItemUnitPriceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type StockItemUnitPriceOrderByWithRelationInput = {
  cartItem?: InputMaybe<CartItemOrderByRelationAggregateInput>;
  costPrice?: InputMaybe<SortOrder>;
  costRate?: InputMaybe<SortOrder>;
  costRateOfCase?: InputMaybe<SortOrder>;
  costRateOfPack?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerCd?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  itemCd?: InputMaybe<SortOrder>;
  orderDetail?: InputMaybe<OrderDetailOrderByRelationAggregateInput>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailOrderByRelationAggregateInput>;
  sizeCd?: InputMaybe<SortOrder>;
  stockItem?: InputMaybe<StockItemOrderByWithRelationInput>;
  stockItemId?: InputMaybe<SortOrder>;
  unitPrice?: InputMaybe<SortOrder>;
  unitPriceParCase?: InputMaybe<SortOrder>;
  unitPriceParPack?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
  wishlistItem?: InputMaybe<WishlistItemOrderByRelationAggregateInput>;
};

export type StockItemUnitPriceRelationFilter = {
  is?: InputMaybe<StockItemUnitPriceWhereInput>;
  isNot?: InputMaybe<StockItemUnitPriceWhereInput>;
};

export enum StockItemUnitPriceScalarFieldEnum {
  CostPrice = 'costPrice',
  CostRate = 'costRate',
  CostRateOfCase = 'costRateOfCase',
  CostRateOfPack = 'costRateOfPack',
  CreatedAt = 'createdAt',
  CustomerCd = 'customerCd',
  CustomerId = 'customerId',
  Id = 'id',
  ItemCd = 'itemCd',
  SizeCd = 'sizeCd',
  StockItemId = 'stockItemId',
  UnitPrice = 'unitPrice',
  UnitPriceParCase = 'unitPriceParCase',
  UnitPriceParPack = 'unitPriceParPack',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy'
}

export type StockItemUnitPriceScalarWhereInput = {
  AND?: InputMaybe<Array<StockItemUnitPriceScalarWhereInput>>;
  NOT?: InputMaybe<Array<StockItemUnitPriceScalarWhereInput>>;
  OR?: InputMaybe<Array<StockItemUnitPriceScalarWhereInput>>;
  costPrice?: InputMaybe<DecimalFilter>;
  costRate?: InputMaybe<DecimalFilter>;
  costRateOfCase?: InputMaybe<DecimalFilter>;
  costRateOfPack?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerCd?: InputMaybe<IntFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  stockItemId?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceParCase?: InputMaybe<DecimalFilter>;
  unitPriceParPack?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
};

export type StockItemUnitPriceUpdateInput = {
  cartItem?: InputMaybe<CartItemUpdateManyWithoutStockItemUnitPriceNestedInput>;
  costPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRate?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  orderDetail?: InputMaybe<OrderDetailUpdateManyWithoutStockItemUnitPriceNestedInput>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailUpdateManyWithoutStockItemUnitPriceNestedInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  wishlistItem?: InputMaybe<WishlistItemUpdateManyWithoutStockItemUnitPriceNestedInput>;
};

export type StockItemUnitPriceUpdateManyMutationInput = {
  costPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRate?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type StockItemUnitPriceUpdateManyWithWhereWithoutCustomerInput = {
  data: StockItemUnitPriceUpdateManyMutationInput;
  where: StockItemUnitPriceScalarWhereInput;
};

export type StockItemUnitPriceUpdateManyWithWhereWithoutStockItemInput = {
  data: StockItemUnitPriceUpdateManyMutationInput;
  where: StockItemUnitPriceScalarWhereInput;
};

export type StockItemUnitPriceUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StockItemUnitPriceCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<StockItemUnitPriceCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<StockItemUnitPriceCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StockItemUnitPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<StockItemUnitPriceUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<StockItemUnitPriceUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<StockItemUnitPriceUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type StockItemUnitPriceUpdateManyWithoutStockItemNestedInput = {
  connect?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StockItemUnitPriceCreateOrConnectWithoutStockItemInput>>;
  create?: InputMaybe<Array<StockItemUnitPriceCreateWithoutStockItemInput>>;
  createMany?: InputMaybe<StockItemUnitPriceCreateManyStockItemInputEnvelope>;
  delete?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StockItemUnitPriceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  set?: InputMaybe<Array<StockItemUnitPriceWhereUniqueInput>>;
  update?: InputMaybe<Array<StockItemUnitPriceUpdateWithWhereUniqueWithoutStockItemInput>>;
  updateMany?: InputMaybe<Array<StockItemUnitPriceUpdateManyWithWhereWithoutStockItemInput>>;
  upsert?: InputMaybe<Array<StockItemUnitPriceUpsertWithWhereUniqueWithoutStockItemInput>>;
};

export type StockItemUnitPriceUpdateWithWhereUniqueWithoutCustomerInput = {
  data: StockItemUnitPriceUpdateWithoutCustomerInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceUpdateWithWhereUniqueWithoutStockItemInput = {
  data: StockItemUnitPriceUpdateWithoutStockItemInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceUpdateWithoutCustomerInput = {
  cartItem?: InputMaybe<CartItemUpdateManyWithoutStockItemUnitPriceNestedInput>;
  costPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRate?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  orderDetail?: InputMaybe<OrderDetailUpdateManyWithoutStockItemUnitPriceNestedInput>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailUpdateManyWithoutStockItemUnitPriceNestedInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  wishlistItem?: InputMaybe<WishlistItemUpdateManyWithoutStockItemUnitPriceNestedInput>;
};

export type StockItemUnitPriceUpdateWithoutStockItemInput = {
  cartItem?: InputMaybe<CartItemUpdateManyWithoutStockItemUnitPriceNestedInput>;
  costPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRate?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  costRateOfPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  customerCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  orderDetail?: InputMaybe<OrderDetailUpdateManyWithoutStockItemUnitPriceNestedInput>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailUpdateManyWithoutStockItemUnitPriceNestedInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  unitPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParCase?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  unitPriceParPack?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  wishlistItem?: InputMaybe<WishlistItemUpdateManyWithoutStockItemUnitPriceNestedInput>;
};

export type StockItemUnitPriceUpsertWithWhereUniqueWithoutCustomerInput = {
  create: StockItemUnitPriceCreateWithoutCustomerInput;
  update: StockItemUnitPriceUpdateWithoutCustomerInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceUpsertWithWhereUniqueWithoutStockItemInput = {
  create: StockItemUnitPriceCreateWithoutStockItemInput;
  update: StockItemUnitPriceUpdateWithoutStockItemInput;
  where: StockItemUnitPriceWhereUniqueInput;
};

export type StockItemUnitPriceWhereInput = {
  AND?: InputMaybe<Array<StockItemUnitPriceWhereInput>>;
  NOT?: InputMaybe<Array<StockItemUnitPriceWhereInput>>;
  OR?: InputMaybe<Array<StockItemUnitPriceWhereInput>>;
  cartItem?: InputMaybe<CartItemListRelationFilter>;
  costPrice?: InputMaybe<DecimalFilter>;
  costRate?: InputMaybe<DecimalFilter>;
  costRateOfCase?: InputMaybe<DecimalFilter>;
  costRateOfPack?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerCd?: InputMaybe<IntFilter>;
  customerId?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  orderDetail?: InputMaybe<OrderDetailListRelationFilter>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailListRelationFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  stockItem?: InputMaybe<StockItemRelationFilter>;
  stockItemId?: InputMaybe<IntFilter>;
  unitPrice?: InputMaybe<DecimalFilter>;
  unitPriceParCase?: InputMaybe<DecimalFilter>;
  unitPriceParPack?: InputMaybe<DecimalFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
  wishlistItem?: InputMaybe<WishlistItemListRelationFilter>;
};

export type StockItemUnitPriceWhereUniqueInput = {
  customerCd_itemCd_sizeCd?: InputMaybe<StockItemUnitPriceCustomerCdItemCdSizeCdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};

export type StockItemUpdateInput = {
  cartItem?: InputMaybe<CartItemUpdateManyWithoutStockItemNestedInput>;
  costPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  orderDetail?: InputMaybe<OrderDetailUpdateManyWithoutStockItemNestedInput>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailUpdateManyWithoutStockItemNestedInput>;
  quantityParCase?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParPack?: InputMaybe<IntFieldUpdateOperationsInput>;
  roughStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  stockItemUnitPrices?: InputMaybe<StockItemUnitPriceUpdateManyWithoutStockItemNestedInput>;
  stockQuantityHigashi?: InputMaybe<IntFieldUpdateOperationsInput>;
  stockQuantitySymbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  stockQuantityYao?: InputMaybe<IntFieldUpdateOperationsInput>;
  totalStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  wishlistItem?: InputMaybe<WishlistItemUpdateManyWithoutStockItemNestedInput>;
};

export type StockItemUpdateManyMutationInput = {
  costPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParCase?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParPack?: InputMaybe<IntFieldUpdateOperationsInput>;
  roughStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  stockQuantityHigashi?: InputMaybe<IntFieldUpdateOperationsInput>;
  stockQuantitySymbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  stockQuantityYao?: InputMaybe<IntFieldUpdateOperationsInput>;
  totalStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type StockItemUpdateManyWithWhereWithoutItemInput = {
  data: StockItemUpdateManyMutationInput;
  where: StockItemScalarWhereInput;
};

export type StockItemUpdateManyWithoutItemNestedInput = {
  connect?: InputMaybe<Array<StockItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<StockItemCreateOrConnectWithoutItemInput>>;
  create?: InputMaybe<Array<StockItemCreateWithoutItemInput>>;
  createMany?: InputMaybe<StockItemCreateManyItemInputEnvelope>;
  delete?: InputMaybe<Array<StockItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<StockItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<StockItemWhereUniqueInput>>;
  set?: InputMaybe<Array<StockItemWhereUniqueInput>>;
  update?: InputMaybe<Array<StockItemUpdateWithWhereUniqueWithoutItemInput>>;
  updateMany?: InputMaybe<Array<StockItemUpdateManyWithWhereWithoutItemInput>>;
  upsert?: InputMaybe<Array<StockItemUpsertWithWhereUniqueWithoutItemInput>>;
};

export type StockItemUpdateWithWhereUniqueWithoutItemInput = {
  data: StockItemUpdateWithoutItemInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemUpdateWithoutItemInput = {
  cartItem?: InputMaybe<CartItemUpdateManyWithoutStockItemNestedInput>;
  costPrice?: InputMaybe<DecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  orderDetail?: InputMaybe<OrderDetailUpdateManyWithoutStockItemNestedInput>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailUpdateManyWithoutStockItemNestedInput>;
  quantityParCase?: InputMaybe<IntFieldUpdateOperationsInput>;
  quantityParPack?: InputMaybe<IntFieldUpdateOperationsInput>;
  roughStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  stockItemUnitPrices?: InputMaybe<StockItemUnitPriceUpdateManyWithoutStockItemNestedInput>;
  stockQuantityHigashi?: InputMaybe<IntFieldUpdateOperationsInput>;
  stockQuantitySymbol?: InputMaybe<StringFieldUpdateOperationsInput>;
  stockQuantityYao?: InputMaybe<IntFieldUpdateOperationsInput>;
  totalStockQuantity?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  wishlistItem?: InputMaybe<WishlistItemUpdateManyWithoutStockItemNestedInput>;
};

export type StockItemUpsertWithWhereUniqueWithoutItemInput = {
  create: StockItemCreateWithoutItemInput;
  update: StockItemUpdateWithoutItemInput;
  where: StockItemWhereUniqueInput;
};

export type StockItemWhereInput = {
  AND?: InputMaybe<Array<StockItemWhereInput>>;
  NOT?: InputMaybe<Array<StockItemWhereInput>>;
  OR?: InputMaybe<Array<StockItemWhereInput>>;
  cartItem?: InputMaybe<CartItemListRelationFilter>;
  costPrice?: InputMaybe<DecimalFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  item?: InputMaybe<ItemRelationFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  itemId?: InputMaybe<IntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  orderDetail?: InputMaybe<OrderDetailListRelationFilter>;
  orderRequestDetail?: InputMaybe<OrderRequestDetailListRelationFilter>;
  quantityParCase?: InputMaybe<IntFilter>;
  quantityParPack?: InputMaybe<IntFilter>;
  roughStockQuantity?: InputMaybe<IntFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  stockItemUnitPrices?: InputMaybe<StockItemUnitPriceListRelationFilter>;
  stockQuantityHigashi?: InputMaybe<IntFilter>;
  stockQuantitySymbol?: InputMaybe<StringFilter>;
  stockQuantityYao?: InputMaybe<IntFilter>;
  totalStockQuantity?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
  wishlistItem?: InputMaybe<WishlistItemListRelationFilter>;
};

export type StockItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd_sizeCd?: InputMaybe<StockItemItemCdSizeCdCompoundUniqueInput>;
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/**
 *
 * システム設定
 */
export type SystemSetting = {
  __typename?: 'SystemSetting';
  createdAt: Scalars['DateTime']['output'];
  /** コード（連携） */
  key: Scalars['Int']['output'];
  /** 更新日時（連携） */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 更新者 */
  updatedBy?: Maybe<Scalars['Int']['output']>;
  /** 値（連携） */
  value: Scalars['Int']['output'];
};

export type SystemSettingCreateInput = {
  key: Scalars['Int']['input'];
  updatedBy?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type SystemSettingOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
  updatedBy?: InputMaybe<SortOrderInput>;
  value?: InputMaybe<SortOrder>;
};

export enum SystemSettingScalarFieldEnum {
  CreatedAt = 'createdAt',
  Key = 'key',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
  Value = 'value'
}

export type SystemSettingUpdateInput = {
  key?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  value?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SystemSettingUpdateManyMutationInput = {
  key?: InputMaybe<IntFieldUpdateOperationsInput>;
  updatedBy?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  value?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type SystemSettingWhereInput = {
  AND?: InputMaybe<Array<SystemSettingWhereInput>>;
  NOT?: InputMaybe<Array<SystemSettingWhereInput>>;
  OR?: InputMaybe<Array<SystemSettingWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  key?: InputMaybe<IntFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  updatedBy?: InputMaybe<IntNullableFilter>;
  value?: InputMaybe<IntFilter>;
};

export type SystemSettingWhereUniqueInput = {
  key?: InputMaybe<Scalars['Int']['input']>;
};

/**
 *
 * お気に入り内商品
 */
export type WishlistItem = {
  __typename?: 'WishlistItem';
  /** 商品在庫単価 - 原価（お気に入り追加時） */
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース掛率（お気に入り追加時） */
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱掛率（お気に入り追加時） */
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - バラ掛率（お気に入り追加時） */
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** 得意先 */
  customer: Customer;
  /** 得意先ID */
  customerId: Scalars['Int']['output'];
  /** 径（連携） */
  diameter: Scalars['String']['output'];
  /** 径CD（連携） */
  diameterCd: Scalars['Int']['output'];
  /** お気に入り内商品ID */
  id: Scalars['Int']['output'];
  /** 商品CD */
  itemCd: Scalars['BigInt']['output'];
  /** 長さ（連携） */
  length: Scalars['String']['output'];
  /** 長さCD（連携） */
  lengthCd: Scalars['Int']['output'];
  /** 商品名 */
  name: Scalars['String']['output'];
  /** 商品在庫 - ケース入数（お気に入り追加時） */
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫 - 小箱入数（お気に入り追加時） */
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  /** お気に入り内で選択中 */
  selected: Scalars['Boolean']['output'];
  /** 商品 短縮CD */
  shortCd?: Maybe<Scalars['Int']['output']>;
  /** サイズCD */
  sizeCd: Scalars['BigInt']['output'];
  /** サイズ名 */
  sizeName: Scalars['String']['output'];
  /** 購入担当者 */
  staff: Staff;
  /** 購入担当者ID */
  staffId: Scalars['Int']['output'];
  /** 商品在庫 */
  stockItem?: Maybe<StockItem>;
  /** 商品在庫ID */
  stockItemId?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫単価 */
  stockItemUnitPrice?: Maybe<StockItemUnitPrice>;
  /** 商品在庫単価ID */
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  /** 商品在庫単価 - バラ単価（お気に入り追加時） */
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - ケース単価（お気に入り追加時） */
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 商品在庫単価 - 小箱単価（お気に入り追加時） */
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WishlistItemAvgAggregate = {
  __typename?: 'WishlistItemAvgAggregate';
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  customerId?: Maybe<Scalars['Float']['output']>;
  diameterCd?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  itemCd?: Maybe<Scalars['Float']['output']>;
  lengthCd?: Maybe<Scalars['Float']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Float']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Float']['output']>;
  shortCd?: Maybe<Scalars['Float']['output']>;
  sizeCd?: Maybe<Scalars['Float']['output']>;
  staffId?: Maybe<Scalars['Float']['output']>;
  stockItemId?: Maybe<Scalars['Float']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Float']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type WishlistItemCountAggregate = {
  __typename?: 'WishlistItemCountAggregate';
  _all: Scalars['Int']['output'];
  costPriceOfStockItemUnitPrice: Scalars['Int']['output'];
  costRateOfCaseOfStockItemUnitPrice: Scalars['Int']['output'];
  costRateOfPackOfStockItemUnitPrice: Scalars['Int']['output'];
  costRateOfStockItemUnitPrice: Scalars['Int']['output'];
  createdAt: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  diameter: Scalars['Int']['output'];
  diameterCd: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  itemCd: Scalars['Int']['output'];
  length: Scalars['Int']['output'];
  lengthCd: Scalars['Int']['output'];
  name: Scalars['Int']['output'];
  quantityParCaseOfStockItem: Scalars['Int']['output'];
  quantityParPackOfStockItem: Scalars['Int']['output'];
  selected: Scalars['Int']['output'];
  shortCd: Scalars['Int']['output'];
  sizeCd: Scalars['Int']['output'];
  sizeName: Scalars['Int']['output'];
  staffId: Scalars['Int']['output'];
  stockItemId: Scalars['Int']['output'];
  stockItemUnitPriceId: Scalars['Int']['output'];
  unitPriceOfStockItemUnitPrice: Scalars['Int']['output'];
  unitPriceParCaseOfStockItemUnitPrice: Scalars['Int']['output'];
  unitPriceParPackOfStockItemUnitPrice: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
};

export type WishlistItemCreateInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutWishlistItemsInput;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutWishlistItemsInput;
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutWishlistItemInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutWishlistItemInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateManyCustomerInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staffId: Scalars['Int']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateManyCustomerInputEnvelope = {
  data: Array<WishlistItemCreateManyCustomerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WishlistItemCreateManyStaffInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerId: Scalars['Int']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateManyStaffInputEnvelope = {
  data: Array<WishlistItemCreateManyStaffInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WishlistItemCreateManyStockItemInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerId: Scalars['Int']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staffId: Scalars['Int']['input'];
  stockItemUnitPriceId?: InputMaybe<Scalars['Int']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateManyStockItemInputEnvelope = {
  data: Array<WishlistItemCreateManyStockItemInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WishlistItemCreateManyStockItemUnitPriceInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customerId: Scalars['Int']['input'];
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staffId: Scalars['Int']['input'];
  stockItemId?: InputMaybe<Scalars['Int']['input']>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateManyStockItemUnitPriceInputEnvelope = {
  data: Array<WishlistItemCreateManyStockItemUnitPriceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WishlistItemCreateOrConnectWithoutCustomerInput = {
  create: WishlistItemCreateWithoutCustomerInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemCreateOrConnectWithoutStaffInput = {
  create: WishlistItemCreateWithoutStaffInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemCreateOrConnectWithoutStockItemInput = {
  create: WishlistItemCreateWithoutStockItemInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemCreateOrConnectWithoutStockItemUnitPriceInput = {
  create: WishlistItemCreateWithoutStockItemUnitPriceInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemCreateWithoutCustomerInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutWishlistItemsInput;
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutWishlistItemInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutWishlistItemInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateWithoutStaffInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutWishlistItemsInput;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutWishlistItemInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutWishlistItemInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateWithoutStockItemInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutWishlistItemsInput;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutWishlistItemsInput;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceCreateNestedOneWithoutWishlistItemInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemCreateWithoutStockItemUnitPriceInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  costRateOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  customer: CustomerCreateNestedOneWithoutWishlistItemsInput;
  diameter: Scalars['String']['input'];
  diameterCd?: InputMaybe<Scalars['Int']['input']>;
  itemCd: Scalars['BigInt']['input'];
  length: Scalars['String']['input'];
  lengthCd?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  quantityParCaseOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  quantityParPackOfStockItem?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<Scalars['Boolean']['input']>;
  shortCd?: InputMaybe<Scalars['Int']['input']>;
  sizeCd: Scalars['BigInt']['input'];
  sizeName: Scalars['String']['input'];
  staff: StaffCreateNestedOneWithoutWishlistItemsInput;
  stockItem?: InputMaybe<StockItemCreateNestedOneWithoutWishlistItemInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

export type WishlistItemListRelationFilter = {
  every?: InputMaybe<WishlistItemWhereInput>;
  none?: InputMaybe<WishlistItemWhereInput>;
  some?: InputMaybe<WishlistItemWhereInput>;
};

export type WishlistItemMaxAggregate = {
  __typename?: 'WishlistItemMaxAggregate';
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  diameter?: Maybe<Scalars['String']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  sizeName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  stockItemId?: Maybe<Scalars['Int']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WishlistItemMinAggregate = {
  __typename?: 'WishlistItemMinAggregate';
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  diameter?: Maybe<Scalars['String']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  length?: Maybe<Scalars['String']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<Scalars['Boolean']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  sizeName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  stockItemId?: Maybe<Scalars['Int']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type WishlistItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type WishlistItemOrderByWithRelationInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customer?: InputMaybe<CustomerOrderByWithRelationInput>;
  customerId?: InputMaybe<SortOrder>;
  diameter?: InputMaybe<SortOrder>;
  diameterCd?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  itemCd?: InputMaybe<SortOrder>;
  length?: InputMaybe<SortOrder>;
  lengthCd?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  quantityParCaseOfStockItem?: InputMaybe<SortOrderInput>;
  quantityParPackOfStockItem?: InputMaybe<SortOrderInput>;
  selected?: InputMaybe<SortOrder>;
  shortCd?: InputMaybe<SortOrderInput>;
  sizeCd?: InputMaybe<SortOrder>;
  sizeName?: InputMaybe<SortOrder>;
  staff?: InputMaybe<StaffOrderByWithRelationInput>;
  staffId?: InputMaybe<SortOrder>;
  stockItem?: InputMaybe<StockItemOrderByWithRelationInput>;
  stockItemId?: InputMaybe<SortOrderInput>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceOrderByWithRelationInput>;
  stockItemUnitPriceId?: InputMaybe<SortOrderInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum WishlistItemScalarFieldEnum {
  CostPriceOfStockItemUnitPrice = 'costPriceOfStockItemUnitPrice',
  CostRateOfCaseOfStockItemUnitPrice = 'costRateOfCaseOfStockItemUnitPrice',
  CostRateOfPackOfStockItemUnitPrice = 'costRateOfPackOfStockItemUnitPrice',
  CostRateOfStockItemUnitPrice = 'costRateOfStockItemUnitPrice',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  Diameter = 'diameter',
  DiameterCd = 'diameterCd',
  Id = 'id',
  ItemCd = 'itemCd',
  Length = 'length',
  LengthCd = 'lengthCd',
  Name = 'name',
  QuantityParCaseOfStockItem = 'quantityParCaseOfStockItem',
  QuantityParPackOfStockItem = 'quantityParPackOfStockItem',
  Selected = 'selected',
  ShortCd = 'shortCd',
  SizeCd = 'sizeCd',
  SizeName = 'sizeName',
  StaffId = 'staffId',
  StockItemId = 'stockItemId',
  StockItemUnitPriceId = 'stockItemUnitPriceId',
  UnitPriceOfStockItemUnitPrice = 'unitPriceOfStockItemUnitPrice',
  UnitPriceParCaseOfStockItemUnitPrice = 'unitPriceParCaseOfStockItemUnitPrice',
  UnitPriceParPackOfStockItemUnitPrice = 'unitPriceParPackOfStockItemUnitPrice',
  UpdatedAt = 'updatedAt'
}

export type WishlistItemScalarWhereInput = {
  AND?: InputMaybe<Array<WishlistItemScalarWhereInput>>;
  NOT?: InputMaybe<Array<WishlistItemScalarWhereInput>>;
  OR?: InputMaybe<Array<WishlistItemScalarWhereInput>>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<IntFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  selected?: InputMaybe<BoolFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  staffId?: InputMaybe<IntFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type WishlistItemStaffIdItemCdSizeCdCompoundUniqueInput = {
  itemCd: Scalars['BigInt']['input'];
  sizeCd: Scalars['BigInt']['input'];
  staffId: Scalars['Int']['input'];
};

export type WishlistItemSumAggregate = {
  __typename?: 'WishlistItemSumAggregate';
  costPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  costRateOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  diameterCd?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  itemCd?: Maybe<Scalars['BigInt']['output']>;
  lengthCd?: Maybe<Scalars['Int']['output']>;
  quantityParCaseOfStockItem?: Maybe<Scalars['Int']['output']>;
  quantityParPackOfStockItem?: Maybe<Scalars['Int']['output']>;
  shortCd?: Maybe<Scalars['Int']['output']>;
  sizeCd?: Maybe<Scalars['BigInt']['output']>;
  staffId?: Maybe<Scalars['Int']['output']>;
  stockItemId?: Maybe<Scalars['Int']['output']>;
  stockItemUnitPriceId?: Maybe<Scalars['Int']['output']>;
  unitPriceOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParCaseOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  unitPriceParPackOfStockItemUnitPrice?: Maybe<Scalars['Decimal']['output']>;
};

export type WishlistItemUpdateInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type WishlistItemUpdateManyMutationInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type WishlistItemUpdateManyWithWhereWithoutCustomerInput = {
  data: WishlistItemUpdateManyMutationInput;
  where: WishlistItemScalarWhereInput;
};

export type WishlistItemUpdateManyWithWhereWithoutStaffInput = {
  data: WishlistItemUpdateManyMutationInput;
  where: WishlistItemScalarWhereInput;
};

export type WishlistItemUpdateManyWithWhereWithoutStockItemInput = {
  data: WishlistItemUpdateManyMutationInput;
  where: WishlistItemScalarWhereInput;
};

export type WishlistItemUpdateManyWithWhereWithoutStockItemUnitPriceInput = {
  data: WishlistItemUpdateManyMutationInput;
  where: WishlistItemScalarWhereInput;
};

export type WishlistItemUpdateManyWithoutCustomerNestedInput = {
  connect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WishlistItemCreateOrConnectWithoutCustomerInput>>;
  create?: InputMaybe<Array<WishlistItemCreateWithoutCustomerInput>>;
  createMany?: InputMaybe<WishlistItemCreateManyCustomerInputEnvelope>;
  delete?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WishlistItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  set?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  update?: InputMaybe<Array<WishlistItemUpdateWithWhereUniqueWithoutCustomerInput>>;
  updateMany?: InputMaybe<Array<WishlistItemUpdateManyWithWhereWithoutCustomerInput>>;
  upsert?: InputMaybe<Array<WishlistItemUpsertWithWhereUniqueWithoutCustomerInput>>;
};

export type WishlistItemUpdateManyWithoutStaffNestedInput = {
  connect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WishlistItemCreateOrConnectWithoutStaffInput>>;
  create?: InputMaybe<Array<WishlistItemCreateWithoutStaffInput>>;
  createMany?: InputMaybe<WishlistItemCreateManyStaffInputEnvelope>;
  delete?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WishlistItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  set?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  update?: InputMaybe<Array<WishlistItemUpdateWithWhereUniqueWithoutStaffInput>>;
  updateMany?: InputMaybe<Array<WishlistItemUpdateManyWithWhereWithoutStaffInput>>;
  upsert?: InputMaybe<Array<WishlistItemUpsertWithWhereUniqueWithoutStaffInput>>;
};

export type WishlistItemUpdateManyWithoutStockItemNestedInput = {
  connect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WishlistItemCreateOrConnectWithoutStockItemInput>>;
  create?: InputMaybe<Array<WishlistItemCreateWithoutStockItemInput>>;
  createMany?: InputMaybe<WishlistItemCreateManyStockItemInputEnvelope>;
  delete?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WishlistItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  set?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  update?: InputMaybe<Array<WishlistItemUpdateWithWhereUniqueWithoutStockItemInput>>;
  updateMany?: InputMaybe<Array<WishlistItemUpdateManyWithWhereWithoutStockItemInput>>;
  upsert?: InputMaybe<Array<WishlistItemUpsertWithWhereUniqueWithoutStockItemInput>>;
};

export type WishlistItemUpdateManyWithoutStockItemUnitPriceNestedInput = {
  connect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<WishlistItemCreateOrConnectWithoutStockItemUnitPriceInput>>;
  create?: InputMaybe<Array<WishlistItemCreateWithoutStockItemUnitPriceInput>>;
  createMany?: InputMaybe<WishlistItemCreateManyStockItemUnitPriceInputEnvelope>;
  delete?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<WishlistItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  set?: InputMaybe<Array<WishlistItemWhereUniqueInput>>;
  update?: InputMaybe<Array<WishlistItemUpdateWithWhereUniqueWithoutStockItemUnitPriceInput>>;
  updateMany?: InputMaybe<Array<WishlistItemUpdateManyWithWhereWithoutStockItemUnitPriceInput>>;
  upsert?: InputMaybe<Array<WishlistItemUpsertWithWhereUniqueWithoutStockItemUnitPriceInput>>;
};

export type WishlistItemUpdateWithWhereUniqueWithoutCustomerInput = {
  data: WishlistItemUpdateWithoutCustomerInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemUpdateWithWhereUniqueWithoutStaffInput = {
  data: WishlistItemUpdateWithoutStaffInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemUpdateWithWhereUniqueWithoutStockItemInput = {
  data: WishlistItemUpdateWithoutStockItemInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemUpdateWithWhereUniqueWithoutStockItemUnitPriceInput = {
  data: WishlistItemUpdateWithoutStockItemUnitPriceInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemUpdateWithoutCustomerInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type WishlistItemUpdateWithoutStaffInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type WishlistItemUpdateWithoutStockItemInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type WishlistItemUpdateWithoutStockItemUnitPriceInput = {
  costPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  costRateOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  diameter?: InputMaybe<StringFieldUpdateOperationsInput>;
  diameterCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  itemCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  length?: InputMaybe<StringFieldUpdateOperationsInput>;
  lengthCd?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  quantityParCaseOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantityParPackOfStockItem?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  selected?: InputMaybe<BoolFieldUpdateOperationsInput>;
  shortCd?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  sizeCd?: InputMaybe<BigIntFieldUpdateOperationsInput>;
  sizeName?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<NullableDecimalFieldUpdateOperationsInput>;
};

export type WishlistItemUpsertWithWhereUniqueWithoutCustomerInput = {
  create: WishlistItemCreateWithoutCustomerInput;
  update: WishlistItemUpdateWithoutCustomerInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemUpsertWithWhereUniqueWithoutStaffInput = {
  create: WishlistItemCreateWithoutStaffInput;
  update: WishlistItemUpdateWithoutStaffInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemUpsertWithWhereUniqueWithoutStockItemInput = {
  create: WishlistItemCreateWithoutStockItemInput;
  update: WishlistItemUpdateWithoutStockItemInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemUpsertWithWhereUniqueWithoutStockItemUnitPriceInput = {
  create: WishlistItemCreateWithoutStockItemUnitPriceInput;
  update: WishlistItemUpdateWithoutStockItemUnitPriceInput;
  where: WishlistItemWhereUniqueInput;
};

export type WishlistItemWhereInput = {
  AND?: InputMaybe<Array<WishlistItemWhereInput>>;
  NOT?: InputMaybe<Array<WishlistItemWhereInput>>;
  OR?: InputMaybe<Array<WishlistItemWhereInput>>;
  costPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  costRateOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customer?: InputMaybe<CustomerRelationFilter>;
  customerId?: InputMaybe<IntFilter>;
  diameter?: InputMaybe<StringFilter>;
  diameterCd?: InputMaybe<IntFilter>;
  id?: InputMaybe<IntFilter>;
  itemCd?: InputMaybe<BigIntFilter>;
  length?: InputMaybe<StringFilter>;
  lengthCd?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  quantityParCaseOfStockItem?: InputMaybe<IntNullableFilter>;
  quantityParPackOfStockItem?: InputMaybe<IntNullableFilter>;
  selected?: InputMaybe<BoolFilter>;
  shortCd?: InputMaybe<IntNullableFilter>;
  sizeCd?: InputMaybe<BigIntFilter>;
  sizeName?: InputMaybe<StringFilter>;
  staff?: InputMaybe<StaffRelationFilter>;
  staffId?: InputMaybe<IntFilter>;
  stockItem?: InputMaybe<StockItemRelationFilter>;
  stockItemId?: InputMaybe<IntNullableFilter>;
  stockItemUnitPrice?: InputMaybe<StockItemUnitPriceRelationFilter>;
  stockItemUnitPriceId?: InputMaybe<IntNullableFilter>;
  unitPriceOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParCaseOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  unitPriceParPackOfStockItemUnitPrice?: InputMaybe<DecimalNullableFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type WishlistItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  staffId_itemCd_sizeCd?: InputMaybe<WishlistItemStaffIdItemCdSizeCdCompoundUniqueInput>;
};

export type AnnouncesQueryVariables = Exact<{
  where?: InputMaybe<AnnounceWhereInput>;
  orderBy?: InputMaybe<Array<AnnounceOrderByWithRelationInput> | AnnounceOrderByWithRelationInput>;
  cursor?: InputMaybe<AnnounceWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AnnouncesQuery = { __typename?: 'Query', announces: Array<{ __typename?: 'Announce', id: number, announceCd: number, message: string, title?: string | null, publishedAt?: Date | null, disabledAt?: Date | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }> };

export type FindFirstCartItemQueryVariables = Exact<{
  where?: InputMaybe<CartItemWhereInput>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput> | CartItemOrderByWithRelationInput>;
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum> | CartItemScalarFieldEnum>;
}>;


export type FindFirstCartItemQuery = { __typename?: 'Query', findFirstCartItem?: { __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null } | null };

export type CountCartItemsQueryVariables = Exact<{
  where?: InputMaybe<CartItemWhereInput>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput> | CartItemOrderByWithRelationInput>;
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CountCartItemsQuery = { __typename?: 'Query', aggregateCartItem: { __typename?: 'AggregateCartItem', _count?: { __typename?: 'CartItemCountAggregate', _all: number } | null } };

export type CreateOneCartItemMutationVariables = Exact<{
  data: CartItemCreateInput;
}>;


export type CreateOneCartItemMutation = { __typename?: 'Mutation', createOneCartItem: { __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, diameterCd: number, lengthCd: number, length: string, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null } };

export type CartItemsQueryVariables = Exact<{
  where?: InputMaybe<CartItemWhereInput>;
  orderBy?: InputMaybe<Array<CartItemOrderByWithRelationInput> | CartItemOrderByWithRelationInput>;
  cursor?: InputMaybe<CartItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<CartItemScalarFieldEnum> | CartItemScalarFieldEnum>;
}>;


export type CartItemsQuery = { __typename?: 'Query', cartItems: Array<{ __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null }> };

export type UpdateOneCartItemMutationVariables = Exact<{
  data: CartItemUpdateInput;
  where: CartItemWhereUniqueInput;
}>;


export type UpdateOneCartItemMutation = { __typename?: 'Mutation', updateOneCartItem?: { __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null } | null };

export type DeleteOneCartItemMutationVariables = Exact<{
  where: CartItemWhereUniqueInput;
}>;


export type DeleteOneCartItemMutation = { __typename?: 'Mutation', deleteOneCartItem?: { __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null } | null };

export type DeleteManyCartItemMutationVariables = Exact<{
  where?: InputMaybe<CartItemWhereInput>;
}>;


export type DeleteManyCartItemMutation = { __typename?: 'Mutation', deleteManyCartItem: { __typename?: 'AffectedRowsOutput', count: number } };

export type LargeCategoriesQueryVariables = Exact<{
  where?: InputMaybe<LargeCategoryWhereInput>;
  orderBy?: InputMaybe<Array<LargeCategoryOrderByWithRelationInput> | LargeCategoryOrderByWithRelationInput>;
  cursor?: InputMaybe<LargeCategoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LargeCategoriesQuery = { __typename?: 'Query', largeCategories: Array<{ __typename?: 'LargeCategory', id: number, largeCd?: number | null, seq?: number | null, name: string, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }> };

export type MiddleCategoriesQueryVariables = Exact<{
  where?: InputMaybe<MiddleCategoryWhereInput>;
  orderBy?: InputMaybe<Array<MiddleCategoryOrderByWithRelationInput> | MiddleCategoryOrderByWithRelationInput>;
  cursor?: InputMaybe<MiddleCategoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MiddleCategoriesQuery = { __typename?: 'Query', middleCategories: Array<{ __typename?: 'MiddleCategory', id: number, largeCd?: number | null, middleCd?: number | null, seq?: number | null, name: string, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }> };

export type SmallCategoriesQueryVariables = Exact<{
  where?: InputMaybe<SmallCategoryWhereInput>;
  orderBy?: InputMaybe<Array<SmallCategoryOrderByWithRelationInput> | SmallCategoryOrderByWithRelationInput>;
  cursor?: InputMaybe<SmallCategoryWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SmallCategoriesQuery = { __typename?: 'Query', smallCategories: Array<{ __typename?: 'SmallCategory', id: number, smallCd?: number | null, seq?: number | null, name: string, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }> };

export type CodeVerifyMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type CodeVerifyMutation = { __typename?: 'Mutation', codeVerify: { __typename?: 'CodeVerifyResponse', result: string } };

export type FindFirstCustomerQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
  orderBy?: InputMaybe<Array<CustomerOrderByWithRelationInput> | CustomerOrderByWithRelationInput>;
  cursor?: InputMaybe<CustomerWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindFirstCustomerQuery = { __typename?: 'Query', findFirstCustomer?: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, staffs: Array<{ __typename?: 'Staff', id: number, name: string, email?: string | null, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }> } | null };

export type FindFirstCustomerByUserAuthSubQueryVariables = Exact<{
  where?: InputMaybe<CustomerWhereInput>;
}>;


export type FindFirstCustomerByUserAuthSubQuery = { __typename?: 'Query', findFirstCustomer?: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, staffs: Array<{ __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', name: string, id: number } }> } | null };

export type CustomerOrderNosQueryVariables = Exact<{
  where?: InputMaybe<OrderRequestDetailWhereInput>;
  orderBy?: InputMaybe<Array<OrderRequestDetailOrderByWithRelationInput> | OrderRequestDetailOrderByWithRelationInput>;
  cursor?: InputMaybe<OrderRequestDetailWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CustomerOrderNosQuery = { __typename?: 'Query', orderRequestDetails: Array<{ __typename?: 'OrderRequestDetail', customerOrderNo?: string | null }> };

export type DiametersQueryVariables = Exact<{
  where?: InputMaybe<StockItemWhereInput>;
  orderBy?: InputMaybe<Array<StockItemOrderByWithRelationInput> | StockItemOrderByWithRelationInput>;
  cursor?: InputMaybe<StockItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiametersQuery = { __typename?: 'Query', stockItems: Array<{ __typename?: 'StockItem', diameter: string, diameterCd: number }> };

export type ItemsQueryVariables = Exact<{
  where?: InputMaybe<ItemWhereInput>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput> | ItemOrderByWithRelationInput>;
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ItemsQuery = { __typename?: 'Query', items: Array<{ __typename?: 'Item', id: number, itemCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, shortCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, imageUrl?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }> };

export type CountItemsQueryVariables = Exact<{
  where?: InputMaybe<ItemWhereInput>;
  orderBy?: InputMaybe<Array<ItemOrderByWithRelationInput> | ItemOrderByWithRelationInput>;
  cursor?: InputMaybe<ItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CountItemsQuery = { __typename?: 'Query', aggregateItem: { __typename?: 'AggregateItem', _count?: { __typename?: 'ItemCountAggregate', _all: number } | null } };

export type FindFirstItemQueryVariables = Exact<{
  where?: InputMaybe<ItemWhereInput>;
}>;


export type FindFirstItemQuery = { __typename?: 'Query', findFirstItem?: { __typename?: 'Item', id: number, itemCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, shortCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, imageUrl?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, largeCategory?: { __typename?: 'LargeCategory', id: number, largeCd?: number | null, seq?: number | null, name: string, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, middleCategory?: { __typename?: 'MiddleCategory', id: number, largeCd?: number | null, middleCd?: number | null, seq?: number | null, name: string, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, smallCategory?: { __typename?: 'SmallCategory', id: number, smallCd?: number | null, seq?: number | null, name: string, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null } | null };

export type LengthsQueryVariables = Exact<{
  where?: InputMaybe<StockItemWhereInput>;
  orderBy?: InputMaybe<Array<StockItemOrderByWithRelationInput> | StockItemOrderByWithRelationInput>;
  cursor?: InputMaybe<StockItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LengthsQuery = { __typename?: 'Query', stockItems: Array<{ __typename?: 'StockItem', length: string, lengthCd: number }> };

export type OrdersQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
  orderBy?: InputMaybe<Array<OrderOrderByWithRelationInput> | OrderOrderByWithRelationInput>;
  cursor?: InputMaybe<OrderWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<OrderScalarFieldEnum> | OrderScalarFieldEnum>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id: number, orderRequestId?: number | null, customerCd: number, customerName: string, customerId: number, staffId?: number | null, customerChargeName?: string | null, billingName?: string | null, billingNameKana?: string | null, billingPostalCode?: string | null, billingPrefecture?: string | null, billingAddress?: string | null, billingPhoneNumber?: string | null, billingChargeName?: string | null, deliveryName?: string | null, deliveryNameKana?: string | null, deliveryPostalCode?: string | null, deliveryPrefecture?: string | null, deliveryAddress?: string | null, deliveryPhoneNumber?: string | null, deliveryChargeName?: string | null, minimumOrderAmount?: any | null, isSameDayDelivery: boolean, deliveryDate?: Date | null, orderRequestDate: Date, orderCompleteDate: Date, orderCompleteParsonName?: string | null, orderCompleteType?: string | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff?: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } | null, details: Array<{ __typename?: 'OrderDetail', id: number, orderId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, orderRequestDetailId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, requestLineNo?: number | null, requestUnitPrice?: any | null, requestQuantity?: number | null, requestTotalQuantity?: number | null, requestAmount?: any | null, requestPacking?: OrderPacking | null, orderLineNo: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', name: string } } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', name: string } } } | null }> }> };

export type FindFirstOrderQueryVariables = Exact<{
  where?: InputMaybe<OrderWhereInput>;
}>;


export type FindFirstOrderQuery = { __typename?: 'Query', findFirstOrder?: { __typename?: 'Order', id: number, orderRequestId?: number | null, customerCd: number, customerName: string, customerId: number, staffId?: number | null, customerChargeName?: string | null, billingName?: string | null, billingNameKana?: string | null, billingPostalCode?: string | null, billingPrefecture?: string | null, billingAddress?: string | null, billingPhoneNumber?: string | null, billingChargeName?: string | null, deliveryName?: string | null, deliveryNameKana?: string | null, deliveryPostalCode?: string | null, deliveryPrefecture?: string | null, deliveryAddress?: string | null, deliveryPhoneNumber?: string | null, deliveryChargeName?: string | null, minimumOrderAmount?: any | null, isSameDayDelivery: boolean, deliveryDate?: Date | null, orderRequestDate: Date, orderCompleteDate: Date, orderCompleteParsonName?: string | null, orderCompleteType?: string | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff?: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } | null, details: Array<{ __typename?: 'OrderDetail', id: number, orderId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, orderRequestDetailId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, requestLineNo?: number | null, requestUnitPrice?: any | null, requestQuantity?: number | null, requestTotalQuantity?: number | null, requestAmount?: any | null, requestPacking?: OrderPacking | null, orderLineNo: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null }> } | null };

export type CreateOneOrderRequestMutationVariables = Exact<{
  data: OrderRequestCreateInput;
}>;


export type CreateOneOrderRequestMutation = { __typename?: 'Mutation', createOneOrderRequest: { __typename?: 'OrderRequest', id: number, customerCd: number, customerName: string, customerId: number, staffId?: number | null, customerChargeName?: string | null, billingName?: string | null, billingNameKana?: string | null, billingPostalCode?: string | null, billingPrefecture?: string | null, billingAddress?: string | null, billingPhoneNumber?: string | null, billingChargeName?: string | null, deliveryName?: string | null, deliveryNameKana?: string | null, deliveryPostalCode?: string | null, deliveryPrefecture?: string | null, deliveryAddress?: string | null, deliveryPhoneNumber?: string | null, deliveryChargeName?: string | null, minimumOrderAmount?: any | null, isSameDayDelivery: boolean, deliveryDate?: Date | null, orderRequestDate: Date, canceledAt?: Date | null, syncedAt?: Date | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff?: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } | null, details: Array<{ __typename?: 'OrderRequestDetail', id: number, orderRequestId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, requestLineNo: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', name: string } } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null }> } };

export type OrderRequestsQueryVariables = Exact<{
  where?: InputMaybe<OrderRequestWhereInput>;
  orderBy?: InputMaybe<Array<OrderRequestOrderByWithRelationInput> | OrderRequestOrderByWithRelationInput>;
  cursor?: InputMaybe<OrderRequestWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrderRequestsQuery = { __typename?: 'Query', orderRequests: Array<{ __typename?: 'OrderRequest', id: number, customerCd: number, customerName: string, customerId: number, staffId?: number | null, customerChargeName?: string | null, billingName?: string | null, billingNameKana?: string | null, billingPostalCode?: string | null, billingPrefecture?: string | null, billingAddress?: string | null, billingPhoneNumber?: string | null, billingChargeName?: string | null, deliveryName?: string | null, deliveryNameKana?: string | null, deliveryPostalCode?: string | null, deliveryPrefecture?: string | null, deliveryAddress?: string | null, deliveryPhoneNumber?: string | null, deliveryChargeName?: string | null, minimumOrderAmount?: any | null, isSameDayDelivery: boolean, deliveryDate?: Date | null, orderRequestDate: Date, canceledAt?: Date | null, syncedAt?: Date | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff?: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } | null, details: Array<{ __typename?: 'OrderRequestDetail', id: number, orderRequestId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, requestLineNo: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', name: string } } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null }> }> };

export type FindFirstOrderRequestQueryVariables = Exact<{
  where?: InputMaybe<OrderRequestWhereInput>;
}>;


export type FindFirstOrderRequestQuery = { __typename?: 'Query', findFirstOrderRequest?: { __typename?: 'OrderRequest', id: number, customerCd: number, customerName: string, customerId: number, staffId?: number | null, customerChargeName?: string | null, billingName?: string | null, billingNameKana?: string | null, billingPostalCode?: string | null, billingPrefecture?: string | null, billingAddress?: string | null, billingPhoneNumber?: string | null, billingChargeName?: string | null, deliveryName?: string | null, deliveryNameKana?: string | null, deliveryPostalCode?: string | null, deliveryPrefecture?: string | null, deliveryAddress?: string | null, deliveryPhoneNumber?: string | null, deliveryChargeName?: string | null, minimumOrderAmount?: any | null, isSameDayDelivery: boolean, deliveryDate?: Date | null, orderRequestDate: Date, canceledAt?: Date | null, syncedAt?: Date | null, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff?: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } | null, details: Array<{ __typename?: 'OrderRequestDetail', id: number, orderRequestId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, requestLineNo: number, unitPrice: any, quantity: number, totalQuantity: number, amount: any, packing: OrderPacking, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', name: string } } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null }> } | null };

export type SendOrderRequestMutationVariables = Exact<{
  mailAddress: Scalars['String']['input'];
  orderRequestNo: Scalars['Int']['input'];
  customerName: Scalars['String']['input'];
  staffName: Scalars['String']['input'];
  orderDate: Scalars['String']['input'];
  itemQuantity: Scalars['String']['input'];
  totalAmount: Scalars['String']['input'];
  details: Array<SendOrderRequestDetailInput> | SendOrderRequestDetailInput;
}>;


export type SendOrderRequestMutation = { __typename?: 'Mutation', sendOrderRequest: { __typename?: 'SendOrderRequestResponse', message: string } };

export type SendVerificationCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendVerificationCodeMutation = { __typename?: 'Mutation', sendVerificationCode: { __typename?: 'SendVerificationCodeResponse', message: string } };

export type FindManyStaffQueryVariables = Exact<{
  where?: InputMaybe<StaffWhereInput>;
  orderBy?: InputMaybe<Array<StaffOrderByWithRelationInput> | StaffOrderByWithRelationInput>;
  cursor?: InputMaybe<StaffWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindManyStaffQuery = { __typename?: 'Query', findManyStaff: Array<{ __typename?: 'Staff', id: number, customerId: number, name: string, email?: string | null, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }> };

export type CreateOneStaffMutationVariables = Exact<{
  data: StaffCreateInput;
}>;


export type CreateOneStaffMutation = { __typename?: 'Mutation', createOneStaff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } };

export type UpdateOneStaffMutationVariables = Exact<{
  data: StaffUpdateInput;
  where: StaffWhereUniqueInput;
}>;


export type UpdateOneStaffMutation = { __typename?: 'Mutation', updateOneStaff?: { __typename?: 'Staff', id: number, customerId: number, name: string, email?: string | null, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } | null };

export type DeleteOneStaffMutationVariables = Exact<{
  where: StaffWhereUniqueInput;
}>;


export type DeleteOneStaffMutation = { __typename?: 'Mutation', deleteOneStaff?: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null } | null };

export type StockItemsQueryVariables = Exact<{
  where?: InputMaybe<StockItemWhereInput>;
  orderBy?: InputMaybe<Array<StockItemOrderByWithRelationInput> | StockItemOrderByWithRelationInput>;
  cursor?: InputMaybe<StockItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type StockItemsQuery = { __typename?: 'Query', stockItems: Array<{ __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItemUnitPrices: Array<{ __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, cartItem: Array<{ __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, unitPrice: any, quantity: number, amount: any, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null }> }> }> };

export type AggregateStockItemQueryVariables = Exact<{ [key: string]: never; }>;


export type AggregateStockItemQuery = { __typename?: 'Query', aggregateStockItem: { __typename?: 'AggregateStockItem', _max?: { __typename?: 'StockItemMaxAggregate', updatedAt?: Date | null } | null } };

export type StockItemUnitPricesQueryVariables = Exact<{
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
  orderBy?: InputMaybe<Array<StockItemUnitPriceOrderByWithRelationInput> | StockItemUnitPriceOrderByWithRelationInput>;
  cursor?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<StockItemUnitPriceScalarFieldEnum> | StockItemUnitPriceScalarFieldEnum>;
}>;


export type StockItemUnitPricesQuery = { __typename?: 'Query', stockItemUnitPrices: Array<{ __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, shortCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } }, cartItem: Array<{ __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, unitPrice: any, quantity: number, amount: any, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, packingStyle?: string | null, createdAt: Date, updatedAt?: Date | null }>, wishlistItem: Array<{ __typename?: 'WishlistItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, createdAt: Date, updatedAt?: Date | null }> }> };

export type FindFirstStockItemUnitPriceQueryVariables = Exact<{
  where?: InputMaybe<StockItemUnitPriceWhereInput>;
  orderBy?: InputMaybe<Array<StockItemUnitPriceOrderByWithRelationInput> | StockItemUnitPriceOrderByWithRelationInput>;
  cursor?: InputMaybe<StockItemUnitPriceWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<StockItemUnitPriceScalarFieldEnum> | StockItemUnitPriceScalarFieldEnum>;
}>;


export type FindFirstStockItemUnitPriceQuery = { __typename?: 'Query', findFirstStockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, shortCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } }, cartItem: Array<{ __typename?: 'CartItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, unitPrice: any, quantity: number, amount: any, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, customerOrderNo?: string | null, customerNote?: string | null, createdAt: Date, updatedAt?: Date | null }>, wishlistItem: Array<{ __typename?: 'WishlistItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, createdAt: Date, updatedAt?: Date | null }> } | null };

export type FindFirstSystemSettingQueryVariables = Exact<{
  where?: InputMaybe<SystemSettingWhereInput>;
  orderBy?: InputMaybe<Array<SystemSettingOrderByWithRelationInput> | SystemSettingOrderByWithRelationInput>;
  cursor?: InputMaybe<SystemSettingWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FindFirstSystemSettingQuery = { __typename?: 'Query', findFirstSystemSetting?: { __typename?: 'SystemSetting', key: number, value: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null };

export type FindFirstWishlistItemQueryVariables = Exact<{
  where?: InputMaybe<WishlistItemWhereInput>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput> | WishlistItemOrderByWithRelationInput>;
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum> | WishlistItemScalarFieldEnum>;
}>;


export type FindFirstWishlistItemQuery = { __typename?: 'Query', findFirstWishlistItem?: { __typename?: 'WishlistItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null } | null };

export type CountWishlistItemsQueryVariables = Exact<{
  where?: InputMaybe<WishlistItemWhereInput>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput> | WishlistItemOrderByWithRelationInput>;
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CountWishlistItemsQuery = { __typename?: 'Query', aggregateWishlistItem: { __typename?: 'AggregateWishlistItem', _count?: { __typename?: 'WishlistItemCountAggregate', _all: number } | null } };

export type CreateOneWishlistItemMutationVariables = Exact<{
  data: WishlistItemCreateInput;
}>;


export type CreateOneWishlistItemMutation = { __typename?: 'Mutation', createOneWishlistItem: { __typename?: 'WishlistItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, diameterCd: number, lengthCd: number, length: string, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null } };

export type WishlistItemsQueryVariables = Exact<{
  where?: InputMaybe<WishlistItemWhereInput>;
  orderBy?: InputMaybe<Array<WishlistItemOrderByWithRelationInput> | WishlistItemOrderByWithRelationInput>;
  cursor?: InputMaybe<WishlistItemWhereUniqueInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  distinct?: InputMaybe<Array<WishlistItemScalarFieldEnum> | WishlistItemScalarFieldEnum>;
}>;


export type WishlistItemsQuery = { __typename?: 'Query', wishlistItems: Array<{ __typename?: 'WishlistItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null }> };

export type UpdateOneWishlistItemMutationVariables = Exact<{
  data: WishlistItemUpdateInput;
  where: WishlistItemWhereUniqueInput;
}>;


export type UpdateOneWishlistItemMutation = { __typename?: 'Mutation', updateOneWishlistItem?: { __typename?: 'WishlistItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, createdAt: Date, updatedAt?: Date | null, customer: { __typename?: 'Customer', id: number, customerCd: number, name: string, email?: string | null, emailAuthSub?: string | null, username?: string | null, usernameAuthSub?: string | null, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null }, staff: { __typename?: 'Staff', id: number, customerId: number, name: string, isEnabledGuidetour: boolean, createdAt: Date, updatedAt?: Date | null }, stockItem?: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } | null, stockItemUnitPrice?: { __typename?: 'StockItemUnitPrice', id: number, customerId: number, stockItemId: number, customerCd: number, itemCd: number, sizeCd: number, costPrice: any, unitPriceParCase: any, unitPriceParPack: any, unitPrice: any, costRateOfCase: any, costRateOfPack: any, costRate: any, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, stockItem: { __typename?: 'StockItem', id: number, itemId: number, itemCd: number, sizeCd: number, sizeName: string, quantityParCase: number, quantityParPack: number, costPrice: any, diameter: string, length: string, diameterCd: number, lengthCd: number, stockQuantityYao: number, stockQuantityHigashi: number, totalStockQuantity: number, stockQuantitySymbol: string, roughStockQuantity: number, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null, item: { __typename?: 'Item', id: number, itemCd?: number | null, shortCd?: number | null, largeCd?: number | null, middleCd?: number | null, smallCd?: number | null, name: string, description?: string | null, stockLocationCd?: number | null, disabled: boolean, createdAt: Date, updatedAt?: Date | null, updatedBy?: number | null } } } | null } | null };

export type DeleteOneWishlistItemMutationVariables = Exact<{
  where: WishlistItemWhereUniqueInput;
}>;


export type DeleteOneWishlistItemMutation = { __typename?: 'Mutation', deleteOneWishlistItem?: { __typename?: 'WishlistItem', id: number, customerId: number, staffId: number, stockItemUnitPriceId?: number | null, stockItemId?: number | null, itemCd: number, shortCd?: number | null, name: string, sizeCd: number, sizeName: string, diameter: string, length: string, diameterCd: number, lengthCd: number, quantityParCaseOfStockItem?: number | null, quantityParPackOfStockItem?: number | null, costPriceOfStockItemUnitPrice?: any | null, unitPriceParCaseOfStockItemUnitPrice?: any | null, unitPriceParPackOfStockItemUnitPrice?: any | null, unitPriceOfStockItemUnitPrice?: any | null, costRateOfCaseOfStockItemUnitPrice?: any | null, costRateOfPackOfStockItemUnitPrice?: any | null, costRateOfStockItemUnitPrice?: any | null, selected: boolean, createdAt: Date, updatedAt?: Date | null } | null };

export type DeleteManyWishlistItemMutationVariables = Exact<{
  where?: InputMaybe<WishlistItemWhereInput>;
}>;


export type DeleteManyWishlistItemMutation = { __typename?: 'Mutation', deleteManyWishlistItem: { __typename?: 'AffectedRowsOutput', count: number } };


export const AnnouncesDocument = gql`
    query announces($where: AnnounceWhereInput, $orderBy: [AnnounceOrderByWithRelationInput!], $cursor: AnnounceWhereUniqueInput, $take: Int, $skip: Int) {
  announces(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    announceCd
    message
    title
    publishedAt
    disabledAt
    createdAt
    updatedAt
    updatedBy
  }
}
    `;
export const FindFirstCartItemDocument = gql`
    query findFirstCartItem($where: CartItemWhereInput, $orderBy: [CartItemOrderByWithRelationInput!], $cursor: CartItemWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CartItemScalarFieldEnum!]) {
  findFirstCartItem(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    unitPrice
    quantity
    totalQuantity
    amount
    packing
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    customerOrderNo
    customerNote
    packingStyle
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
    }
  }
}
    `;
export const CountCartItemsDocument = gql`
    query countCartItems($where: CartItemWhereInput, $orderBy: [CartItemOrderByWithRelationInput!], $cursor: CartItemWhereUniqueInput, $take: Int, $skip: Int) {
  aggregateCartItem(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    _count {
      _all
    }
  }
}
    `;
export const CreateOneCartItemDocument = gql`
    mutation createOneCartItem($data: CartItemCreateInput!) {
  createOneCartItem(data: $data) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    diameterCd
    lengthCd
    length
    unitPrice
    quantity
    totalQuantity
    amount
    packing
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    customerOrderNo
    customerNote
    packingStyle
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
    }
  }
}
    `;
export const CartItemsDocument = gql`
    query cartItems($where: CartItemWhereInput, $orderBy: [CartItemOrderByWithRelationInput!], $cursor: CartItemWhereUniqueInput, $take: Int, $skip: Int, $distinct: [CartItemScalarFieldEnum!]) {
  cartItems(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    unitPrice
    quantity
    totalQuantity
    amount
    packing
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    customerOrderNo
    customerNote
    packingStyle
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
    }
  }
}
    `;
export const UpdateOneCartItemDocument = gql`
    mutation updateOneCartItem($data: CartItemUpdateInput!, $where: CartItemWhereUniqueInput!) {
  updateOneCartItem(data: $data, where: $where) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    unitPrice
    quantity
    totalQuantity
    amount
    packing
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    customerOrderNo
    customerNote
    packingStyle
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
    }
  }
}
    `;
export const DeleteOneCartItemDocument = gql`
    mutation deleteOneCartItem($where: CartItemWhereUniqueInput!) {
  deleteOneCartItem(where: $where) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    unitPrice
    quantity
    totalQuantity
    amount
    packing
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    customerOrderNo
    customerNote
    packingStyle
    createdAt
    updatedAt
  }
}
    `;
export const DeleteManyCartItemDocument = gql`
    mutation deleteManyCartItem($where: CartItemWhereInput) {
  deleteManyCartItem(where: $where) {
    count
  }
}
    `;
export const LargeCategoriesDocument = gql`
    query largeCategories($where: LargeCategoryWhereInput, $orderBy: [LargeCategoryOrderByWithRelationInput!], $cursor: LargeCategoryWhereUniqueInput, $take: Int, $skip: Int) {
  largeCategories(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    largeCd
    seq
    name
    createdAt
    updatedAt
    updatedBy
  }
}
    `;
export const MiddleCategoriesDocument = gql`
    query middleCategories($where: MiddleCategoryWhereInput, $orderBy: [MiddleCategoryOrderByWithRelationInput!], $cursor: MiddleCategoryWhereUniqueInput, $take: Int, $skip: Int) {
  middleCategories(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    largeCd
    middleCd
    seq
    name
    createdAt
    updatedAt
    updatedBy
  }
}
    `;
export const SmallCategoriesDocument = gql`
    query smallCategories($where: SmallCategoryWhereInput, $orderBy: [SmallCategoryOrderByWithRelationInput!], $cursor: SmallCategoryWhereUniqueInput, $take: Int, $skip: Int) {
  smallCategories(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    smallCd
    seq
    name
    createdAt
    updatedAt
    updatedBy
  }
}
    `;
export const CodeVerifyDocument = gql`
    mutation codeVerify($email: String!, $code: String!) {
  codeVerify(email: $email, code: $code) {
    result
  }
}
    `;
export const FindFirstCustomerDocument = gql`
    query findFirstCustomer($where: CustomerWhereInput, $orderBy: [CustomerOrderByWithRelationInput!], $cursor: CustomerWhereUniqueInput, $take: Int, $skip: Int) {
  findFirstCustomer(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    customerCd
    name
    email
    emailAuthSub
    username
    usernameAuthSub
    createdAt
    updatedAt
    updatedBy
    staffs {
      id
      name
      email
      isEnabledGuidetour
      createdAt
      updatedAt
    }
  }
}
    `;
export const FindFirstCustomerByUserAuthSubDocument = gql`
    query findFirstCustomerByUserAuthSub($where: CustomerWhereInput) {
  findFirstCustomer(where: $where) {
    id
    customerCd
    name
    email
    emailAuthSub
    username
    usernameAuthSub
    createdAt
    updatedAt
    updatedBy
    staffs {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
      customer {
        name
        id
      }
    }
  }
}
    `;
export const CustomerOrderNosDocument = gql`
    query customerOrderNos($where: OrderRequestDetailWhereInput, $orderBy: [OrderRequestDetailOrderByWithRelationInput!], $cursor: OrderRequestDetailWhereUniqueInput, $take: Int, $skip: Int) {
  orderRequestDetails(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: customerOrderNo
  ) {
    customerOrderNo
  }
}
    `;
export const DiametersDocument = gql`
    query diameters($where: StockItemWhereInput, $orderBy: [StockItemOrderByWithRelationInput!], $cursor: StockItemWhereUniqueInput, $take: Int, $skip: Int) {
  stockItems(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: diameter
  ) {
    diameter
    diameterCd
  }
}
    `;
export const ItemsDocument = gql`
    query items($where: ItemWhereInput, $orderBy: [ItemOrderByWithRelationInput!], $cursor: ItemWhereUniqueInput, $take: Int, $skip: Int) {
  items(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    itemCd
    largeCd
    middleCd
    smallCd
    shortCd
    name
    description
    stockLocationCd
    disabled
    imageUrl
    createdAt
    updatedAt
    updatedBy
  }
}
    `;
export const CountItemsDocument = gql`
    query countItems($where: ItemWhereInput, $orderBy: [ItemOrderByWithRelationInput!], $cursor: ItemWhereUniqueInput, $take: Int, $skip: Int) {
  aggregateItem(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    _count {
      _all
    }
  }
}
    `;
export const FindFirstItemDocument = gql`
    query findFirstItem($where: ItemWhereInput) {
  findFirstItem(where: $where) {
    id
    itemCd
    largeCd
    middleCd
    smallCd
    shortCd
    name
    description
    stockLocationCd
    disabled
    imageUrl
    createdAt
    updatedAt
    updatedBy
    largeCategory {
      id
      largeCd
      seq
      name
      createdAt
      updatedAt
      updatedBy
    }
    middleCategory {
      id
      largeCd
      middleCd
      seq
      name
      createdAt
      updatedAt
      updatedBy
    }
    smallCategory {
      id
      smallCd
      seq
      name
      createdAt
      updatedAt
      updatedBy
    }
  }
}
    `;
export const LengthsDocument = gql`
    query lengths($where: StockItemWhereInput, $orderBy: [StockItemOrderByWithRelationInput!], $cursor: StockItemWhereUniqueInput, $take: Int, $skip: Int) {
  stockItems(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: length
  ) {
    length
    lengthCd
  }
}
    `;
export const OrdersDocument = gql`
    query orders($where: OrderWhereInput, $orderBy: [OrderOrderByWithRelationInput!], $cursor: OrderWhereUniqueInput, $take: Int, $skip: Int, $distinct: [OrderScalarFieldEnum!]) {
  orders(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    orderRequestId
    customerCd
    customerName
    customerId
    staffId
    customerChargeName
    billingName
    billingNameKana
    billingPostalCode
    billingPrefecture
    billingAddress
    billingPhoneNumber
    billingChargeName
    deliveryName
    deliveryNameKana
    deliveryPostalCode
    deliveryPrefecture
    deliveryAddress
    deliveryPhoneNumber
    deliveryChargeName
    minimumOrderAmount
    isSameDayDelivery
    deliveryDate
    orderRequestDate
    orderCompleteDate
    orderCompleteParsonName
    orderCompleteType
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    details(orderBy: [{orderLineNo: asc}]) {
      id
      orderId
      stockItemUnitPriceId
      stockItemId
      orderRequestDetailId
      itemCd
      shortCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      requestLineNo
      requestUnitPrice
      requestQuantity
      requestTotalQuantity
      requestAmount
      requestPacking
      orderLineNo
      unitPrice
      quantity
      totalQuantity
      amount
      packing
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      customerOrderNo
      customerNote
      packingStyle
      createdAt
      updatedAt
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          name
        }
      }
      stockItemUnitPrice {
        id
        customerId
        stockItemId
        customerCd
        itemCd
        sizeCd
        costPrice
        unitPriceParCase
        unitPriceParPack
        unitPrice
        costRateOfCase
        costRateOfPack
        costRate
        createdAt
        updatedAt
        updatedBy
        stockItem {
          id
          itemId
          itemCd
          sizeCd
          sizeName
          quantityParCase
          quantityParPack
          costPrice
          diameter
          length
          diameterCd
          lengthCd
          stockQuantityYao
          stockQuantityHigashi
          totalStockQuantity
          stockQuantitySymbol
          roughStockQuantity
          createdAt
          updatedAt
          updatedBy
          item {
            name
          }
        }
      }
    }
  }
}
    `;
export const FindFirstOrderDocument = gql`
    query findFirstOrder($where: OrderWhereInput) {
  findFirstOrder(where: $where) {
    id
    orderRequestId
    customerCd
    customerName
    customerId
    staffId
    customerChargeName
    billingName
    billingNameKana
    billingPostalCode
    billingPrefecture
    billingAddress
    billingPhoneNumber
    billingChargeName
    deliveryName
    deliveryNameKana
    deliveryPostalCode
    deliveryPrefecture
    deliveryAddress
    deliveryPhoneNumber
    deliveryChargeName
    minimumOrderAmount
    isSameDayDelivery
    deliveryDate
    orderRequestDate
    orderCompleteDate
    orderCompleteParsonName
    orderCompleteType
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    details(orderBy: [{orderLineNo: asc}]) {
      id
      orderId
      stockItemUnitPriceId
      stockItemId
      orderRequestDetailId
      itemCd
      shortCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      requestLineNo
      requestUnitPrice
      requestQuantity
      requestTotalQuantity
      requestAmount
      requestPacking
      orderLineNo
      unitPrice
      quantity
      totalQuantity
      amount
      packing
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      customerOrderNo
      customerNote
      packingStyle
      createdAt
      updatedAt
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          id
          itemCd
          shortCd
          largeCd
          middleCd
          smallCd
          shortCd
          name
          description
          stockLocationCd
          disabled
          createdAt
          updatedAt
          updatedBy
        }
      }
      stockItemUnitPrice {
        id
        customerId
        stockItemId
        customerCd
        itemCd
        sizeCd
        costPrice
        unitPriceParCase
        unitPriceParPack
        unitPrice
        costRateOfCase
        costRateOfPack
        costRate
        createdAt
        updatedAt
        updatedBy
        stockItem {
          id
          itemId
          itemCd
          sizeCd
          sizeName
          quantityParCase
          quantityParPack
          costPrice
          diameter
          length
          diameterCd
          lengthCd
          stockQuantityYao
          stockQuantityHigashi
          totalStockQuantity
          stockQuantitySymbol
          roughStockQuantity
          createdAt
          updatedAt
          updatedBy
          item {
            id
            itemCd
            shortCd
            largeCd
            middleCd
            smallCd
            shortCd
            name
            description
            stockLocationCd
            disabled
            createdAt
            updatedAt
            updatedBy
          }
        }
      }
    }
  }
}
    `;
export const CreateOneOrderRequestDocument = gql`
    mutation createOneOrderRequest($data: OrderRequestCreateInput!) {
  createOneOrderRequest(data: $data) {
    id
    customerCd
    customerName
    customerId
    staffId
    customerChargeName
    billingName
    billingNameKana
    billingPostalCode
    billingPrefecture
    billingAddress
    billingPhoneNumber
    billingChargeName
    deliveryName
    deliveryNameKana
    deliveryPostalCode
    deliveryPrefecture
    deliveryAddress
    deliveryPhoneNumber
    deliveryChargeName
    minimumOrderAmount
    isSameDayDelivery
    deliveryDate
    orderRequestDate
    canceledAt
    syncedAt
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    details(orderBy: [{requestLineNo: asc}]) {
      id
      orderRequestId
      stockItemUnitPriceId
      stockItemId
      itemCd
      shortCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      requestLineNo
      unitPrice
      quantity
      totalQuantity
      amount
      packing
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      customerOrderNo
      customerNote
      packingStyle
      createdAt
      updatedAt
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          name
        }
      }
      stockItemUnitPrice {
        id
        customerId
        stockItemId
        customerCd
        itemCd
        sizeCd
        costPrice
        unitPriceParCase
        unitPriceParPack
        unitPrice
        costRateOfCase
        costRateOfPack
        costRate
        createdAt
        updatedAt
        updatedBy
        stockItem {
          id
          itemId
          itemCd
          sizeCd
          sizeName
          quantityParCase
          quantityParPack
          costPrice
          diameter
          length
          diameterCd
          lengthCd
          stockQuantityYao
          stockQuantityHigashi
          totalStockQuantity
          stockQuantitySymbol
          roughStockQuantity
          createdAt
          updatedAt
          updatedBy
          item {
            id
            itemCd
            shortCd
            largeCd
            middleCd
            smallCd
            shortCd
            name
            description
            stockLocationCd
            disabled
            createdAt
            updatedAt
            updatedBy
          }
        }
      }
    }
  }
}
    `;
export const OrderRequestsDocument = gql`
    query orderRequests($where: OrderRequestWhereInput, $orderBy: [OrderRequestOrderByWithRelationInput!], $cursor: OrderRequestWhereUniqueInput, $take: Int, $skip: Int) {
  orderRequests(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    customerCd
    customerName
    customerId
    staffId
    customerChargeName
    billingName
    billingNameKana
    billingPostalCode
    billingPrefecture
    billingAddress
    billingPhoneNumber
    billingChargeName
    deliveryName
    deliveryNameKana
    deliveryPostalCode
    deliveryPrefecture
    deliveryAddress
    deliveryPhoneNumber
    deliveryChargeName
    minimumOrderAmount
    isSameDayDelivery
    deliveryDate
    orderRequestDate
    canceledAt
    syncedAt
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    details(orderBy: [{requestLineNo: asc}]) {
      id
      orderRequestId
      stockItemUnitPriceId
      stockItemId
      itemCd
      shortCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      requestLineNo
      unitPrice
      quantity
      totalQuantity
      amount
      packing
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      customerOrderNo
      customerNote
      packingStyle
      createdAt
      updatedAt
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          name
        }
      }
      stockItemUnitPrice {
        id
        customerId
        stockItemId
        customerCd
        itemCd
        sizeCd
        costPrice
        unitPriceParCase
        unitPriceParPack
        unitPrice
        costRateOfCase
        costRateOfPack
        costRate
        createdAt
        updatedAt
        updatedBy
        stockItem {
          id
          itemId
          itemCd
          sizeCd
          sizeName
          quantityParCase
          quantityParPack
          costPrice
          diameter
          length
          diameterCd
          lengthCd
          stockQuantityYao
          stockQuantityHigashi
          totalStockQuantity
          stockQuantitySymbol
          roughStockQuantity
          createdAt
          updatedAt
          updatedBy
          item {
            id
            itemCd
            shortCd
            largeCd
            middleCd
            smallCd
            shortCd
            name
            description
            stockLocationCd
            disabled
            createdAt
            updatedAt
            updatedBy
          }
        }
      }
    }
  }
}
    `;
export const FindFirstOrderRequestDocument = gql`
    query findFirstOrderRequest($where: OrderRequestWhereInput) {
  findFirstOrderRequest(where: $where) {
    id
    customerCd
    customerName
    customerId
    staffId
    customerChargeName
    billingName
    billingNameKana
    billingPostalCode
    billingPrefecture
    billingAddress
    billingPhoneNumber
    billingChargeName
    deliveryName
    deliveryNameKana
    deliveryPostalCode
    deliveryPrefecture
    deliveryAddress
    deliveryPhoneNumber
    deliveryChargeName
    minimumOrderAmount
    isSameDayDelivery
    deliveryDate
    orderRequestDate
    canceledAt
    syncedAt
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    details(orderBy: [{requestLineNo: asc}]) {
      id
      orderRequestId
      stockItemUnitPriceId
      stockItemId
      itemCd
      shortCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      requestLineNo
      unitPrice
      quantity
      totalQuantity
      amount
      packing
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      customerOrderNo
      customerNote
      packingStyle
      createdAt
      updatedAt
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          name
        }
      }
      stockItemUnitPrice {
        id
        customerId
        stockItemId
        customerCd
        itemCd
        sizeCd
        costPrice
        unitPriceParCase
        unitPriceParPack
        unitPrice
        costRateOfCase
        costRateOfPack
        costRate
        createdAt
        updatedAt
        updatedBy
        stockItem {
          id
          itemId
          itemCd
          sizeCd
          sizeName
          quantityParCase
          quantityParPack
          costPrice
          diameter
          length
          diameterCd
          lengthCd
          stockQuantityYao
          stockQuantityHigashi
          totalStockQuantity
          stockQuantitySymbol
          roughStockQuantity
          createdAt
          updatedAt
          updatedBy
          item {
            id
            itemCd
            shortCd
            largeCd
            middleCd
            smallCd
            shortCd
            name
            description
            stockLocationCd
            disabled
            createdAt
            updatedAt
            updatedBy
          }
        }
      }
    }
  }
}
    `;
export const SendOrderRequestDocument = gql`
    mutation sendOrderRequest($mailAddress: String!, $orderRequestNo: Int!, $customerName: String!, $staffName: String!, $orderDate: String!, $itemQuantity: String!, $totalAmount: String!, $details: [SendOrderRequestDetailInput!]!) {
  sendOrderRequest(
    customerName: $customerName
    staffName: $staffName
    orderDate: $orderDate
    itemQuantity: $itemQuantity
    totalAmount: $totalAmount
    mailAddress: $mailAddress
    orderRequestNo: $orderRequestNo
    details: $details
  ) {
    message
  }
}
    `;
export const SendVerificationCodeDocument = gql`
    mutation sendVerificationCode($email: String!) {
  sendVerificationCode(email: $email) {
    message
  }
}
    `;
export const FindManyStaffDocument = gql`
    query findManyStaff($where: StaffWhereInput, $orderBy: [StaffOrderByWithRelationInput!], $cursor: StaffWhereUniqueInput, $take: Int, $skip: Int) {
  findManyStaff(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    customerId
    name
    email
    isEnabledGuidetour
    createdAt
    updatedAt
  }
}
    `;
export const CreateOneStaffDocument = gql`
    mutation createOneStaff($data: StaffCreateInput!) {
  createOneStaff(data: $data) {
    id
    customerId
    name
    isEnabledGuidetour
    createdAt
    updatedAt
  }
}
    `;
export const UpdateOneStaffDocument = gql`
    mutation updateOneStaff($data: StaffUpdateInput!, $where: StaffWhereUniqueInput!) {
  updateOneStaff(data: $data, where: $where) {
    id
    customerId
    name
    email
    isEnabledGuidetour
    createdAt
    updatedAt
  }
}
    `;
export const DeleteOneStaffDocument = gql`
    mutation deleteOneStaff($where: StaffWhereUniqueInput!) {
  deleteOneStaff(where: $where) {
    id
    customerId
    name
    isEnabledGuidetour
    createdAt
    updatedAt
  }
}
    `;
export const StockItemsDocument = gql`
    query stockItems($where: StockItemWhereInput, $orderBy: [StockItemOrderByWithRelationInput!], $cursor: StockItemWhereUniqueInput, $take: Int, $skip: Int) {
  stockItems(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    id
    itemId
    itemCd
    sizeCd
    sizeName
    quantityParCase
    quantityParPack
    costPrice
    diameter
    length
    diameterCd
    lengthCd
    stockQuantityYao
    stockQuantityHigashi
    totalStockQuantity
    stockQuantitySymbol
    roughStockQuantity
    createdAt
    updatedAt
    updatedBy
    stockItemUnitPrices {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
      cartItem {
        id
        customerId
        staffId
        stockItemUnitPriceId
        stockItemId
        itemCd
        name
        sizeCd
        sizeName
        diameter
        length
        diameterCd
        lengthCd
        unitPrice
        quantity
        amount
        quantityParCaseOfStockItem
        quantityParPackOfStockItem
        costPriceOfStockItemUnitPrice
        unitPriceParCaseOfStockItemUnitPrice
        unitPriceParPackOfStockItemUnitPrice
        unitPriceOfStockItemUnitPrice
        costRateOfCaseOfStockItemUnitPrice
        costRateOfPackOfStockItemUnitPrice
        costRateOfStockItemUnitPrice
        customerOrderNo
        customerNote
        packingStyle
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export const AggregateStockItemDocument = gql`
    query aggregateStockItem {
  aggregateStockItem {
    _max {
      updatedAt
    }
  }
}
    `;
export const StockItemUnitPricesDocument = gql`
    query stockItemUnitPrices($where: StockItemUnitPriceWhereInput, $orderBy: [StockItemUnitPriceOrderByWithRelationInput!], $cursor: StockItemUnitPriceWhereUniqueInput, $take: Int, $skip: Int, $distinct: [StockItemUnitPriceScalarFieldEnum!]) {
  stockItemUnitPrices(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    customerId
    stockItemId
    customerCd
    itemCd
    sizeCd
    costPrice
    unitPriceParCase
    unitPriceParPack
    unitPrice
    costRateOfCase
    costRateOfPack
    costRate
    createdAt
    updatedAt
    updatedBy
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
      item {
        id
        itemCd
        largeCd
        middleCd
        smallCd
        shortCd
        name
        description
        stockLocationCd
        disabled
        createdAt
        updatedAt
        updatedBy
      }
    }
    cartItem {
      id
      customerId
      staffId
      stockItemUnitPriceId
      stockItemId
      itemCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      unitPrice
      quantity
      amount
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      customerOrderNo
      customerNote
      packingStyle
      createdAt
      updatedAt
    }
    wishlistItem {
      id
      customerId
      staffId
      stockItemUnitPriceId
      stockItemId
      itemCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      createdAt
      updatedAt
    }
  }
}
    `;
export const FindFirstStockItemUnitPriceDocument = gql`
    query findFirstStockItemUnitPrice($where: StockItemUnitPriceWhereInput, $orderBy: [StockItemUnitPriceOrderByWithRelationInput!], $cursor: StockItemUnitPriceWhereUniqueInput, $take: Int, $skip: Int, $distinct: [StockItemUnitPriceScalarFieldEnum!]) {
  findFirstStockItemUnitPrice(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    customerId
    stockItemId
    customerCd
    itemCd
    sizeCd
    costPrice
    unitPriceParCase
    unitPriceParPack
    unitPrice
    costRateOfCase
    costRateOfPack
    costRate
    createdAt
    updatedAt
    updatedBy
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
      item {
        id
        itemCd
        largeCd
        middleCd
        smallCd
        shortCd
        name
        description
        stockLocationCd
        disabled
        createdAt
        updatedAt
        updatedBy
      }
    }
    cartItem {
      id
      customerId
      staffId
      stockItemUnitPriceId
      stockItemId
      itemCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      unitPrice
      quantity
      amount
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      customerOrderNo
      customerNote
      createdAt
      updatedAt
    }
    wishlistItem {
      id
      customerId
      staffId
      stockItemUnitPriceId
      stockItemId
      itemCd
      name
      sizeCd
      sizeName
      diameter
      length
      diameterCd
      lengthCd
      quantityParCaseOfStockItem
      quantityParPackOfStockItem
      costPriceOfStockItemUnitPrice
      unitPriceParCaseOfStockItemUnitPrice
      unitPriceParPackOfStockItemUnitPrice
      unitPriceOfStockItemUnitPrice
      costRateOfCaseOfStockItemUnitPrice
      costRateOfPackOfStockItemUnitPrice
      costRateOfStockItemUnitPrice
      createdAt
      updatedAt
    }
  }
}
    `;
export const FindFirstSystemSettingDocument = gql`
    query findFirstSystemSetting($where: SystemSettingWhereInput, $orderBy: [SystemSettingOrderByWithRelationInput!], $cursor: SystemSettingWhereUniqueInput, $take: Int, $skip: Int) {
  findFirstSystemSetting(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    key
    value
    createdAt
    updatedAt
    updatedBy
  }
}
    `;
export const FindFirstWishlistItemDocument = gql`
    query findFirstWishlistItem($where: WishlistItemWhereInput, $orderBy: [WishlistItemOrderByWithRelationInput!], $cursor: WishlistItemWhereUniqueInput, $take: Int, $skip: Int, $distinct: [WishlistItemScalarFieldEnum!]) {
  findFirstWishlistItem(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          id
          itemCd
          shortCd
          largeCd
          middleCd
          smallCd
          shortCd
          name
          description
          stockLocationCd
          disabled
          createdAt
          updatedAt
          updatedBy
        }
      }
    }
  }
}
    `;
export const CountWishlistItemsDocument = gql`
    query countWishlistItems($where: WishlistItemWhereInput, $orderBy: [WishlistItemOrderByWithRelationInput!], $cursor: WishlistItemWhereUniqueInput, $take: Int, $skip: Int) {
  aggregateWishlistItem(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
  ) {
    _count {
      _all
    }
  }
}
    `;
export const CreateOneWishlistItemDocument = gql`
    mutation createOneWishlistItem($data: WishlistItemCreateInput!) {
  createOneWishlistItem(data: $data) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    diameterCd
    lengthCd
    length
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          id
          itemCd
          shortCd
          largeCd
          middleCd
          smallCd
          shortCd
          name
          description
          stockLocationCd
          disabled
          createdAt
          updatedAt
          updatedBy
        }
      }
    }
  }
}
    `;
export const WishlistItemsDocument = gql`
    query wishlistItems($where: WishlistItemWhereInput, $orderBy: [WishlistItemOrderByWithRelationInput!], $cursor: WishlistItemWhereUniqueInput, $take: Int, $skip: Int, $distinct: [WishlistItemScalarFieldEnum!]) {
  wishlistItems(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          id
          itemCd
          shortCd
          largeCd
          middleCd
          smallCd
          shortCd
          name
          description
          stockLocationCd
          disabled
          createdAt
          updatedAt
          updatedBy
        }
      }
    }
  }
}
    `;
export const UpdateOneWishlistItemDocument = gql`
    mutation updateOneWishlistItem($data: WishlistItemUpdateInput!, $where: WishlistItemWhereUniqueInput!) {
  updateOneWishlistItem(data: $data, where: $where) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    createdAt
    updatedAt
    customer {
      id
      customerCd
      name
      email
      emailAuthSub
      username
      usernameAuthSub
      createdAt
      updatedAt
      updatedBy
    }
    staff {
      id
      customerId
      name
      isEnabledGuidetour
      createdAt
      updatedAt
    }
    stockItem {
      id
      itemId
      itemCd
      sizeCd
      sizeName
      quantityParCase
      quantityParPack
      costPrice
      diameter
      length
      diameterCd
      lengthCd
      stockQuantityYao
      stockQuantityHigashi
      totalStockQuantity
      stockQuantitySymbol
      roughStockQuantity
      createdAt
      updatedAt
      updatedBy
    }
    stockItemUnitPrice {
      id
      customerId
      stockItemId
      customerCd
      itemCd
      sizeCd
      costPrice
      unitPriceParCase
      unitPriceParPack
      unitPrice
      costRateOfCase
      costRateOfPack
      costRate
      createdAt
      updatedAt
      updatedBy
      stockItem {
        id
        itemId
        itemCd
        sizeCd
        sizeName
        quantityParCase
        quantityParPack
        costPrice
        diameter
        length
        diameterCd
        lengthCd
        stockQuantityYao
        stockQuantityHigashi
        totalStockQuantity
        stockQuantitySymbol
        roughStockQuantity
        createdAt
        updatedAt
        updatedBy
        item {
          id
          itemCd
          shortCd
          largeCd
          middleCd
          smallCd
          shortCd
          name
          description
          stockLocationCd
          disabled
          createdAt
          updatedAt
          updatedBy
        }
      }
    }
  }
}
    `;
export const DeleteOneWishlistItemDocument = gql`
    mutation deleteOneWishlistItem($where: WishlistItemWhereUniqueInput!) {
  deleteOneWishlistItem(where: $where) {
    id
    customerId
    staffId
    stockItemUnitPriceId
    stockItemId
    itemCd
    shortCd
    name
    sizeCd
    sizeName
    diameter
    length
    diameterCd
    lengthCd
    quantityParCaseOfStockItem
    quantityParPackOfStockItem
    costPriceOfStockItemUnitPrice
    unitPriceParCaseOfStockItemUnitPrice
    unitPriceParPackOfStockItemUnitPrice
    unitPriceOfStockItemUnitPrice
    costRateOfCaseOfStockItemUnitPrice
    costRateOfPackOfStockItemUnitPrice
    costRateOfStockItemUnitPrice
    selected
    createdAt
    updatedAt
  }
}
    `;
export const DeleteManyWishlistItemDocument = gql`
    mutation deleteManyWishlistItem($where: WishlistItemWhereInput) {
  deleteManyWishlistItem(where: $where) {
    count
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    announces(variables?: AnnouncesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AnnouncesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AnnouncesQuery>(AnnouncesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'announces', 'query');
    },
    findFirstCartItem(variables?: FindFirstCartItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstCartItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstCartItemQuery>(FindFirstCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstCartItem', 'query');
    },
    countCartItems(variables?: CountCartItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CountCartItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountCartItemsQuery>(CountCartItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'countCartItems', 'query');
    },
    createOneCartItem(variables: CreateOneCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOneCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneCartItemMutation>(CreateOneCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneCartItem', 'mutation');
    },
    cartItems(variables?: CartItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CartItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CartItemsQuery>(CartItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'cartItems', 'query');
    },
    updateOneCartItem(variables: UpdateOneCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOneCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOneCartItemMutation>(UpdateOneCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOneCartItem', 'mutation');
    },
    deleteOneCartItem(variables: DeleteOneCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOneCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOneCartItemMutation>(DeleteOneCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOneCartItem', 'mutation');
    },
    deleteManyCartItem(variables?: DeleteManyCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteManyCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteManyCartItemMutation>(DeleteManyCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteManyCartItem', 'mutation');
    },
    largeCategories(variables?: LargeCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LargeCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LargeCategoriesQuery>(LargeCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'largeCategories', 'query');
    },
    middleCategories(variables?: MiddleCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<MiddleCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<MiddleCategoriesQuery>(MiddleCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'middleCategories', 'query');
    },
    smallCategories(variables?: SmallCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SmallCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SmallCategoriesQuery>(SmallCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'smallCategories', 'query');
    },
    codeVerify(variables: CodeVerifyMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CodeVerifyMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CodeVerifyMutation>(CodeVerifyDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'codeVerify', 'mutation');
    },
    findFirstCustomer(variables?: FindFirstCustomerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstCustomerQuery>(FindFirstCustomerDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstCustomer', 'query');
    },
    findFirstCustomerByUserAuthSub(variables?: FindFirstCustomerByUserAuthSubQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstCustomerByUserAuthSubQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstCustomerByUserAuthSubQuery>(FindFirstCustomerByUserAuthSubDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstCustomerByUserAuthSub', 'query');
    },
    customerOrderNos(variables?: CustomerOrderNosQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CustomerOrderNosQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CustomerOrderNosQuery>(CustomerOrderNosDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'customerOrderNos', 'query');
    },
    diameters(variables?: DiametersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DiametersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DiametersQuery>(DiametersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'diameters', 'query');
    },
    items(variables?: ItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ItemsQuery>(ItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'items', 'query');
    },
    countItems(variables?: CountItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CountItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountItemsQuery>(CountItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'countItems', 'query');
    },
    findFirstItem(variables?: FindFirstItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstItemQuery>(FindFirstItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstItem', 'query');
    },
    lengths(variables?: LengthsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LengthsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LengthsQuery>(LengthsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lengths', 'query');
    },
    orders(variables?: OrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersQuery>(OrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orders', 'query');
    },
    findFirstOrder(variables?: FindFirstOrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstOrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstOrderQuery>(FindFirstOrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstOrder', 'query');
    },
    createOneOrderRequest(variables: CreateOneOrderRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOneOrderRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneOrderRequestMutation>(CreateOneOrderRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneOrderRequest', 'mutation');
    },
    orderRequests(variables?: OrderRequestsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderRequestsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderRequestsQuery>(OrderRequestsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderRequests', 'query');
    },
    findFirstOrderRequest(variables?: FindFirstOrderRequestQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstOrderRequestQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstOrderRequestQuery>(FindFirstOrderRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstOrderRequest', 'query');
    },
    sendOrderRequest(variables: SendOrderRequestMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendOrderRequestMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendOrderRequestMutation>(SendOrderRequestDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendOrderRequest', 'mutation');
    },
    sendVerificationCode(variables: SendVerificationCodeMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SendVerificationCodeMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<SendVerificationCodeMutation>(SendVerificationCodeDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'sendVerificationCode', 'mutation');
    },
    findManyStaff(variables?: FindManyStaffQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindManyStaffQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindManyStaffQuery>(FindManyStaffDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findManyStaff', 'query');
    },
    createOneStaff(variables: CreateOneStaffMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOneStaffMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneStaffMutation>(CreateOneStaffDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneStaff', 'mutation');
    },
    updateOneStaff(variables: UpdateOneStaffMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOneStaffMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOneStaffMutation>(UpdateOneStaffDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOneStaff', 'mutation');
    },
    deleteOneStaff(variables: DeleteOneStaffMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOneStaffMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOneStaffMutation>(DeleteOneStaffDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOneStaff', 'mutation');
    },
    stockItems(variables?: StockItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StockItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StockItemsQuery>(StockItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stockItems', 'query');
    },
    aggregateStockItem(variables?: AggregateStockItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AggregateStockItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AggregateStockItemQuery>(AggregateStockItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'aggregateStockItem', 'query');
    },
    stockItemUnitPrices(variables?: StockItemUnitPricesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<StockItemUnitPricesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<StockItemUnitPricesQuery>(StockItemUnitPricesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stockItemUnitPrices', 'query');
    },
    findFirstStockItemUnitPrice(variables?: FindFirstStockItemUnitPriceQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstStockItemUnitPriceQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstStockItemUnitPriceQuery>(FindFirstStockItemUnitPriceDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstStockItemUnitPrice', 'query');
    },
    findFirstSystemSetting(variables?: FindFirstSystemSettingQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstSystemSettingQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstSystemSettingQuery>(FindFirstSystemSettingDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstSystemSetting', 'query');
    },
    findFirstWishlistItem(variables?: FindFirstWishlistItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FindFirstWishlistItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FindFirstWishlistItemQuery>(FindFirstWishlistItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'findFirstWishlistItem', 'query');
    },
    countWishlistItems(variables?: CountWishlistItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CountWishlistItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CountWishlistItemsQuery>(CountWishlistItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'countWishlistItems', 'query');
    },
    createOneWishlistItem(variables: CreateOneWishlistItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateOneWishlistItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateOneWishlistItemMutation>(CreateOneWishlistItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createOneWishlistItem', 'mutation');
    },
    wishlistItems(variables?: WishlistItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<WishlistItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<WishlistItemsQuery>(WishlistItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'wishlistItems', 'query');
    },
    updateOneWishlistItem(variables: UpdateOneWishlistItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateOneWishlistItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateOneWishlistItemMutation>(UpdateOneWishlistItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateOneWishlistItem', 'mutation');
    },
    deleteOneWishlistItem(variables: DeleteOneWishlistItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteOneWishlistItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteOneWishlistItemMutation>(DeleteOneWishlistItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteOneWishlistItem', 'mutation');
    },
    deleteManyWishlistItem(variables?: DeleteManyWishlistItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteManyWishlistItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteManyWishlistItemMutation>(DeleteManyWishlistItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteManyWishlistItem', 'mutation');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;